{
  "imageUpload": {
    "preparing": "Préparation de l'image…",
    "uploading": "Envoi de l'image…",
    "retrying": "Nouvel essai de l'envoi…",
    "failed": "Impossible d'envoyer l'image",
    "failedTooLarge": "L'image est trop volumineuse",
    "failedUnsupported": "Format d'image non pris en charge",
    "failedNetwork": "Connexion au serveur impossible",
    "failedPrepare": "Impossible de traiter l'image",
    "retry": "Réessayer",
    "pendingWarning": "{{count}} image(s) n'existent que dans ce navigateur et n'ont pas été enregistrées sur le serveur. Elles seront perdues si vous fermez ou rechargez la page."
  },
  "super": {
    "title": "Administration",
    "issuesTitle": "Signalements et idées",
    "issuesSubtitle": "Consultez les incidents et suggestions envoyés par les utilisateurs",
    "brandsTab": "Marques",
    "brandsTitle": "Marques et distributeurs",
    "brandsSubtitle": "Qui nous amène chaque client et ce qu'il voit en se connectant",
    "packagesTab": "Forfaits",
    "packagesTitle": "Forfaits de fonctionnalités",
    "packagesSubtitle": "Ce que comprend chaque forfait et combien de comptes rendus par mois"
  },
  "packages": {
    "modalSubtitle": "Définissez l'enveloppe de comptes rendus et les fonctionnalités incluses.",
    "create": "Créer le forfait",
    "optional": "Facultatif",
    "activeLabel": "Forfait actif",
    "informesPerMonth": "Comptes rendus / mois",
    "informesPlaceholder": "p. ex. 500",
    "plazoLabel": "Délai du lot",
    "days": "jours",
    "overageTitle": "Quand l'enveloppe est épuisée",
    "policyOption": {
      "charge": "Facturer en sus",
      "block": "Bloquer l'IA"
    },
    "policyHint": {
      "charge": "Chaque compte rendu au-delà de l'enveloppe est facturé à part.",
      "block": "Une fois l'enveloppe épuisée, l'IA s'arrête jusqu'au mois suivant."
    },
    "priceLabel": "Prix par compte rendu supplémentaire",
    "capPlaceholder": "Sans plafond",
    "capHint": "Vide = sans limite.",
    "selectedCount_one": "{{count}} sélectionnée",
    "selectedCount_other": "{{count}} sélectionnées",
    "requestFeaturesHint": "Consomment des itérations",
    "toggleFeaturesHint": "Ne consomment pas d’itérations",
    "imagingWarningRich": "Sans <strong>Modalité d'imagerie</strong>, l'enregistrement ne classe pas la modalité et la facturation par modalité de ces comptes sera vide.",
    "section": {
      "identity": "Identification",
      "pool": "Enveloppe mensuelle",
      "overage": "Dépassement",
      "features": "Fonctionnalités"
    },
    "pool": {
      "unlimited": "Rapports illimités : ni enveloppe ni dépassement.",
      "empty": "Indiquez les rapports et les itérations pour voir l’enveloppe.",
      "suffix": "itérations par mois"
    },
    "title": "Forfaits",
    "hint": "Chaque forfait fixe les fonctionnalités d'un établissement et les comptes rendus mensuels inclus (1 compte rendu = 3 itérations). Un compte sans forfait attribué a tout gratuitement.",
    "new": "Nouveau forfait",
    "newTitle": "Nouveau forfait",
    "editTitle": "Modifier le forfait",
    "edit": "Modifier",
    "empty": "Aucun forfait pour l'instant.",
    "loading": "Chargement des forfaits…",
    "loadError": "Impossible de charger les forfaits. Réessayez.",
    "retry": "Réessayer",
    "key": "Clé",
    "keyHint": "Minuscules, chiffres, - et _. Non modifiable.",
    "name": "Nom",
    "description": "Description",
    "status": "Statut",
    "active": "Actif",
    "inactive": "Inactif",
    "activeHint": "Un forfait inactif ne peut pas être attribué à de nouveaux comptes ; ceux qui l'ont déjà le conservent.",
    "informes": "Comptes rendus/mois",
    "informesHint": "Enveloppe de l'établissement. Elle expire à la clôture du mois.",
    "unlimited": "Illimité",
    "iteraciones": "Itérations par compte rendu",
    "plazo": "Délai du lot (jours)",
    "overage": "Dépassement",
    "overageHint": "Facturer : chaque compte rendu supplémentaire est facturé. Bloquer : l'IA s'arrête quand l'enveloppe est épuisée.",
    "price": "Prix par compte rendu supplémentaire (€)",
    "cap": "Plafond de comptes rendus supplémentaires",
    "features": "Fonctionnalités",
    "requestFeatures": "Requêtes d'IA",
    "toggleFeatures": "Activables",
    "imagingWarning": "Sans « Modalité d'imagerie », l'enregistrement ne classe pas la modalité et la facturation par modalité de ces comptes sera vide.",
    "policy": {
      "charge": "Facturer",
      "block": "Bloquer"
    },
    "created": "Forfait créé.",
    "updated": "Forfait mis à jour.",
    "saveError": "Impossible d'enregistrer le forfait.",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "errors": {
      "key": "Clé invalide : 2 à 40 caractères en minuscules, chiffres, - ou _.",
      "name": "Le nom est obligatoire.",
      "informes": "Indiquez un nombre entier de comptes rendus ou cochez « Illimité ».",
      "iteraciones": "Entre 1 et 100.",
      "plazo": "Entre 1 et 365 jours.",
      "price": "Prix invalide.",
      "cap": "Nombre entier invalide."
    },
    "feature": {
      "magic_dictation": "Dictée magique",
      "magic_writing": "Écriture magique",
      "direct_generation": "Génération directe",
      "traditional_dictation": "Dictée traditionnelle",
      "classification": "Classification",
      "patient_summary": "Résumé du patient",
      "presave_check": "Vérification avant enregistrement",
      "few_shot": "Exemples (few-shot)",
      "snomed": "SNOMED",
      "anatomic_regions": "Régions anatomiques",
      "imaging_modality": "Modalité d'imagerie",
      "faq": "Assistant d'aide",
      "template_import": "Import de modèles",
      "template_name_variants": "Variantes de nom de modèle",
      "batch_dictation": "Dictée par lots"
    }
  },
  "subscription": {
    "title": "Forfait et facturation",
    "none": "Sans forfait : le compte a toutes les fonctionnalités gratuitement et sa consommation n'est pas mesurée.",
    "future": "Forfait « {{name}} » à partir du {{date}}. D'ici là, tout est gratuit.",
    "inForce": "Forfait « {{name}} » en vigueur depuis le {{date}}. Le cycle commence le {{day}} de chaque mois ({{tz}}).",
    "loadError": "Impossible de charger le forfait du compte.",
    "package": "Forfait",
    "choose": "— Choisissez un forfait —",
    "reportsPerMonth": "comptes rendus/mois",
    "startsAt": "Début du cycle de facturation",
    "startsAtHint": "Vide = maintenant. Avant cette date, le compte garde tout gratuitement.",
    "startsAtInForceHint": "Si vous ne modifiez pas la date, le nouveau forfait s'applique d?s maintenant et le jour de facturation est conserv?.",
    "anchorDay": "Jour de clôture",
    "anchorDayPlaceholder": "jour de début",
    "anchorDayHint": "1–31. Vide = le jour du début. Les mois plus courts utilisent leur dernier jour.",
    "timezone": "Fuseau horaire",
    "enforcement": "Mode",
    "enforcementHint": "Observation : mesuré mais non bloqué. Appliquer : ce qui n'est pas dans le forfait est bloqué.",
    "mode": {
      "shadow": "Observation",
      "enforce": "Appliquer"
    },
    "overrides": "Exceptions de ce compte",
    "free": "Gratuit (non facturé)",
    "informesOverride": "Comptes rendus/mois (vide = ceux du forfait)",
    "overageOverride": "Dépassement",
    "overageFromPackage": "Dépassement : celui du forfait",
    "assign": "Attribuer le forfait",
    "reassign": "Changer de forfait",
    "remove": "Retirer le forfait",
    "removeConfirm": "Retirer le forfait ? Le compte aura tout gratuitement.",
    "assigned": "Forfait attribué.",
    "removed": "Forfait retiré.",
    "saveError": "Impossible d'attribuer le forfait.",
    "errors": {
      "package": "Choisissez un forfait.",
      "startsAt": "Date invalide.",
      "anchorDay": "Le jour de clôture doit être entre 1 et 31.",
      "timezone": "Indiquez le fuseau horaire.",
      "informes": "Nombre entier invalide."
    }
  },
  "radiologyStyle": {
    "title": "Votre style radiologique",
    "description": "Créez une liste de préférences décrivant comment vous aimez rédiger vos comptes rendus. Par exemple : « Je veux que tous les résultats soient en gras ».",
    "menuLabel": "Votre style radiologique",
    "settingsTitle": "Votre style radiologique",
    "settingsDescription": "Définissez comment vous aimez rédiger vos comptes rendus avec une liste de préférences personnelles",
    "settingsText": "Créez et modifiez votre liste de préférences de style. Par exemple : « Je veux que tous les résultats soient en gras ».",
    "settingsButton": "Modifier mon style",
    "empty": "Vous n'avez pas encore ajouté de préférence de style.",
    "placeholder": "Ex : Je veux que tous les résultats soient en gras",
    "addRule": "Ajouter une préférence",
    "removeRule": "Supprimer la préférence",
    "saving": "Enregistrement…",
    "saved": "Votre style radiologique a été enregistré avec succès",
    "saveError": "Impossible d'enregistrer votre style radiologique",
    "limitHint": "Jusqu'à {{maxRules}} préférences de {{maxLength}} caractères chacune.",
    "maxRulesReached": "Vous avez atteint le maximum de {{maxRules}} préférences",
    "ruleTooLong": "Une préférence dépasse {{maxLength}} caractères : raccourcissez-la pour enregistrer"
  },
  "common": {
    "welcome": "Bienvenue",
    "unknownModality": "Modalité inconnue",
    "unknownRegion": "Région inconnue",
    "professionalTitleDefault": "Dr.",
    "login": "Se connecter",
    "logout": "Déconnexion",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "view": "Voir",
    "close": "Fermer",
    "search": "Rechercher",
    "loading": "Chargement...",
    "sending": "Envoi...",
    "error": "Erreur",
    "success": "Succès",
    "email": "E-mail",
    "password": "Mot de passe",
    "submit": "Envoyer",
    "back": "Retour",
    "continue": "Continuer",
    "next": "Suivant",
    "previous": "Précédent",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "goHome": "Retour à l'accueil",
    "home": "Accueil",
    "myInsights": "Mes statistiques",
    "groupReports": "Historique de travail",
    "createReport": "Créer un rapport",
    "templates": "Modèles",
    "accounts": "Comptes",
    "users": "Utilisateurs",
    "issues": "Problèmes",
    "adminPanel": "Panneau admin",
    "orgAdmin": "Organisation",
    "configuration": "Paramètres",
    "parameters": "Paramètres",
    "openMenu": "Ouvrir le menu",
    "collapseMenu": "Réduire le menu",
    "expandMenu": "Développer le menu",
    "writeHere": "Écrivez ici...",
    "headingPlaceholder": "Titre",
    "selectButtonsToExport": "Sélectionnez les boutons à exporter",
    "exportSelection": "Exporter la sélection",
    "configureButtons": "Configurer les boutons à exporter",
    "searchPlaceholder": "Rechercher...",
    "clearSelection": "Effacer la sélection",
    "noResults": "Aucun résultat trouvé",
    "commands": "Commandes",
    "insert": "Insérer",
    "update": "Mettre à jour",
    "generate": "Générer",
    "select": "Sélectionner",
    "dictate": "Dicter",
    "language": "Langue",
    "showing": "Affichage",
    "of": "de",
    "or": "ou",
    "page": "Page",
    "item": "élément",
    "items": "éléments",
    "copy": "Copier",
    "clear": "Effacer",
    "share": "Partager",
    "discard": "Ignorer",
    "deleting": "Suppression...",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "send": "Envoyer",
    "pause": "Pause",
    "resume": "Reprendre",
    "showLaterality": "Afficher la latéralité",
    "hideLaterality": "Masquer la latéralité",
    "laterality": {
      "left": "Gauche",
      "right": "Droite",
      "both": "Bilatéral"
    },
    "groups": "Groupes"
  },
  "commandPalette": {
    "searchPlaceholder": "Tapez une commande...",
    "results": "Résultats",
    "searching": "Recherche...",
    "noTemplatesFound": "Aucun modèle trouvé",
    "suggestions": "Suggestions",
    "createTemplate": "Créer un modèle",
    "startDictation": "Démarrer la dictée",
    "generateReport": "Générer un rapport",
    "recentTemplates": "Modèles récents",
    "errorLoadingTemplates": "Erreur de chargement des modèles",
    "errorSearching": "Erreur dans la recherche de modèles",
    "mustUseWithinProvider": "useCommandPalette doit être utilisé dans CommandPaletteProvider"
  },
  "auth": {
    "welcomeHello": "Bonjour,",
    "welcomeBack": "Accueillir",
    "launchSignInNeeded": "Votre examen vous attend. Connectez-vous pour continuer.",
    "launchIdentityRefused": "La connexion automatique n'a pas abouti : les données de votre compte ne correspondent pas au groupe depuis lequel l'examen a été lancé. Contactez votre administrateur. En attendant, vous pouvez vous connecter ici.",
    "emailLabel": "E-mail",
    "passwordLabel": "Mot de passe",
    "loginTitle": "Connectez-vous àAinovis",
    "loginSubtitle": "Entrez vos identifiants pour accéder",
    "forgotPassword": "Vous avez oublié votre mot de passe ?",
    "rememberMe": "Souviens-toi de moi",
    "noAccount": "Vous n'avez pas de compte ?",
    "signUp": "S'inscrire",
    "alreadyHaveAccount": "Vous avez déjà un compte ?",
    "signIn": "Se connecter",
    "verifyEmail": "Vérifier l'e-mail",
    "verifyEmailText": "Nous avons envoyé un e-mail de vérification à votre adresse e-mail",
    "resetPassword": "Réinitialiser le mot de passe",
    "resetPasswordText": "Entrez votre nouveau mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmez le mot de passe",
    "sendResetLink": "Envoyer le lien de réinitialisation",
    "backToLogin": "Retour à la connexion",
    "googleLogin": "Continuer avec Google",
    "microsoftLogin": "Continuer avec Microsoft",
    "orLoginWith": "Ou connectez-vous avec",
    "authenticatingMicrosoft": "Authentification avec Microsoft...",
    "processingAuth": "Traitement de l'authentification...",
    "resetPasswordTitle": "Réinitialiser le mot de passe",
    "resetPasswordDescription": "Entrez votre nouveau mot de passe",
    "resetting": "Réinitialisation...",
    "resetPasswordButton": "Réinitialiser le mot de passe",
    "invalidToken": "Jeton invalide ou expiré",
    "completeAllFields": "Veuillez remplir tous les champs",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "passwordMinLength": "Le mot de passe doit contenir au moins 6 caractères",
    "passwordResetSuccess": "Mot de passe réinitialisé avec succès",
    "enterButton": "Entrer",
    "emailPlaceholder": "E-mail",
    "passwordPlaceholder": "Mot de passe",
    "completeCaptcha": "Veuillez compléter le captcha",
    "continueWith": "ou continuez avec",
    "continueWithMicrosoft": "Continuer avec Microsoft",
    "forgotPasswordTitle": "Vous avez oublié votre mot de passe ?",
    "forgotPasswordDescription": "Ne vous inquiétez pas, nous vous enverrons des instructions pour le réinitialiser",
    "sendInstructions": "Envoyer les instructions",
    "emailSentTitle": "E-mail envoyé",
    "emailSentMessage": "Nous avons envoyé un email à{{email}}avec des instructions pour réinitialiser votre mot de passe",
    "checkSpam": "Si vous ne recevez pas l'e-mail dans quelques minutes, vérifiez votre dossier spam"
  },
  "notFound": {
    "title": "404",
    "subtitle": "Page introuvable",
    "message": "Désolé, la page que vous recherchez n'existe pas ou a été déplacée"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "reports": "Rapports",
    "recentReports": "Vos récents rapports de diagnostic",
    "createReport": "Créer un rapport",
    "viewAll": "Voir tout",
    "statistics": "Statistiques",
    "totalReports": "Total des rapports",
    "pendingReports": "Rapports en attente",
    "completedReports": "Rapports terminés"
  },
  "reports": {
    "deselectAll": "Tout désélectionner",
    "allSelected": "Tous sélectionnés ({{count}})",
    "tapToSelectAll": "Tout sélectionner",
    "selectedCountHint": "· {{count}} sélectionnés",
    "selectedCountHint_one": "· {{count}} sélectionné",
    "selectedCountHint_other": "· {{count}} sélectionnés",
    "signReport": "Signer",
    "signedBy": "Signé par :",
    "licenseNumber": "Nº d'ordre",
    "sendBusy": "Attendez la fin du traitement en cours",
    "requestEdit": "Demander l'accès en modification",
    "requestEditSent": "Demande envoyée",
    "requestEditError": "Impossible d'envoyer la demande. Réessayez.",
    "editRequestToast": "{{name}} demande l'accès en modification.",
    "editRequestManage": "Gérer",
    "editRequestSomeone": "Un utilisateur",
    "title": "Rapports",
    "newReport": "Nouveau rapport",
    "reportList": "Liste des rapports",
    "reportDetails": "Détails du rapport",
    "status": "Statut",
    "createdAt": "Créé à",
    "updatedAt": "Mis à jour à",
    "createdBy": "Créé par",
    "draft": "Brouillon",
    "published": "Publié",
    "archived": "Archivé",
    "noReports": "Aucun rapport disponible",
    "savedVersionLabel": "Version {{n}}", "savedVersionCorrected": "Corrigé", "savedVersionAddendum": "Avec addendum", "savedVersionSelector": "Version",
    "editSentReport": "Corriger le rapport", "revisionBanner": "Correction du rapport envoyé v{{n}}", "pacsRevisionBanner": "Correction du rapport du PACS", "pacsAddendumBanner": "Addendum au rapport du PACS", "correctionBadge": "Correction {{date}}", "revisionOpenError": "Impossible d'ouvrir la correction du rapport", "revisionPolicyDenied": "Votre compte ne permet pas de corriger les rapports envoyés.", "revisionVersionConflict": "Ce rapport a déjà une version plus récente. Rechargez la liste.", "revisionNoChanges": "Aucune modification par rapport au rapport envoyé.", "revisionAccessDenied": "Seul l'auteur peut corriger ce rapport.", "revisionNotFound": "Le rapport n'existe plus.",
    "addAddendum": "Ajouter un addendum", "addendumBadge": "Addendum {{date}}",
    "savedVersionMarked": "Modifications suivies", "pacsReportUnavailable": "Impossible de récupérer le rapport du PACS. Le rapport n'a pas été envoyé : réessayez.", "pacsRevisionInProgress": "Une autre personne révise déjà le rapport de cette étude.", "revisionKindConflict": "Vous avez déjà un brouillon ouvert de ce compte rendu avec un autre type de révision. Envoyez-le ou supprimez-le dans Brouillons.", "revisionUnmarkedDeletion": "Du texte du compte rendu d'origine a été supprimé sans être barré.", "editMarkedReport": "Modifier avec suivi des modifications", "markedBanner": "Modifications suivies sur le compte rendu envoyé v{{n}} : ce que vous supprimez sera barré", "markedRestore": "Restaurer",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce rapport ?",
    "studyDescription": "Description de l'étude",
    "studyDescriptionPlaceholder": "Entrez la description de l'étude...",
    "reasonForRequestedProcedure": "Motif de la demande",
    "reportGeneration": "Génération",
    "automatic": "Automatique",
    "manual": "Manuel",
    "automaticTooltip": "Générer le rapport automatiquement",
    "manualTooltip": "Générer le rapport à partir du modèle sélectionné",
    "reportFormat": "Type de rapport",
    "inside": "À l'intérieur",
    "first": "D'abord",
    "insideTooltip": "Les résultats seront répartis uniformément dans la section « Résultats »",
    "firstTooltip": "Les résultats seront placés au début de la section « Résultats »",
    "selectedTemplate": "Modèle sélectionné",
    "templateList": "Liste des modèles",
    "auto": "Auto",
    "automatic2": "Automatique",
    "enterDescription": "Veuillez saisir une description de l'étude",
    "reportCopied": "Rapport copié avec succès",
    "reportGenerated": "Rapport généré avec succès",
    "reportSaved": "Rapport enregistré avec succès",
    "noReportToSave": "Aucun rapport généré à enregistrer",
    "missingReportInfo": "Informations manquantes dans le rapport",
    "timeoutError": "La génération a pris trop de temps. Essayez avec une description plus courte",
    "generateButton": "Générer un rapport",
    "generating": "Générateur...",
    "thinking": "Pensée...",
    "saveButton": "Enregistrer le rapport",
    "saving": "Économie...",
    "generatingMessage": "Génération du rapport...",
    "savingMessage": "Enregistrement du rapport...",
    "editorPlaceholder": "Le rapport généré apparaîtra ici...",
    "activateDictation": "Activer la dictée vocale",
    "holdMicSendHint": "Relâchez pour envoyer · Échap pour annuler",
    "holdMicCancelHint": "Relâchez pour annuler",
    "keepAllContent": "Conserver tout le contenu marqué",
    "keepContentDesc": "Conserver le contenu marqué (fusionner sans supprimer)",
    "deleteAllContent": "Supprimer tout le contenu marqué",
    "keepOriginal": "Conserver le texte original",
    "keepOriginalDesc": "Conserver le texte original (ignorer les modifications)",
    "applyUpdates": "Appliquer toutes les mises à jour",
    "generateReport": "Générer un rapport",
    "basedOnRecentActivity": "Basé sur votre activité récente",
    "aiDisclaimer": "Ainovispeut faire des erreurs. Pensez à vérifier les informations importantes",
    "reportContent": "Paramètres du rapport",
    "continueWithBaseTemplate": "Continuer avec le modèle de base",
    "blocksDetected": "Blocs détectés",
    "selectBlockHint": "Sélectionnez un bloc ou continuez avec le modèle de base",
    "continueWithNormalTemplate": "Continuer sans blocs",
    "referenceSelected": "Référence sélectionnée ✓",
    "blockSelected": "Bloc sélectionné ✓",
    "blockSkipped": "Poursuivre sans bloc ✓",
    "description": "Descriptif",
    "detectedProcedures": "Procédures détectées",
    "noProceduresDetected": "Aucune procédure détectée",
    "detectedLaterality": "Latéralité détectée",
    "noLateralityFound": "Aucune latéralité trouvée",
    "searchLaterality": "Aligner la latéralité",
    "lateralityUpdated": "Latéralité mise à jour",
    "errorSearchingLaterality": "Erreur de détection de latéralité",
    "findingsFirst": "Les constats au début",
    "findingsInside": "Constatations dans le texte",
    "welcome": "Bienvenue {{title}} {{surname}}",
    "searchTemplate": "Modèle de recherche...",
    "loadingTemplate": "Chargement du modèle...",
    "multipleReferencesDetected": "Plusieurs références détectées",
    "selectReferenceHint": "Sélectionnez une option pour continuer la génération",
    "generateManualReport": "Générer un rapport manuel",
    "blankCanvas": "Toile vierge",
    "createTemplate": "Créer un modèle",
    "viewPowerBI": "Afficher les statistiques",
    "uploadAudio": "Traitement audio par lots",
    "noTemplatesFound": "Aucun modèle trouvé",
    "errorCreatingBlankCanvas": "Erreur lors de la création d'une toile vierge",
    "manualModePlaceholder": "Tapez le modèle que vous souhaitez utiliser",
    "navigate": "naviguer",
    "select": "sélectionner",
    "close": "fermer",
    "loadingTemplates": "Chargement des modèles...",
    "searchPlaceholder": "Rapport de recherche...",
    "reportsHistorySidebarTitle": "Historique des rapports",
    "reportsHistorySidebarTitleSaved": "Rapports envoyés",
    "reportsHistoryPreviewStamp": "Rapport envoyé",
    "reportsHistorySidebarClose": "Fermer le panneau d'historique",
    "reportsHistoryLoading": "Chargement…",
    "reportsHistoryError": "Impossible de charger l'historique",
    "reportsHistoryNoResults": "Aucun résultat",
    "reportsHistoryDraftsEmpty": "Vous n'avez aucun brouillon",
    "reportsHistorySavedEmpty": "Vous n'avez aucun rapport envoyé",
    "reportsHistoryUntitled": "Sans titre",
    "reportsHistoryTabDrafts": "Brouillons",
    "reportsHistoryTabSaved": "Envoyés",
    "createReport": "Créer un rapport",
    "currentStatus": "Statut actuel",
    "pendingReview": "Rapports en attente d'examen",
    "savedToday": "Rapports enregistrés aujourd'hui",
    "draftReports": "Projets de rapports",
    "recentReports": "Rapports de diagnostic récents",
    "drafts": "Brouillons",
    "saved": "Envoyé",
    "sharedWithMe": "Partagé avec moi",
    "ownedByMe": "Je suis le propriétaire",
    "noOwnedDrafts": "Aucun brouillon dont vous êtes propriétaire",
    "countOwned": "{{count}} personnels",
    "diagnosis": "Conclusion",
    "versions": "Versions",
    "version": "version",
    "lastUpdate": "Dernière mise à jour",
    "actions": "Actes",
    "noDrafts": "Aucun brouillon",
    "noSharedDrafts": "Aucun rapport partagé avec vous",
    "noDiagnosis": "(Pas de diagnostic)",
    "loadingVersions": "Chargement des versions...",
    "owner": "Propriétaire",
    "modalities": "Modalités",
    "procedure": "Procédure",
    "procedures": "Procédures",
    "time": "Temps",
    "draftVersionsInfo": "Ce projet a{{count}}version(s) enregistrée(s)",
    "report": "rapport",
    "reports": "rapports",
    "yourPerformance": "Votre prestation",
    "last7Days": "7 derniers jours",
    "thisWeek": "Cette semaine",
    "thisMonth": "Ce mois-ci",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "last30Days": "30 derniers jours",
    "older": "Plus vieux",
    "totalReports": "Total",
    "deleteDraftTitle": "Supprimer le brouillon",
    "leaveDraft": "Quitter le brouillon",
    "leaveDraftTitle": "Quitter le brouillon",
    "leaveDraftConfirm": "Quitter",
    "leaveDraftMessage": "Vous n'aurez plus accès à ce brouillon partagé. Le propriétaire pourra le partager à nouveau avec vous.",
    "deleteReportTitle": "Supprimer le rapport",
    "deleteDraftMessage": "Êtes-vous sûr de vouloir supprimer ce brouillon et toutes ses versions ? Cette action ne peut pas être annulée.",
    "deleteReportMessage": "Êtes-vous sûr de vouloir supprimer ce rapport enregistré ? Cette action ne peut pas être annulée.",
    "deleteBatchTitle": "Supprimer le lot",
    "deleteBatchMessage": "Etes-vous sûr de vouloir supprimer ce lot et toutes ses études ? Cette action ne peut pas être annulée.",
    "errorLoadingReport": "Erreur lors du chargement du rapport",
    "noContentToCopy": "Aucun contenu à copier",
    "contentCopied": "Contenu copié dans le presse-papiers",
    "errorCopying": "Erreur lors de la copie du contenu",
    "errorPreSaveValidation": "Erreur lors de la validation avant l'enregistrement",
    "preSaveInconsistencies": "Incohérences détectées",
    "preSaveVersions": "Plusieurs versions",
    "preSaveVersionsMsg": "Seule la version actuelle sera enregistrée et le reste{{count}}sera rejeté.",
    "errorSavingReport": "Erreur lors de l'enregistrement du rapport",
    "errorSavingDraft": "Erreur lors de l'enregistrement du brouillon",
    "draftDeleted": "Brouillon supprimé avec succès",
    "errorDeletingDraft": "Erreur lors de la suppression du brouillon",
    "emptyTechnique": "La technique est vide",
    "proceduresFound": "Procédures mises à jour",
    "errorSearchingProcedures": "Procédures de recherche d'erreurs",
    "blankVersionCreated": "Toile vierge créée",
    "errorCreatingBlankVersion": "Erreur lors de la création d'une toile vierge",
    "loadingReport": "Chargement du rapport...",
    "deletingMessage": "Suppression du brouillon...",
    "searchingProcedures": "Procédures de recherche...",
    "searchingLaterality": "Détecter la latéralité...",
    "hideProcedures": "Masquer les procédures",
    "searchProcedures": "Procédures de recherche",
    "showProcedures": "Afficher les procédures",
    "confirmDeleteDraft": "Êtes-vous sûr de vouloir supprimer ce brouillon ? Cette action ne peut pas être annulée.",
    "inconsistency": "Incohérence",
    "show": "Montrer",
    "preSaveTitle": "Avant d'enregistrer",
    "preSaveSubtitle": "Les avertissements suivants ont été détectés :",
    "confirmSave": "Envoyer quand même",
    "unsavedChanges": "Modifications non enregistrées",
    "unsavedChangesMessage": "\"{{title}}\" comporte des modifications non enregistrées. Supprimer les modifications ?",
    "maxVersionsReached": "Nombre maximal de rapports atteint",
    "settings": "Paramètres",
    "reportType": "Type de rapport",
    "noTemplateSelected": "Détection automatique",
    "useAnotherTemplate": "Utiliser un autre modèle",
    "change": "Changement",
    "changeTemplate": "Changer de modèle",
    "backToAutoDetection": "Retour à la détection automatique",
    "autoDetection": "Détection automatique",
    "noDescription": "Pas de description",
    "resume": "CV",
    "pause": "Pause",
    "process": "Processus",
    "processingAudio": "Traitement du son...",
    "analyzingVoice": "Analyse de votre voix...",
    "transcribingAudio": "Transcription audio...",
    "interpretingCommands": "Interprétation des commandes...",
    "preparingResult": "Préparation du résultat...",
    "analyzingText": "Analyse de votre texte...",
    "understandingIntent": "Compréhension de l'intention...",
    "readingContext": "Lecture du contexte...",
    "identifyingSections": "Identification des sections...",
    "writing": "Écriture...",
    "fillingReport": "Remplissage du rapport...",
    "writingSections": "Rédaction des sections...",
    "addingFindings": "Ajout des constatations...",
    "refiningContent": "Peaufinage du contenu...",
    "applyingClassifications": "Application des classifications...",
    "evaluatingCriteria": "Évaluation des critères...",
    "calculatingResults": "Calcul des résultats...",
    "finalizingReport": "Finalisation...",
    "aiAssistantPlaceholder": "Écrivez un texte ou dictez avec le micro...",
    "sendToDescriptive": "Descriptif",
    "aiChatEmpty": "Envoyez un message pour démarrer la conversation",
    "carolinaAssistance": "CarolinaAssistance",
    "send": "Envoyer",
    "record": "Enregistrer",
    "generate": "Générer",
    "selectReference": "Sélectionnez une des références pour continuer",
    "errorGenerating": "Erreur lors de la génération du rapport",
    "noTemplateDetected": "Aucun modèle détecté",
    "reportGeneratedWithReference": "Rapport généré avec la référence sélectionnée",
    "versionCreated": "Nouvelle version créée avec succès",
    "errorCreatingVersion": "Erreur lors de la création de la version",
    "emptyRecording": "L'enregistrement est vide",
    "invalidServerResponse": "Erreur : réponse du serveur non valide",
    "noAudioDetected": "Aucun son détecté",
    "commandExecuted": "Commande exécutée avec succès",
    "audioTranscribed": "Audio transcrit avec succès",
    "audioProcessingError": "Erreur lors du traitement de l'audio",
    "microphoneAccessError": "Impossible d'accéder au microphone",
    "descriptionRequired": "Vous devez saisir une description",
    "errorLoadingTemplates": "Impossible de charger les modèles",
    "patient": "Patient",
    "patientId": "ID du patient",
    "patientIdPlaceholder": "IDENTIFIANT...",
    "patientAge": "Âge",
    "patientAgePlaceholder": "Années",
    "patientSex": "Sexe",
    "patientSexPlaceholder": "Sélectionner...",
    "sexMale": "Mâle",
    "sexFemale": "Femelle",
    "studyDate": "Date de l'étude",
    "requestReason": "Motif de la demande",
    "patientNamePlaceholder": "Nom, Prénom",
    "requestReasonPlaceholder": "Description de la raison...",
    "cancel": "Annuler",
    "cancelEditing": "Annuler la modification",
    "patientNameRequired": "Le nom du patient est requis",
    "confirmHint": "Entrer pour confirmer · Echap pour annuler",
    "editPatient": "Modifier le patient",
    "deletePatient": "Supprimer un patient",
    "contractReason": "Raison de l'effondrement",
    "expandReason": "Développer la raison",
    "years": "Années",
    "modality": "Modalité",
    "accessionNumber": "Numéro d'accession",
    "referringPhysician": "Médecin référent",
    "previousStudiesTitle": "Études antérieures",
    "previousStudiesHint": "Afficher et comparer avec des études de patients précédentes",
    "allProcedures": "Toutes les procédures",
    "study": "étude",
    "studiesCount": "études",
    "studyPlural": "études",
    "batches": "Lots",
    "batchStudies": "Études",
    "noBatches": "Aucun lot en attente",
    "continueBatch": "Continuer",
    "noStudiesFound": "Aucune étude antérieure trouvée",
    "studyStatus_completed": "Complété",
    "studyStatus_pending": "En attente",
    "studyStatus_cancelled": "Annulé",
    "loadPrevStudies": "Charger les études précédentes",
    "reportClinicalInfo": "Informations cliniques",
    "reportTechnique": "Technique",
    "reportFindings": "Résultats",
    "reportConclusion": "Conclusion",
    "conclusionType": "Conclusion",
    "conclusionBrief": "Brève conclusion",
    "conclusionNormal": "Conclusion normale",
    "conclusionExtensive": "Conclusion détaillée",
    "conclusionBriefShort": "Bref",
    "conclusionNormalShort": "Normale",
    "conclusionExtensiveShort": "Extensif",
    "speedMode": "Mode vitesse",
    "fast": "Rapide",
    "accurate": "Précis",
    "fastModeDesc": "Génération rapide",
    "accurateModeDesc": "Une plus grande précision",
    "loadTemplate": "Charger le rapport sans modifications",
    "templateNotes": "Souhaitez-vous modifier quelque chose lors de la génération du nouveau rapport ?",
    "templateNotesPlaceholder": "Ex. : modifier les résultats hépatiques, ajouter un nodule pulmonaire de 8 mm…",
    "needDescriptive": "Écrivez quelque chose dans le champ de texte pour générer",
    "useAsTemplate": "Générer en utilisant ceci comme modèle",
    "noReportContent": "Aucun contenu de rapport disponible",
    "searchStudies": "Recherche par procédure ou par date…",
    "previousStudy": "Étude précédente",
    "makeChanges": "Apporter des modifications",
    "makeChangesPlaceholder": "Décrivez les modifications que vous souhaitez apporter au rapport comparatif…",
    "classificationSectionsEmpty": "Les sections techniques, résultats et conclusions doivent être complètes pour classer",
    "classificationSuccess": "Classement terminé avec succès",
    "classificationError": "Erreur lors de la classification",
    "editorNotReady": "L'éditeur n'est pas prêt",
    "classificationUnchanged": "Le contenu du rapport n'a pas changé depuis la dernière classification.",
    "classificationNoFindings": "Aucun résultat compatible trouvé pour cette classification",
    "classificationInResearch": "Cette fonctionnalité est en cours de recherche. Si vous souhaitez l'utiliser, demandez-la à votre administrateur.",
    "classifications": "Classement",
    "classificationsTitle": "Classement",
    "fleischnerClassification": "FleischnerClassification",
    "fleischnerDesc": "Nodules pulmonaires accidentels —Fleischner2017",
    "analyzing": "Analyser…",
    "classify": "Classer",
    "results": "Résultats",
    "table": "Tableau",
    "fleischnerCriteria": "FleischnerCritères",
    "fleischner_toggleHighlight": "Activer/Désactiver la visibilité des surbrillance",
    "fleischnerDescription": "Lignes directrices de suivi des nodules pulmonaires fortuits détectés par tomodensitométrie, basées sur la taille, le nombre et le type de nodule.",
    "singleSolidNodule": "Nodule solide unique",
    "multipleSolidNodules": "Nodules solides multiples",
    "subsolidNodules": "Nodules subsolides",
    "pureGroundGlass": "Verre dépoli pur",
    "partSolidNodule": "Nodule partiellement solide",
    "size": "Taille",
    "lowRisk": "Faible risque",
    "highRisk": "Risque élevé",
    "followUp": "Suivi",
    "noFollowUp": "Aucun suivi",
    "partSolidNote": "Si composant solide ≥ 6 mm, envisager une TEP-TDM ou une résection.",
    "reference": "Référence:MacMahonH et coll.",
    "singleLt6LowRisk": "Aucun suivi",
    "singleLt6HighRisk": "CT à 12 mois (facultatif)",
    "single6to8LowRisk": "CT à 6-12 mois → envisager à 18-24 mois",
    "single6to8HighRisk": "CT à 6-12 mois → répéter à 18-24 mois",
    "singleGt8LowRisk": "Envisager une tomodensitométrie à 3 mois, une TEP-TDM ou une biopsie",
    "singleGt8HighRisk": "Identique à faible risque",
    "multipleLt6LowRisk": "Aucun suivi",
    "multipleLt6HighRisk": "CT à 12 mois",
    "multipleGte6LowRisk": "CT à 3-6 mois → envisager à 18-24 mois",
    "multipleGte6HighRisk": "CT à 3-6 mois → répéter à 18-24 mois",
    "ggLt6": "Aucun suivi",
    "ggGte6": "CT à 6-12 mois → puis tous les 2 ans jusqu'à 5 ans",
    "psLt6": "Aucun suivi",
    "psGte6": "TDM à 3–6 mois → si persistant, suivi annuel pendant 5 ans",
    "conclusionNoFollowUp": "Aucun suivi requis parFleischnerCritères 2017.",
    "conclusionOptionalCT12": "Un suivi tomodensitométrique facultatif à 12 mois est recommandéFleischnerCritères 2017.",
    "conclusionCT6to12Consider18to24": "Un suivi par tomodensitométrie à 6-12 mois est recommandé, avec la possibilité d'envisager un suivi supplémentaire à 18-24 mois par mois.FleischnerCritères 2017.",
    "conclusionCT6to12Repeat18to24": "Un suivi par tomodensitométrie à 6-12 mois est recommandé, avec un suivi supplémentaire à 18-24 mois par mois.FleischnerCritères 2017.",
    "conclusionConsiderCT3PetBiopsy": "Envisager une tomodensitométrie à 3 mois, une TEP-TDM ou une biopsie parFleischnerCritères 2017.",
    "conclusionCT12": "Un suivi tomodensitométrique à 12 mois est recommandéFleischnerCritères 2017.",
    "conclusionCT3to6Consider18to24": "Un suivi par tomodensitométrie à 3-6 mois est recommandé, avec la possibilité d'envisager un suivi supplémentaire à 18-24 mois par mois.FleischnerCritères 2017.",
    "conclusionCT3to6Repeat18to24": "Un suivi par tomodensitométrie à 3-6 mois est recommandé, avec un suivi supplémentaire à 18-24 mois par mois.FleischnerCritères 2017.",
    "conclusionCT6to12Every2y5y": "Un suivi par tomodensitométrie à 6-12 mois est recommandé, suivi d'un suivi tous les 2 ans pendant un maximum de 5 ans parFleischnerCritères 2017.",
    "conclusionCT3to6Annual5y": "Un suivi tomodensitométrique à 3-6 mois est recommandé ; si persistant, suivi annuel pendant 5 ans parFleischnerCritères 2017.",
    "tirads_classification": "TI-RADSClassification",
    "tirads_desc": "Nodules thyroïdiens —ACR TI-RADS2017",
    "tirads_criteria": "ACR TI-RADSCritères",
    "tirads_description": "Système de notation des nodules thyroïdiens détectés par échographie, basé sur la composition, l'échogénicité, la forme, les marges et les foyers échogènes.",
    "tirads_composition": "Composition",
    "tirads_echogenicity": "Échogénicité",
    "tirads_shape": "Forme",
    "tirads_margin": "Marges",
    "tirads_echogenicFoci": "Foyers échogènes",
    "tirads_feature": "Fonctionnalité",
    "tirads_points": "Points",
    "tirads_compositionCystic": "Kystique ou presque complètement kystique",
    "tirads_compositionSpongiform": "Spongiforme",
    "tirads_compositionMixed": "Mixte kystique et solide",
    "tirads_compositionSolid": "Solide ou presque entièrement solide",
    "tirads_echogenicityAnechoic": "Anéchoïque",
    "tirads_echogenicityHyperIso": "Hyperéchogène ou isoéchogène",
    "tirads_echogenicityHypo": "Hypoéchogène",
    "tirads_echogenicityVeryHypo": "Très hypoéchogène",
    "tirads_shapeWider": "Plus large que haut",
    "tirads_shapeTaller": "Plus grand que large",
    "tirads_marginSmooth": "Lisse",
    "tirads_marginIllDefined": "Mal défini",
    "tirads_marginLobulated": "Lobulé ou irrégulier",
    "tirads_marginExtrathyroidal": "Extension extra-thyroïdienne",
    "tirads_fociNone": "Aucun ou gros artefacts en queue de comète",
    "tirads_fociMacro": "Macrocalcifications",
    "tirads_fociPeripheral": "Calcifications périphériques (bord)",
    "tirads_fociPunctate": "Foyers échogènes ponctués",
    "tirads_categoriesTitle": "Catégories et recommandations",
    "tirads_categoryCol": "Catégorie",
    "tirads_fnaThreshold": "FNA si",
    "tirads_followUpThreshold": "Faire un suivi si",
    "tirads_tr1_name": "TR1 – Bénin",
    "tirads_tr2_name": "TR2 — Pas suspect",
    "tirads_tr3_name": "TR3 – Légèrement suspect",
    "tirads_tr4_name": "TR4 – Modérément suspect",
    "tirads_tr5_name": "TR5 — Très suspect",
    "tirads_scoringNote": "Additionnez les points de chaque catégorie (valeur la plus élevée dans chacune). S'applique uniquement aux nodules ≥ 1 cm ou présentant des caractéristiques suspectes.",
    "tirads_reference": "Référence:TesslerFN et coll.",
    "tirads_conclusionTR1": "Nodule thyroïdien classé commeTI-RADS1 (bénigne). Aucune FNA ou suivi requis parACR TI-RADS2017.",
    "tirads_conclusionTR2": "Nodule thyroïdien classé commeTI-RADS2 (pas suspect). Aucune FNA ou suivi requis parACR TI-RADS2017.",
    "tirads_conclusionTR3": "Nodule thyroïdien classé commeTI-RADS3 (légèrement suspect). FNA recommandée si ≥ 2,5 cm ou suivi si ≥ 1,5 cm parACR TI-RADS2017.",
    "tirads_conclusionTR4": "Nodule thyroïdien classé commeTI-RADS4 (modérément suspect). FNA recommandée si ≥ 1,5 cm ou suivi si ≥ 1 cm parACR TI-RADS2017.",
    "tirads_conclusionTR5": "Nodule thyroïdien classé commeTI-RADS5 (très suspect). FNA recommandée si ≥ 1 cm ou suivi si ≥ 0,5 cm parACR TI-RADS2017.",
    "tirads_chooseOne": "Choisissez 1",
    "tirads_chooseAll": "Tout ce qui s'applique",
    "tirads_sumPoints": "Somme des points de toutes les catégories",
    "tirads_selectOptions": "Sélectionnez les options",
    "tirads_recommendationCol": "Recommandation",
    "tirads_noFnaNoFollowUp": "Pas de FNA · Pas de suivi",
    "tirads_tr1_label": "Bénin",
    "tirads_tr2_label": "Pas suspect",
    "tirads_tr3_label": "Légèrement suspect",
    "tirads_tr4_label": "Modérément suspect",
    "tirads_tr5_label": "Très suspect",
    "pirads_classification": "ClassificationPI-RADS",
    "pirads_desc": "Lésions prostatiques —PI-RADSv2.1",
    "pirads_title": "PI-RADSv2.1 — Classification par zones",
    "pirads_description": "Système de notation pour la détection du cancer de la prostate cliniquement significatif à l'aideRMmultiparamétrique. Basé sur le guide deRadiology Assistant.",
    "pirads_dominant": "Dominant",
    "pirads_secondary": "Secondaire",
    "pirads_probabilityCol": "Probabilité",
    "pirads_refinedV21": "v2.1 raffiné",
    "pirads_tabPZ": "Zone périphérique (ZP)",
    "pirads_tabTZ": "Zone de transition (TZ)",
    "pirads_tabDCE": "DCEet paramètres",
    "pirads_tabInfo": "Protocole etTNM",
    "pirads_zonePZ": "Zone périphérique",
    "pirads_zoneTZ": "Zone de transition",
    "pirads_pr1_legend": "PI-RADS1 — Très faible",
    "pirads_pr2_legend": "PI-RADS2 — Faible",
    "pirads_pr3_legend": "PI-RADS3 — Erreur",
    "pirads_pr4_legend": "PI-RADS4 — Élevé",
    "pirads_pr5_legend": "PI-RADS5 — Très élevé",
    "pirads_pr1_label": "Très faible",
    "pirads_pr2_label": "Faible",
    "pirads_pr3_label": "Erreur",
    "pirads_pr4_label": "Haut",
    "pirads_pr5_label": "très élevé",
    "pirads_pr1_prob_short": "< 3%",
    "pirads_pr2_prob_short": "~5%",
    "pirads_pr3_prob_short": "~12-18%",
    "pirads_pr4_prob_short": "~25-40%",
    "pirads_pr5_prob_short": "~60-90%",
    "pirads_pz1_dwi": "Aucune anomalie visible dansADCni dansDWIvaleur élevée b.",
    "pirads_pz1_t2w": "Signal hyperintense homogène normal.",
    "pirads_pz1_prob": "Très faible (< 3 %)",
    "pirads_pz2_dwi": "Hypointensité dansADCet/ou hyperintensitéDWIavec configuration linéaire ou en coin.",
    "pirads_pz2_t2w": "Hypointensité diffuse ou en coin.",
    "pirads_pz2_prob": "Faible (~5 %)",
    "pirads_pz3_dwi": "Hypointensité focale dansADCet/ou hyperintensité focaleDWI. Il peut être marqué sur un mais pas sur les deux simultanément.",
    "pirads_pz3_t2w": "Hypointensité focale hétérogène et non marquée.",
    "pirads_pz3_prob": "Intermédiaire (~12-18%)",
    "pirads_pz3_dce_adjust": "Monter àPI-RADS4 s’il y a un rehaussement focal précoce. OuaisDCE(−), reste à 3.",
    "pirads_pz4_dwi": "Hypointensité focale marquéeADCet une hyperintensité marquéeDWI.",
    "pirads_pz4_t2w": "Hypointensité focale marquée.",
    "pirads_pz4_prob": "Élevé (~25-40 %)",
    "pirads_pz5_dwi": "Identique au score 4 mais ≥ 1,5 cm ou extension extraprostatique (EPE) / comportement invasif définitif.",
    "pirads_pz5_t2w": "Hypointensité focale marquée avec invasion possible.",
    "pirads_pz5_prob": "Très élevé (~60-90%)",
    "pirads_tz1_t2w": "ZT d'apparence normale ou nodule arrondi complètement encapsulé (« nodule typique »).",
    "pirads_tz1_dwi": "Normale.",
    "pirads_tz1_prob": "Très faible (< 2 %)",
    "pirads_tz2_t2w": "Nodule majoritairement encapsulé, ou nodule homogène circonscrit sans capsule (« nodule atypique »), ou zone homogène légèrement hypointense entre nodules.",
    "pirads_tz2_dwi": "DWI≤ 3 : ne modifie pas le score.",
    "pirads_tz2_prob": "Faible (~5 %)",
    "pirads_tz2_dwi_adjust": "Monter àPI-RADS3. OuiDWI≤ 3, reste à 2.",
    "pirads_tz3_t2w": "Signal hétérogène avec marges sombres. Comprend les résultats qui ne correspondent pas aux catégories 2, 4 ou 5.",
    "pirads_tz3_dwi": "DWI< 5 : ne modifie pas le score.",
    "pirads_tz3_prob": "Intermédiaire (~10-15%)",
    "pirads_tz3_dwi_adjust": "Monter àPI-RADS4. OuiDWI≤ 4, reste à 3.",
    "pirads_tz4_t2w": "Lésion lenticulaire ou non circonscrite, homogène, moyennement hypointense.",
    "pirads_tz4_dwi": "Restriction de diffusion moyennement marquée.",
    "pirads_tz4_prob": "Élevé (~25-40 %)",
    "pirads_tz5_t2w": "Idem score 4 mais ≥ 1,5 cm ou extension extraprostatique / comportement invasif définitif.",
    "pirads_tz5_dwi": "Restriction de diffusion marquée.",
    "pirads_tz5_prob": "Très élevé (~60-90%)",
    "pirads_dcePositive": "DCEPositif (+)",
    "pirads_dcePositiveDesc": "Rehaussement focal, précoce ou contemporain du rehaussement du tissu prostatique normal adjacent, et correspondant à une constatation suspecte dansT2WjeDWI.",
    "pirads_dceNegative": "DCENégatif (−)",
    "pirads_dceNeg1": "Absence de rehaussement précoce.",
    "pirads_dceNeg2": "Rehaussement diffus, ne correspondant pas à la lésion focaleT2W/DWI.",
    "pirads_dceNeg3": "Rehaussement focal correspondant à un nodule deHBP.",
    "pirads_zoneCol": "Zone",
    "pirads_baseScoreCol": "Note de base",
    "pirads_conditionCol": "Condition",
    "pirads_finalScoreCol": "Score final",
    "pirads_dce_pz_3_pos_base": "DWI/ADC= 3",
    "pirads_dce_pz_3_pos_cond": "DCE(+) → Amélioration focale précoce",
    "pirads_dce_pz_3_pos_final": "↑PI-RADS4",
    "pirads_dce_pz_3_neg_base": "DWI/ADC= 3",
    "pirads_dce_pz_3_neg_cond": "DCE(−) → Pas de rehaussement focal",
    "pirads_dce_pz_3_neg_final": "PI-RADS3",
    "pirads_dce_tz_2_up_base": "T2W= 2",
    "pirads_dce_tz_2_up_cond": "DWI≥ 4",
    "pirads_dce_tz_2_up_final": "↑PI-RADS3",
    "pirads_dce_tz_2_stay_base": "T2W= 2",
    "pirads_dce_tz_2_stay_cond": "DWI≤ 3",
    "pirads_dce_tz_2_stay_final": "PI-RADS2",
    "pirads_dce_tz_3_up_base": "T2W= 3",
    "pirads_dce_tz_3_up_cond": "DWI= 5 (fortement intense ≥ 1,5 cm)",
    "pirads_dce_tz_3_up_final": "↑PI-RADS4",
    "pirads_dce_tz_3_stay_base": "T2W= 3",
    "pirads_dce_tz_3_stay_cond": "DWI≤ 4",
    "pirads_dce_tz_3_stay_final": "PI-RADS3",
    "pirads_afmsTitle": "Stroma fibromusculaire antérieurAFMS)",
    "pirads_afmsDesc": "Le cancer de la prostate ne provient pas duAFMS. Lorsqu'une lésion suspecte est identifiée dans cette zone, il convient d'appliquer les critères de la zone (PZ ou TZ) d'où la lésion est probablement originaire. IlAFMSla normale présente une forme de croissant bilatéral symétrique avec un signal faible homogène similaire à celui du muscle obturateur dansT2W,ADCetDWIhaut.",
    "pirads_protocolTitle": "ProtocoleRMrecommandé (v2.1)",
    "pirads_protocolT2W": "Plan axial (ou plan oblique perpendiculaire au grand axe de la prostate) + au moins un plan orthogonal supplémentaire (sagittal et/ou coronal).",
    "pirads_protocolDWI": "Valeur b faible (0-100, 50-100 de préférence), intermédiaire (800-1 000) et élevée (≥ 1 400 s/mm²) obligatoire. CarteADCcalculé.",
    "pirads_protocolDCE": "Résolution temporelle ≤ 15 s. De préférence en 3DT1W GRE.",
    "pirads_protocolT1W": "Pour détecter une hémorragie post-biopsie.FOVbifurcation large à aortique pour les ganglions lymphatiques et les métastases osseuses.",
    "pirads_csCancerTitle": "Cancer cliniquement significatif (définitionPI-RADS)",
    "pirads_csCancer1": "Gleasonscore ≥ 7 (dont 3+4 avec composanteGleason4 importants).",
    "pirads_csCancer2": "Volume tumoral> 0,5 cc.",
    "pirads_csCancer3": "Extension extraprostatique (EPE).",
    "pirads_volumeTitle": "Volume et densité de la prostatePSA",
    "pirads_ellipsoidFormula": "Formule ellipsoïde",
    "pirads_psaDensity": "DensitéPSA≥ 0,20 → suspicion de malignité cliniquement significative.",
    "pirads_rtLimit": "Limite pour la radiothérapie externe conventionnelle : 55 cc.",
    "pirads_tStagingTitle": "Mise en scène T pertinente pour l’image",
    "pirads_stageT2": "Tumeur confinée à la prostate (T2a : ≤ la moitié d'un lobe ; T2b : > la moitié d'un lobe ; T2c : les deux lobes).",
    "pirads_stageT3a": "Extension extraprostatique (EPE).",
    "pirads_stageT3b": "Invasion des vésicules séminales.",
    "pirads_stageT4": "Invasion des structures adjacentes (rectum, paroi pelvienne, sphincter, vessie).",
    "pirads_stageN1": "Noeuds régionaux positifs (pelviens, hypogastriques, sacrés, iliaques).",
    "pirads_stageM1a": "Ganglions lymphatiques éloignés (aortique, iliaque commun, inguinal).",
    "pirads_nodesTitle": "Ganglions lymphatiques suspects (stadification N)",
    "pirads_node1": "Rond à axe court ≥ 8 mm.",
    "pirads_node2": "Ovale à axe court ≥ 10 mm.",
    "pirads_node3": "Aspect hétérogène.",
    "pirads_node4": "Marges irrégulières.",
    "pirads_node5": "DWIC'est la meilleure séquence pour la détection des ganglions lymphatiques.",
    "pirads_changesTitle": "Changements clés v2.0 → v2.1",
    "pirads_change1": "Les nodules ronds complètement encapsulés dans TZ sont désormaisPI-RADS1 (auparavant 2).",
    "pirads_change2": "Critères plus précis pour la catégorie 2 en TZ et PZ.",
    "pirads_change3": "Mettre à jour les recommandations de valeur BDWIet résolution temporelleDCE.",
    "pirads_change4": "Considérations particulières pourAFMSet zone centrale.",
    "pirads_change5": "Guide amélioré pour l’évaluation du signal de fond dans TZ.",
    "pirads_scoringNote": "La séquence dominante détermine le score de base. Dans PZ, la dominante estDWI/ADC; en TZ la dominante estT2W. Les paramètresDCEetDWIIls peuvent modifier le score final.",
    "pirads_reference": "Fontaine:Radiology Assistant—PI-RADSv2.1. Pour usage de référence pédagogique et clinique uniquement.",
    "pirads_conclusionPR1": "Lésion de la prostate classée commePI-RADS1 (très faible probabilité de cancer cliniquement significatif). Ne nécessite pas de surveillance particulière.",
    "pirads_conclusionPR2": "Lésion de la prostate classée commePI-RADS2 (faible probabilité de cancer cliniquement significatif). Aucune biopsie requise.",
    "pirads_conclusionPR3": "Lésion de la prostate classée commePI-RADS3 (probabilité équivoque de cancer cliniquement significatif). Une corrélation clinique et un éventuel suivi ou biopsie sont recommandés en fonction du contexte clinique.",
    "pirads_conclusionPR4": "Lésion de la prostate classée commePI-RADS4 (forte probabilité de cancer cliniquement significatif). Une biopsie ciblée est recommandée.",
    "pirads_conclusionPR5": "Lésion de la prostate classée commePI-RADS5 (très forte probabilité de cancer cliniquement significatif). Une biopsie ciblée urgente est recommandée.",
    "bosniak_classification": "ClassificationBosniak2019",
    "bosniak_desc": "Masses rénales kystiques —Bosniak2019",
    "bosniak_criteria": "CritèresBosniak2019",
    "bosniak_description": "Système de classification des masses rénales kystiques basé sur les caractéristiques de la paroi, des septa, du rehaussement, de la calcification, de la nodularité et de l'atténuation.TC/RM.",
    "bosniak_wall": "Mur",
    "bosniak_septa": "Septums",
    "bosniak_enhancement": "Renforcement",
    "bosniak_calcification": "Calcification",
    "bosniak_attenuation": "Atténuation/Signal",
    "bosniak_chooseOne": "Choisissez 1",
    "bosniak_highestCategory": "La catégorie la plus élevée détermine le classement",
    "bosniak_selectFeatures": "Sélectionnez les fonctionnalités",
    "bosniak_malignancyRisk": "Risque de malignité",
    "bosniak_wallThinSmooth": "Paroi mince (≤ 2 mm) lisse",
    "bosniak_wallThinSmoothWithSepta": "Paroi lisse mince (≤ 2 mm) (avec septa ou calcification)",
    "bosniak_wallMinimalThickening3mm": "Épaississement lisse minimal (3 mm) avec rehaussement",
    "bosniak_wallThickOrIrregular": "Paroi épaisse (≥ 4 mm) ou irrégulière avec rehaussement",
    "bosniak_wallWithNodule": "Mur avec nodule(s) surélevé(s)",
    "bosniak_septaNone": "Pas de septa",
    "bosniak_septaFewThin": "Quelques (1 à 3) septa minces (≤ 2 mm) rehaussés",
    "bosniak_septaMinimalThickeningOrMany": "Épaississement minimal (3 mm) des septa ou ≥ 4 septa minces",
    "bosniak_septaThickOrIrregular": "Septa épais (≥ 4 mm) ou irréguliers avec rehaussement",
    "bosniak_septaWithNodule": "Septa avec nodule(s) (≥ 4 mm obtus ou tout angle aigu)",
    "bosniak_enhanceWallOnly": "Le mur peut mettre en valeur ; sans amélioration interne",
    "bosniak_enhanceSeptaWall": "Les septums et les murs peuvent améliorer",
    "bosniak_enhanceSmoothMinimal": "Paroi lisse ou rehaussement de septum (3 mm)",
    "bosniak_enhanceThickIrregular": "Renforcement des parois ou septa épais/irrégulier",
    "bosniak_enhanceNodular": "Composant(s) nodulaire(s) avec rehaussement",
    "bosniak_calcNone": "Pas de calcification",
    "bosniak_calcAnyType": "Calcification de tout type (paroi mince, quelques septa)",
    "bosniak_attenSimpleFluid": "Liquide simple homogène (−9 à 20UH)",
    "bosniak_attenHyperNonContrast": "Hyperatténuant homogène (≥ 70UH)TCpas de contraste",
    "bosniak_attenNonEnhancingGt20": "Homogène sans enrichissement > 20UH(protocole rénalTC)",
    "bosniak_attenPortalVenous2130": "Homogène 21-30UHen phase veineuse porte",
    "bosniak_attenTooSmall": "Faible atténuation homogène, trop petite pour être caractérisée",
    "bosniak_attenHeteroT1Hyper": "Hétérogène en T1 sans contraste avec saturation graisseuse (hyperintense)",
    "bosniak_bI_label": "Bénin",
    "bosniak_bII_label": "Peu complexe",
    "bosniak_bIIF_label": "Peu complexe (suivi)",
    "bosniak_bIII_label": "Indéterminé",
    "bosniak_bIV_label": "Clairement maléfique",
    "bosniak_scoringNote": "La catégorieBosniakla finale est déterminée par la caractéristique la plus élevée. Ne pas appliquer sur des lésions avec > 25 % de composante solide, d'étiologie infectieuse/inflammatoire ou vasculaire.",
    "bosniak_reference": "Référence : Silverman SG et coll.",
    "bosniak_conclusionI": "Masse rénale kystique classée commeBosniakJe (bénigne). Aucun suivi requis en fonction de la classificationBosniak2019.",
    "bosniak_conclusionII": "Masse rénale kystique classée commeBosniakII (peu complexe, bénin). Risque de malignité < 1 %. Aucun suivi requis en fonction de la classificationBosniak2019.",
    "bosniak_conclusionIIF": "Masse rénale kystique classée commeBosniakIIF (peu complexe, nécessite un suivi). Risque de malignité 5 à 10 %. Un suivi des images est recommandé selon la classificationBosniak2019.",
    "bosniak_conclusionIII": "Masse rénale kystique classée commeBosniakIII (indéterminé). Risque de malignité ~50%. Une intervention chirurgicale ou une surveillance active est recommandée selon le contexte clinique et la classification.Bosniak2019.",
    "bosniak_conclusionIV": "Masse rénale kystique classée commeBosniakIV (clairement malin). Risque de malignité ~90%. Un traitement chirurgical est recommandé selon la classificationBosniak2019.",
    "bosniak_tabScoring": "Calculatrice",
    "bosniak_tabCategories": "Catégories",
    "bosniak_tabImaging": "Image",
    "bosniak_tabInfo": "Informations",
    "bosniak_wallDesc": "Évaluation de l'épaisseur, de la régularité et de la présence de nodules dans la paroi du kyste rénal. L'épaississement ou l'irrégularité du mur augmente la catégorieBosniak.",
    "bosniak_septaDesc": "Évaluation du nombre, de l'épaisseur et de la régularité des cloisons intrakystiques. Des cloisons épaisses ou nodulaires suggèrent un risque plus élevé de malignité.",
    "bosniak_enhancementDesc": "Modèle de rehaussement après administration de contraste intraveineux. Véritable amélioration (≥ 20UH) de composants solides est essentiel pour différencier les masses bénignes des masses malignes.",
    "bosniak_calcificationDesc": "La calcification seule ne change pas la catégorieBosniakdans la version 2019. Elle est documentée mais ne modifie pas le classement.",
    "bosniak_attenuationDesc": "Caractéristiques de gradation (TC) ou un signal (RM) du contenu kystique. Les valeurs deUHet le modèle de signal détermine si le kyste est simple ou complexe.",
    "bosniak_typicalFindings": "Résultats typiques",
    "bosniak_catI_desc": "Kyste rénal simple. Paroi fine et imperceptible, densité d'eau homogène (−9 à 20UH), sans septa, ni calcification, ni rehaussement interne.",
    "bosniak_catI_finding1": "Paroi mince (≤ 2 mm), lisse, sans rehaussement notable de la paroi",
    "bosniak_catI_finding2": "Teneur en eau homogène (−9 à 20UH) sans septa",
    "bosniak_catI_finding3": "SigneRM: T2 hyperintense, T1 hypointense sans restriction de diffusion",
    "bosniak_catII_desc": "Kyste peu complexe sans rehaussement suspect. Il comprend des kystes avec peu de cloisons fines, de fines calcifications ou un contenu hyperdense sans rehaussement.",
    "bosniak_catII_finding1": "Quelques septa fins (≤ 2 mm) pouvant rehausser",
    "bosniak_catII_finding2": "Calcification de tout type dans une paroi mince ou un septa mince",
    "bosniak_catII_finding3": "Kystes hyperdenses ≥ 70UHou sans amélioration > 20UH",
    "bosniak_catIIF_desc": "Kyste peu complexe nécessitant un suivi. Il a des fonctionnalités légèrement plus complexes queBosniakII, mais sans rehaussement franchement suspect.",
    "bosniak_catIIF_finding1": "Épaississement minimal (3 mm) lisse de la paroi ou du septum avec rehaussement",
    "bosniak_catIIF_finding2": "Multiples cloisons fines (≥ 4) ou complexité modérée",
    "bosniak_catIIF_finding3": "Signal hétérogène en T1 avec saturation de graisse (hyperintense)",
    "bosniak_catIII_desc": "Masse kystique indéterminée. Il présente des signes suspects tels qu'un épaississement irrégulier de la paroi/septum avec rehaussement, mais sans composante clairement nodulaire.",
    "bosniak_catIII_finding1": "Paroi ou septa épais (≥ 4 mm) ou irréguliers avec rehaussement",
    "bosniak_catIII_finding2": "Amélioration mesurable des composants épaissis/irréguliers",
    "bosniak_catIII_finding3": "Pas de nodule mural ou septal clairement défini",
    "bosniak_catIV_desc": "Masse kystique clairement maligne. Contient un ou plusieurs composants nodulaires solides avec rehaussement, indiquant un carcinome rénal jusqu'à preuve du contraire.",
    "bosniak_catIV_finding1": "Rehaussement de nodule(s) mural ou septal (composant solide)",
    "bosniak_catIV_finding2": "Bords nets du nodule (< 90°) avec paroi ou septum",
    "bosniak_catIV_finding3": "Composant améliorant solide, diffusion restreinte",
    "bosniak_protocolTitle": "ProtocoleTCrénal",
    "bosniak_phasePrecontrast": "Phase sans contraste",
    "bosniak_phasePrecontrastDesc": "Mesurer l'atténuation basale du kyste (UH). Clé pour détecter les kystes hyperdenses et calculer le véritable rehaussement.",
    "bosniak_phaseCorticomedullary": "phase corticomédullaire",
    "bosniak_phaseCorticomedullaryDesc": "25 à 70 s après l'injection. Utile pour détecter un rehaussement précoce, mais la phase néphrographique est privilégiée pourBosniak.",
    "bosniak_phaseNephrographic": "Phase néphrographique",
    "bosniak_phaseNephrographicDesc": "80 à 180 s après l'injection. Phase optimale pour évaluer le rehaussement paroi/septale. C'est la phase la plus importante pour la classification.",
    "bosniak_phaseExcretory": "phase excrétrice",
    "bosniak_phaseExcretoryDesc": "≥ 3 minutes. Évaluer la relation avec le système collecteur et exclure la possibilité d’un diverticule caliceal.",
    "bosniak_enhancementCritTitle": "Critères d'amélioration",
    "bosniak_enhanceCrit1": "Véritable amélioration : incrément ≥ 20UHentre phase sans contraste et phase néphrographique",
    "bosniak_enhanceCrit2": "Pseudoamélioration : augmentation < 10UHpar durcissement par diffusion/faisceau, pas de véritable amélioration",
    "bosniak_enhanceCrit3": "Zone grise (10-20UH): considérerRMavec soustraction pour confirmer",
    "bosniak_mriTitle": "Évaluation parRM",
    "bosniak_mriT1": "Avant et aprèsGdavec saturation de graisse. Soustraction obligatoire pour détecter une amélioration subtile.",
    "bosniak_mriT2": "Contenu kystique hyperintense. Les composantes solides sont relativement hypointenses.",
    "bosniak_mriDWI": "Utile en complément. Une restriction de diffusion peut indiquer un composant solide, mais ne remplace pas une amélioration.",
    "bosniak_mriSubtraction": "Soustraction",
    "bosniak_mriSubtractionDesc": "Indispensable dansRM. Soustrait T1 pré-Gddu premier trimestre aprèsGdpour isoler la véritable amélioration du signal intrinsèque T1.",
    "bosniak_pitfallsTitle": "Erreurs de diagnostic courantes",
    "bosniak_pitfall1": "Confondre pseudo-rehaussement dispersé et véritable rehaussement dans les petits kystes (< 2 cm) adjacents au parenchyme",
    "bosniak_pitfall2": "Ne mesurez pas l'atténuation basale sans contraste : impossible de déterminer le véritable rehaussement sans référence.",
    "bosniak_pitfall3": "Classer les kystes hémorragiques/protéinés (hyperdenses) comme complexes lorsqu'ils ne s'améliorent PAS",
    "bosniak_pitfall4": "AppliquerBosniakaux masses contenant > 25 % de composants solides — la classification n'est pas conçue pour les masses solides",
    "bosniak_changesTitle": "ChangementsBosniak2019 par rapport aux précédents",
    "bosniak_change1": "Suppression de catégorieBosniakI contre II basé sur la calcification – la calcification n'affecte plus la catégorie",
    "bosniak_change2": "Nouvelle définition des seuils d'épaisseur : ≤ 2 mm (mince), 3 mm (peu épaissi), ≥ 4 mm (épaisseur)",
    "bosniak_change3": "Constitution formelle deRMcomme une modalité équivalente àTCpour le classement",
    "bosniak_change4": "Il est clairement défini que le nodule mural/septal (composant solide avec rehaussement) =BosniakIV",
    "bosniak_change5": "La règle du « plus haut degré » persiste : la caractéristique individuelle la plus suspecte détermine la catégorie finale",
    "bosniak_indicationsTitle": "Indications",
    "bosniak_indication1": "Masses rénales kystiques accidentelles détectées chezTCsoitRMavec contraste",
    "bosniak_indication2": "Suivi des kystes précédemment classés commeBosniakIIF",
    "bosniak_indication3": "Évaluation préopératoire des masses rénales kystiques complexes pour la planification chirurgicale",
    "bosniak_limitationsTitle": "Limites",
    "bosniak_limitation1": "Ne pas appliquer sur les masses rénales contenant > 25 % de composants solides (utiliser la classification des masses solides).",
    "bosniak_limitation2": "Non valable sans produit de contraste intraveineux — le rehaussement est un pilier fondamental de la classification",
    "bosniak_limitation3": "Exclure les masses d'étiologie infectieuse/inflammatoire connue (abcès, kystes infectés)",
    "bosniak_limitation4": "Non destiné aux masses kystiques d'origine vasculaire (anévrismes,MAVrognons)",
    "bosniak_followUpTitle": "Suivi recommandé",
    "bosniak_followUp12": "Ne nécessite pas de suivi d'image",
    "bosniak_followUpIIF": "TCsoitRMà 6 et 12 mois, puis annuellement pendant 5 ans. Si progrès → reclasser.",
    "bosniak_followUpIII": "Chirurgie partielle/radicale ou surveillance active avec imagerie tous les 6 mois en fonction des comorbidités et des préférences du patient.",
    "bosniak_followUpIV": "Traitement chirurgical (néphrectomie partielle préférée si techniquement réalisable). Biopsie si une confirmation préopératoire est requise.",
    "bosniak_referencesTitle": "Références",
    "garden_classification": "GardenClassification",
    "garden_desc": "Fractures sous-capitales du col du fémur —Garden",
    "garden_criteria": "GardenClassification",
    "garden_description": "Système de classification des fractures sous-capitales du col du fémur basé sur le degré de déplacement des fragments osseux surAPradiographie.",
    "garden_fracturePattern": "Modèle de fracture",
    "garden_trabecularPattern": "Modèle trabéculaire",
    "garden_chooseOne": "Choisissez 1",
    "garden_highestGrade": "La note la plus élevée détermine le classement",
    "garden_selectFeatures": "Sélectionnez les fonctionnalités",
    "garden_displacement": "Déplacement",
    "garden_fractureIncomplete": "Fracture incomplète (impaction valgus, cortex inférieur uniquement)",
    "garden_fractureCompleteNondisplaced": "Fracture complète, non déplacée (les deux cortex sont cassés, alignés)",
    "garden_fractureCompletePartial": "Fracture complète, partiellement déplacée",
    "garden_fractureCompleteFull": "Fracture complète, entièrement déplacée (pas de contact entre fragments)",
    "garden_trabecularAngulated": "Trabécules angulées (impaction valgus)",
    "garden_trabecularInterrupted": "Trabécules interrompues, alignées sur la ligne de fracture",
    "garden_trabecularDisrupted": "Trabécules perturbées avec rotation de la tête fémorale",
    "garden_trabecularNone": "Pas de continuité trabéculaire (séparation complète)",
    "garden_gI_label": "Incomplet / Valgus impacté",
    "garden_gII_label": "Complet, non déplacé",
    "garden_gIII_label": "Complet, partiellement déplacé",
    "garden_gIV_label": "Complet, entièrement déplacé",
    "garden_scoringNote": "La finaleGardenla pente est déterminée par le niveau de déplacement observé. En pratique clinique, les grades I à II (non déplacés) et III à IV (déplacés) sont regroupés pour la prise de décision thérapeutique.",
    "garden_reference": "Référence:",
    "garden_conclusionI": "Fracture sous-capitale du col du fémur classée commeGardenI (fracture incomplète / valgus inclus). Une fixation interne avec des vis canulées est recommandée.",
    "garden_conclusionII": "Fracture sous-capitale du col du fémur classée commeGardenII (fracture complète, non déplacée). Une fixation interne avec des vis canulées est recommandée.",
    "garden_conclusionIII": "Fracture sous-capitale du col du fémur classée commeGardenIII (fracture complète, partiellement déplacée). Une arthroplastie partielle ou totale est recommandée en fonction de l'âge du patient et de son niveau d'activité.",
    "garden_conclusionIV": "Fracture sous-capitale du col du fémur classée commeGardenIV (fracture complète, complètement déplacée). Une arthroplastie partielle ou totale est recommandée en fonction de l'âge du patient et de son niveau d'activité.",
    "garden_clickToInsert": "Cliquez pour insérer la recommandation dans le rapport",
    "garden_toggleHighlight": "Activer/Désactiver la visibilité des surbrillance",
    "eaton_classification": "Eaton-LittlerClassification",
    "eaton_desc": "Arthrose trapézométacarpienne (base du pouce) —Eaton-Littler",
    "eaton_criteria": "Eaton-LittlerClassification",
    "eaton_description": "Système de classification radiologique de l'arthrose trapézo-métacarpienne basé sur le rétrécissement de l'espace articulaire, les ostéophytes, la subluxation et l'arthrose scaphotrapéziotrapézoïdale (STT) participation conjointe.",
    "eaton_jointSpace": "Espace commun",
    "eaton_osteophytes": "Ostéophytes",
    "eaton_subluxation": "Subluxation",
    "eaton_sttJoint": "STTArticulation",
    "eaton_chooseOne": "Choisissez 1",
    "eaton_highestStage": "L'échelon le plus élevé détermine le classement",
    "eaton_selectFeatures": "Sélectionnez les fonctionnalités",
    "eaton_jointNormal": "Espace articulaire normal ou légèrement élargi",
    "eaton_jointSlightNarrowing": "Léger rétrécissement de l’espace articulaire",
    "eaton_jointMarkedNarrowing": "Rétrécissement ou destruction marqué de l’espace articulaire",
    "eaton_jointNarrowingBoth": "Rétrécissement marqué deTMC+STTarticulation",
    "eaton_osteoAbsent": "Pas d'ostéophytes",
    "eaton_osteoSmall": "Petits ostéophytes (< 2 mm)",
    "eaton_osteoLarge": "Ostéophytes > 2 mm, sclérose sous-chondrale/kystes",
    "eaton_osteoBothJoints": "Ostéophytes àTMC+STTarticulations",
    "eaton_subluxMinimal": "Subluxation ≤ 1/3 de la surface articulaire",
    "eaton_subluxSlight": "Légère subluxation deTMCarticulation",
    "eaton_subluxSignificant": "Subluxation importante (> 1/3)",
    "eaton_subluxFixed": "Subluxation deTMC+ déformation d'adduction fixe",
    "eaton_sttNormalI": "STTarticulation normale",
    "eaton_sttNormalII": "STTarticulation normale",
    "eaton_sttNormalIII": "STTarticulation normale",
    "eaton_sttAffected": "STTarticulation touchée (rétrécissement, ostéophytes, sclérose)",
    "eaton_eI_label": "Pré-arthrite",
    "eaton_eII_label": "Arthrose légère",
    "eaton_eIII_label": "Arthrose avancée (TMCseulement)",
    "eaton_eIV_label": "Arthrose pantrapézienne (TMC+STT)",
    "eaton_scoringNote": "La finaleEaton-LittlerLe stade est déterminé par le résultat radiologique le plus grave. Les stades I à II sont généralement gérés de manière conservatrice, tandis que les stades III à IV nécessitent une évaluation chirurgicale.",
    "eaton_reference": "Référence:",
    "eaton_conclusionI": "Arthrose trapézométacarpienne classée commeEaton-LittlerI (stade pré-arthritique). Un traitement conservateur avec attelles, anti-inflammatoires et rééducation est recommandé.",
    "eaton_conclusionII": "Arthrose trapézométacarpienne classée commeEaton-LittlerII (arthrose légère). Un traitement conservateur ou une intervention chirurgicale en fonction des symptômes cliniques est recommandé.",
    "eaton_conclusionIII": "Arthrose trapézométacarpienne classée commeEaton-LittlerIII (avancéTMCarthrose articulaire). Une trapézectomie ou une arthroplastie est recommandée.",
    "eaton_conclusionIV": "Arthrose trapézométacarpienne classée commeEaton-LittlerIV (arthrose pantrapézienne,TMC+STTparticipation). Une arthrodèse ou une arthroplastie totale est recommandée.",
    "snyder_classification": "SnyderClassification",
    "snyder_desc": "Déchirures complètes de la coiffe des rotateurs —Snyder",
    "snyder_criteria": "SnyderClassification",
    "snyder_description": "Système de classification des déchirures complètes de la coiffe des rotateurs (supraspinatus et/ou infraspinatus) basé sur le diamètre de la déchirure antéropostérieure et le nombre de tendons impliqués.",
    "snyder_tearSize": "Taille des larmes (AP)",
    "snyder_tendonCount": "Tendons impliqués",
    "snyder_chooseOne": "Choisissez 1",
    "snyder_highestGrade": "La note la plus élevée détermine le classement",
    "snyder_selectFeatures": "Sélectionnez les fonctionnalités",
    "snyder_tearSmall": "Déchirure pleine épaisseur < 10 mmAPdiamètre",
    "snyder_tearMedium": "Déchirure sur toute l'épaisseur 10 à 20 mmAPdiamètre",
    "snyder_tearLarge": "Déchirure pleine épaisseur > 20 mmAPdiamètre",
    "snyder_tearMassive": "Déchirure totale impliquant ≥ 2 tendons",
    "snyder_tendonSingle": "Tendon unique (supraspinatus ou infraspinatus)",
    "snyder_tendonSingleRetracted": "Tendon unique avec rétraction modérée",
    "snyder_tendonSingleAtrophy": "Tendon unique avec rétraction/atrophie importante",
    "snyder_tendonMultiple": "Deux tendons ou plus impliqués",
    "snyder_sC1_label": "Petite déchirure complète (< 10 mm)",
    "snyder_sC2_label": "Déchirure complète moyenne (10–20 mm)",
    "snyder_sC3_label": "Grande déchirure complète (> 20 mm)",
    "snyder_sC4_label": "Déchirure massive (≥ 2 tendons)",
    "snyder_scoringNote": "La finaleSnyderle grade est déterminé par le résultat le plus grave. C4 est prioritaire lorsque deux tendons ou plus sont impliqués, quelle que soit la taille de la déchirure.",
    "snyder_reference": "Référence:",
    "snyder_conclusionC1": "Déchirure complète de la coiffe des rotateurs classée commeSnyderC1 (petite déchirure, < 10 mmAPdiamètre). Une réparation arthroscopique est recommandée.",
    "snyder_conclusionC2": "Déchirure complète de la coiffe des rotateurs classée commeSnyderC2 (déchirure moyenne, 10–20 mmAPdiamètre). Une réparation arthroscopique ou mini-ouverte est recommandée.",
    "snyder_conclusionC3": "Déchirure complète de la coiffe des rotateurs classée commeSnyderC3 (grande déchirure, > 20 mmAPdiamètre). Une réparation ouverte ou arthroscopique est recommandée en fonction de la rétraction et de la qualité des tissus.",
    "snyder_conclusionC4": "Déchirure complète de la coiffe des rotateurs classée commeSnyderC4 (déchirure massive impliquant deux tendons ou plus). Un transfert de tendon ou une arthroplastie inversée de l’épaule doivent être envisagés.",
    "herbert_classification": "Classification de Herbert-Fisher",
    "herbert_desc": "Fractures du scaphoïde carpien — Herbert-Fisher",
    "herbert_criteria": "Scaphoïde carpien · Herbert et Fisher, 1984",
    "herbert_description": "Classe les fractures du scaphoïde carpien selon leur stabilité et leur évolution (Herbert et Fisher, 1984) et oriente la prise en charge.",
    "herbert_acutePattern": "Fracture aiguë",
    "herbert_instability": "Critère d'instabilité",
    "herbert_chronicity": "Évolution",
    "herbert_chooseOne": "Choisir 1",
    "herbert_optional": "Facultatif",
    "herbert_highestGrade": "Le type le plus sévère détermine la classification",
    "herbert_selectFeatures": "Sélectionnez des caractéristiques",
    "herbert_a1Tubercle": "Fracture du tubercule",
    "herbert_a2WaistNondisplaced": "Taille non déplacée (confirmée par TDM)",
    "herbert_b1DistalOblique": "Oblique du tiers distal",
    "herbert_b2WaistDisplaced": "Taille déplacée ou mobile",
    "herbert_b3ProximalPole": "Pôle proximal",
    "herbert_b4Perilunate": "Fracture-luxation trans-scapho-périlunaire",
    "herbert_b5Comminuted": "Comminutive",
    "herbert_instDisplacement": "Déplacement > 1 mm",
    "herbert_instDisi": "DISI : angle scapholunaire > 60°",
    "herbert_instAngle": "Angle intrascaphoïdien latéral > 35°",
    "herbert_instComminution": "Comminution",
    "herbert_instPerilunate": "Partie d'une lésion périlunaire",
    "herbert_cDelayed": "Retard de consolidation",
    "herbert_d1Fibrous": "Pseudarthrose fibreuse (pôle proximal habituellement viable)",
    "herbert_d2Mobile": "Pseudarthrose mobile",
    "herbert_d3Sclerotic": "Pseudarthrose scléreuse, avec perte de substance et déformation en bosse",
    "herbert_d4Avn": "Nécrose avasculaire avec collapsus et perte de l'architecture",
    "herbert_extB3a": "Angle scapholunaire < 60°",
    "herbert_extB3b": "Angle scapholunaire > 60°",
    "herbert_extShortLt2": "Raccourcissement < 2 mm",
    "herbert_extShortGt2": "Raccourcissement > 2 mm",
    "herbert_extSlac": "Avec altérations SLAC",
    "herbert_tA_label": "Aiguë stable",
    "herbert_tB_label": "Aiguë instable",
    "herbert_tC_label": "Retard de consolidation",
    "herbert_tD_label": "Pseudarthrose établie",
    "herbert_recA": "Traitement conservateur ou fixation percutanée.",
    "herbert_recB": "Fixation chirurgicale.",
    "herbert_recC": "Chirurgie, souvent avec greffe osseuse.",
    "herbert_recD": "Chirurgie, souvent avec greffe osseuse.",
    "herbert_scoringNote": "Le type final est déterminé par la lésion la plus sévère. L'un quelconque de ces critères rend la fracture aiguë instable (B) : déplacement > 1 mm, angle scapholunaire > 60° (DISI), angle intrascaphoïdien latéral > 35°, comminution ou lésion périlunaire. Le pôle proximal (B3) est toujours instable en raison de sa vascularisation rétrograde. Confirmer A2 par rapport à B2 par TDM.",
    "herbert_reference": "Référence :",
    "herbert_conclusion": "Fracture du scaphoïde carpien classée Herbert {{subtype}} ({{label}}). {{recommendation}}",
    "tnm_lung_classification": "TNMClassification des poumons",
    "tnmLungName": "TNMPoumon",
    "tnm_lung_desc": "Cancer du poumon non à petites cellules —TNM7ème édition",
    "tnm_lung_criteria": "TNMClassification des poumons",
    "tnm_lung_description": "Système de classification du cancer du poumon non à petites cellules basé sur les descripteurs de la tumeur primaire (T), des ganglions lymphatiques régionaux (N) et des métastases à distance (M), selon le 7eTNMÉdition (IASLC/UICC/AJCC, 2010).",
    "tnm_lung_tumorDescriptor": "Tumeur primaire (T)",
    "tnm_lung_nodeDescriptor": "Ganglions lymphatiques régionaux (N)",
    "tnm_lung_metastasisDescriptor": "Métastase à distance (M)",
    "tnm_lung_chooseOne": "Choisissez 1",
    "tnm_lung_stageGrouping": "Détermination de l'étape",
    "tnm_lung_stage": "Scène",
    "tnm_lung_selectDescriptors": "Sélectionnez les descripteurs T, N et M",
    "tnm_lung_survival5y": "Survie à 5 ans",
    "tnm_lung_scoringNote": "La finaleTNMle stade est déterminé en combinant les descripteurs T, N et M. Si M1 est présent, le stade est toujours IV quels que soient T et N.",
    "tnm_lung_reference": "Référence:",
    "tnm_lung_tTX": "TX — La tumeur primaire ne peut pas être évaluée",
    "tnm_lung_tT0": "T0 – Aucun signe de tumeur primitive",
    "tnm_lung_tTis": "Tis — Carcinome in situ",
    "tnm_lung_tT1a": "T1a — Tumeur ≤ 2 cm",
    "tnm_lung_tT1b": "T1b — Tumeur > 2 cm et ≤ 3 cm",
    "tnm_lung_tT2a": "T2a — Tumeur > 3 cm et ≤ 5 cm",
    "tnm_lung_tT2b": "T2b — Tumeur > 5 cm et ≤ 7 cm",
    "tnm_lung_tT3": "T3 — Tumeur > 7 cm, ou invasion de la paroi thoracique/du diaphragme/du nerf phrénique, ou même nodule(s) lobaire(s)",
    "tnm_lung_tT4": "T4 — Invasion du médiastin, du cœur, des gros vaisseaux, de la trachée, de la carène, de l'œsophage, du corps vertébral ; ou nodule(s) lobaire(s) différent(s) homolatéral(s)",
    "tnm_lung_nNX": "NX — Les ganglions lymphatiques régionaux ne peuvent pas être évalués",
    "tnm_lung_nN0": "N0 — Aucune métastase ganglionnaire régionale",
    "tnm_lung_nN1": "N1 — Métastases ganglionnaires péribronchiques/hilaires homolatérales",
    "tnm_lung_nN2": "N2 — Métastases ganglionnaires médiastinales/sous-carinales homolatérales",
    "tnm_lung_nN3": "N3 — Métastases médiastinales/hilaires, scalènes ou ganglionnaires supraclaviculaires controlatérales",
    "tnm_lung_mM0": "M0 — Pas de métastase à distance",
    "tnm_lung_mM1a": "M1a — Nodule(s) pulmonaire(s) controlatéral(s), épanchement pleural/péricardique malin",
    "tnm_lung_mM1b": "M1b — Métastases à distance (extrathoraciques)",
    "tnm_lung_conclusionOculto": "Cancer du poumon classé comme occulte (TX N0 M0). Un bilan supplémentaire est recommandé.",
    "tnm_lung_conclusion0": "Cancer du poumon classé au stade 0 (Tis N0 M0, carcinome in situ). Une résection chirurgicale est recommandée.",
    "tnm_lung_conclusionIA": "Le cancer du poumon classé comme stadeIA(T1a-T1bN0M0). Une résection chirurgicale (lobectomie) est recommandée. Survie à 5 ans : 73 %.",
    "tnm_lung_conclusionIB": "Cancer du poumon classé au stade IB (T2a N0 M0). Une résection chirurgicale ± une chimiothérapie adjuvante est recommandée. Survie à 5 ans : 58 %.",
    "tnm_lung_conclusionIIA": "Cancer du poumon classé stade IIA (T1-T2a N1, T2b N0). Une résection chirurgicale associée à une chimiothérapie adjuvante est recommandée. Survie à 5 ans : 46 %.",
    "tnm_lung_conclusionIIB": "Cancer du poumon classé au stade IIB (T2b N1, T3 N0). Une résection chirurgicale associée à une chimiothérapie adjuvante est recommandée. Survie à 5 ans : 36 %.",
    "tnm_lung_conclusionIIIA": "Cancer du poumon classé stade IIIA (T1-T2 N2, T3 N1-N2, T4 N0-N1). Une chimioradiothérapie avec évaluation chirurgicale est recommandée. Survie à 5 ans : 24 %.",
    "tnm_lung_conclusionIIIB": "Cancer du poumon classé au stade IIIB (T4 N2, Any T N3). Une chimioradiothérapie est recommandée. Survie à 5 ans : 9 %.",
    "tnm_lung_conclusionIV": "Cancer du poumon classé au stade IV (Any T, Any N, M1). Une thérapie systémique (chimiothérapie/ciblée/immunothérapie) est recommandée. Survie à 5 ans : 13 %.",
    "tnm_lung_matrixTitle": "Matrice de mise en scène (T × N)",
    "tnm_lung_matrixDesc": "Etape résultant de la combinaison des descripteurs T et N lorsque M = M0. Si M1a ou M1b est présent, le stade est toujours IV quels que soient T et N.",
    "tnm_lung_matrixM1Note": "N’importe quel T, n’importe quel N – toujours Stade IV",
    "tnm_lung_matrixOccult": "Occulte",
    "smartBarPlaceholder": "Tapez ici...",
    "noCommandsUnderstood": "Je n'ai pas bien compris ce que tu voulais que je fasse. Pourriez-vous être plus précis, s'il vous plaît ?",
    "bold": "Audacieux",
    "italic": "Italique",
    "underline": "Souligner",
    "textColor": "Couleur du texte",
    "custom": "Coutume",
    "untitled": "Rapport sans titre",
    "facturationRate": "Facturation hebdomadaire",
    "billedReports": "rapports facturés",
    "vsLastWeek": "vs la semaine dernière",
    "weeklyCompletionRate": "Rapports hebdomadaires",
    "activitySummary": "Résumé d'activité",
    "viewMoreStats": "Voir plus de statistiques",
    "avgEditTime": "Temps moyen par rapport",
    "avgEditTimeSub": "{{count}} rapports cette semaine",
    "avgEditTimeEmpty": "Aucune donnée d'édition",
    "countDrafts": "{{count}} brouillons",
    "countBatches": "{{count}} lots",
    "countSent": "{{count}} envoyés",
    "countShared": "{{count}} partagés",
    "workHistoryTitle": "Historique de travail",
    "viewGroupWorkHistory": "Voir l'historique de travail du groupe",
    "sent": "Envoyés",
    "moreStats": "Voir toutes les statistiques",
    "moreStatsDesc": "Analysez votre productivité et vos tendances",
    "versionHistory": "Historique des versions",
    "closePanel": "Fermer le panneau",
    "saveDocToSeeHistory": "Enregistrez le document pour voir l'historique.",
    "noVersionsSaved": "Aucune version enregistrée pour le moment.",
    "restoring": "Restauration…",
    "restoreThisVersion": "Restaurer cette version",
    "loadMore": "Charger plus",
    "comparingDiffs": "Comparer les différences",
    "exitPreview": "Quitter l'aperçu",
    "versionRestored": "Version restaurée",
    "versionRestoreError": "Impossible de restaurer la version",
    "triggerAutosave": "Sauvegarde automatique",
    "triggerManualSave": "Sauvegarde manuelle",
    "triggerAiGeneration": "Génération d'IA",
    "triggerVoiceCommand": "Commande vocale",
    "triggerMagicWrite": "Écriture magique",
    "triggerTemplateInserted": "Modèle inséré",
    "triggerTemplateChange": "Changement de modèle",
    "sourceMagicWriting": "Écriture magique",
    "sourceManual": "Manuel",
    "sourceDictation": "Dictée",
    "triggerVersionRestored": "Version restaurée",
    "standardTemplateHint": "Tu n'as indiqué aucun modèle, j'ai donc utilisé le modèle standard.\n Si tu veux, dis-moi quel modèle utiliser et je l'appliquerai aussitôt.\n Par exemple : « Utilise le modèle de TDM du thorax. Dans le parenchyme pulmonaire on identifie... ».",
    "patientData": "Données des patients",
    "patientHistory": "Antécédents du patient",
    "closePatientPanel": "Fermer le panneau patient",
    "demographics": "Données démographiques",
    "birth": "Naissance",
    "age": "Âge",
    "sex": "Sexe",
    "studySection": "Étude",
    "date": "Date",
    "descriptionLabel": "Description",
    "clinic": "Clinique",
    "reportHistory": "Historique du rapport",
    "signed": "Signé",
    "reportIssueTitle": "Signaler un problème",
    "reportIssueThanks": "Merci pour votre rapport!",
    "reportIssueReview": "Nous l’examinerons dès que possible et travaillerons à sa résolution.",
    "reportIssueDescribe": "Décrivez le problème",
    "reportIssuePlaceholder": "Décrivez en détail ce qui s'est passé, sur quel écran ou action et comment le reproduire...",
    "reportIssueSendError": "Impossible d'envoyer le problème. Veuillez réessayer.",
    "reportIssueConsent": "Je suis d'accord que leAinovisl'équipe peut me contacter pour plus de détails",
    "reportIssueDisclaimer": "Nous utiliserons ces informations uniquement pour améliorer notre outil et résoudre le problème signalé.",
    "reportIssueSubmit": "Soumettre le rapport",
    "menuFile": "Déposer",
    "menuInsert": "Insérer",
    "menuClassifications": "Classement",
    "menuTemplates": "Modèles",
    "menuSupport": "Soutien",
    "menuCopy": "Copie",
    "menuShare": "Partager",
    "menuVersionHistory": "Historique des versions",
    "menuDownloadPdf": "Télécharger en tant quePDF",
    "menuPrint": "Imprimer",
    "menuRename": "Rebaptiser",
    "menuDelete": "Supprimer",
    "menuLanguage": "Langue",
    "menuImage": "Image",
    "menuTable": "Tableau",
    "insertTable": "Insérer un tableau",
    "menuDivider": "Ligne de séparation",
    "menuChart": "Graphique",
    "menuShortcuts": "Raccourcis clavier",
    "menuAskCarolina": "Demander à Carolina",
    "menuReportIssue": "Signaler un problème",
    "menuExploreTemplates": "Explorer les modèles",
    "menuUseAinovisTemplates": "Utiliser les modèles Ainovis",
    "menuCreateTemplate": "Créer un modèle",
    "saveAsTemplate": "Enregistrer comme modèle",
    "templateNameInvalid": "Le nom ne peut contenir que des lettres, des chiffres, des espaces, des traits d'union, des apostrophes et des points",
    "templateNameAinovis": "UnAinovisun modèle portant ce nom existe déjà. Veuillez choisir un autre nom.",
    "templateNameGroup": "Le nom du modèle ne peut pas contenir le nom de votre groupe.",
    "templateName": "Nom du modèle",
    "contentCopiedToClipboard": "Contenu copié dans le presse-papiers",
    "errorCopyingContent": "Impossible de copier le contenu",
    "noSavedDocToDelete": "Aucun document enregistré à supprimer.",
    "deleteDocumentTitle": "Supprimer le document",
    "confirmDeleteDocument": "Êtes-vous sûr de vouloir supprimer ce document ? Cette action ne peut pas être annulée.",
    "documentDeleted": "Document supprimé avec succès.",
    "errorDeletingDocument": "Impossible de supprimer le document.",
    "errorDeleteForbidden": "Vous n'avez pas l'autorisation de supprimer ce brouillon.",
    "draftNoAccessTitle": "Vous n'avez pas accès à ce brouillon",
    "draftNoAccessMessage": "Demandez à son auteur de le partager avec vous.",
    "draftNotFoundTitle": "Ce brouillon n'existe pas",
    "draftNotFoundMessage": "Son auteur l'a peut-être supprimé.",
    "noContentToExport": "Aucun contenu à exporter.",
    "browserBlockedPopup": "Le navigateur a bloqué la fenêtre contextuelle.",
    "saveTemplate": "Enregistrer le modèle",
    "backToReports": "Retour aux rapports",
    "untitledTemplate": "Modèle sans titre",
    "templateTitleRequired": "Vous devez ajouter un titre au modèle",
    "actionVersions": "Versions",
    "actionPatients": "Patients",
    "actionReportsHistory": "Rapports précédents",
    "patientsSidebarTitlePatient": "Détails du patient",
    "patientsSidebarTitleHistory": "Antécédents du patient",
    "patientsSidebarClose": "Fermer le panneau patient",
    "patientsSidebarNotConnected": "Non connecté",
    "patientsSidebarTabPatient": "Détails du patient",
    "patientsSidebarTabHistory": "Historique du rapport",
    "patientsSidebarSectionDemographics": "Données démographiques",
    "patientsSidebarSectionStudy": "Étude en cours",
    "patientsSidebarSectionClinical": "Clinique",
    "patientsSidebarLabelBirth": "Date de naissance",
    "patientsSidebarLabelAge": "Âge",
    "patientsSidebarLabelSex": "Sexe",
    "patientsSidebarLabelModality": "Modalité",
    "patientsSidebarLabelDate": "Date",
    "patientsSidebarLabelAccession": "Numéro d'accession",
    "patientsSidebarLabelDescription": "Description",
    "patientsSidebarLabelReferring": "Médecin référent",
    "patientsSidebarLabelReason": "Motif de la demande",
    "patientsSidebarAddReason": "Ajouter un motif de demande",
    "patientsSidebarAddReasonShort": "Ajouter",
    "patientsSidebarReasonHint": "Vous devez être connecté à un système externe (RIS/PACS) pour activer cette fonctionnalité.",
    "patientsSidebarStudyUid": "ÉtudeUID",
    "patientsSidebarSexMale": "Mâle",
    "patientsSidebarSexFemale": "Femelle",
    "patientsSidebarYearsOld": "{{years}}années",
    "patientsSidebarNoPatientName": "Patient anonyme",
    "patientsSidebarReportFallbackTitle": "Rapport",
    "patientsSidebarNoReport": "Aucun rapport",
    "patientsSidebarHistoryEmpty": "Aucun rapport précédent disponible",
    "patientsSidebarHistoryUnread": "Les rapports n'ont pas pu être chargés",
    "patientsSidebarHistoryCount": "{{studies}}études ·{{reports}}rapports",
    "patientSummaryButton": "Résumer",
    "patientSummaryButtonHint": "Résumé des comptes rendus antérieurs généré par Carolina",
    "patientSummaryTitle": "Résumé du patient",
    "patientSummaryRegenerate": "Régénérer",
    "patientSummaryCollapse": "Replier le résumé",
    "patientSummaryExpand": "Déplier le résumé",
    "patientSummaryShowMore": "Tout afficher",
    "patientSummaryShowLess": "Afficher moins",
    "patientSummaryStepAnalyzing": "Analyse des comptes rendus antérieurs ({{count}})…",
    "patientSummaryStepWriting": "Rédaction du résumé…",
    "patientSummaryNoPriors": "Aucun compte rendu antérieur avec du texte ne peut être analysé.",
    "patientSummaryNoFindings": "Aucun antécédent pertinent n'a été trouvé dans les comptes rendus antérieurs.",
    "patientSummaryStale": "Les comptes rendus antérieurs ont changé depuis la génération de ce résumé.",
    "patientSummaryRetry": "Réessayer",
    "patientSummaryErrorGeneric": "Le résumé n'a pas pu être généré.",
    "patientSummaryErrorTimeout": "Le résumé a pris trop de temps. Veuillez réessayer.",
    "patientSummaryErrorLimits": "Il y a trop de comptes rendus antérieurs pour les résumer en une seule fois.",
    "patientSummaryErrorUnavailable": "Le service de résumé n'est pas disponible pour le moment.",
    "patientSummaryDisclaimer": "Généré par Carolina à {{time}} · Vérifiez les références",
    "patientSummaryReferences": "Références ({{count}})",
    "patientSummaryViewInReport": "Voir dans le compte rendu",
    "actionAiAssistant": "Assistant IA",
    "actionMicQr": "Micro du téléphone",
    "micQrSidebarTitle": "Micro du téléphone",
    "micQrSidebarClose": "Fermer le panneau micro",
    "micQrStep1": "Ouvrez l'appareil photo du téléphone.",
    "micQrStep2": "Scannez le code QR.",
    "micQrStep3": "Autorisez l'accès au microphone.",
    "micQrStep4": "Appuyez sur le bouton d'enregistrement.",
    "micQrNeedsPermission": "Autorisez l'accès au microphone sur le téléphone avant d'enregistrer.",
    "micQrLoading": "Génération du code…",
    "micQrError": "Impossible de créer le code. Réessayez.",
    "micQrExpired": "Le code a expiré",
    "micQrExpiresIn": "Expire dans {{minutes}} min",
    "micQrHttpsHint": "Le téléphone a besoin de HTTPS (ou localhost) pour utiliser le micro.",
    "micQrRefresh": "Générer un autre code",
    "micQrWaiting": "En attente du téléphone…",
    "micQrStartRemote": "Connecté au microphone du téléphone. Appuyez pour enregistrer.",
    "micQrConnected": "Téléphone connecté",
    "micQrConnectedHint": "Appuyez sur le bouton d'enregistrement.",
    "micQrDisconnect": "Déconnecter",
    "useTemplate": "Utiliser un modèle",
    "newChat": "Nouvelle discussion",
    "closeAiPanel": "Fermer le panneau IA",
    "aiHeroText": "Posez-moi toutes vos questions surAinovis",
    "aiPlaceholder": "Écrire un message...",
    "aiErrorMessage": "Désolé, je n'ai pas pu traiter votre question. Veuillez réessayer.",
    "aiQuestion1": "Comment générer un rapport avec la SmartBar ?",
    "aiQuestion2": "Comment démarrer la dictée vocale ?",
    "aiQuestion3": "Quelles classifications médicales puis-je utiliser ?",
    "toolbarParagraphStyle": "Style de paragraphe",
    "toolbarFontFamily": "Police",
    "toolbarStyleNormal": "Texte normal",
    "toolbarStyleH1": "En-tête 1",
    "toolbarStyleH2": "En-tête 2",
    "toolbarStyleH3": "En-tête 3",
    "toolbarStyleH4": "En-tête 4",
    "toolbarStyleH5": "En-tête 5",
    "toolbarApplyStyleToAll": "Appliquer à tous : « {{style}} »",
    "toolbarBold": "Gras (Ctrl+B)",
    "toolbarItalic": "Italique (Ctrl+I)",
    "toolbarUnderline": "Souligner (Ctrl+U)",
    "toolbarStrikethrough": "Barré",
    "toolbarTextColor": "Couleur du texte",
    "toolbarHighlightColor": "Couleur de surbrillance",
    "toolbarHighlight": "Surbrillance",
    "toolbarNoColor": "Aucune",
    "toolbarPresetColors": "Couleurs prédéfinies",
    "toolbarCustomColors": "Couleurs personnalisées",
    "toolbarAddCustomColor": "Couleur personnalisée...",
    "toolbarAlignLeft": "Aligner à gauche",
    "toolbarAlignCenter": "Centre",
    "toolbarAlignRight": "Aligner à droite",
    "toolbarJustify": "Justifier",
    "toolbarBulletList": "Liste à puces",
    "toolbarNumberedList": "Liste numérotée",
    "toolbarLineSpacing": "Espacement des lignes",
    "toolbarRemoveSpaceBefore": "Supprimer l'espace avant le paragraphe",
    "toolbarAddSpaceBefore": "Ajouter un espace avant le paragraphe",
    "toolbarRestoreSpaceAfter": "Restaurer l'espace après le paragraphe",
    "toolbarRemoveSpaceAfter": "Supprimer l'espace après le paragraphe",
    "toolbarCustomSpacing": "Espacement personnalisé…",
    "toolbarKeepWithNext": "Continuer avec le suivant",
    "toolbarKeepLinesTogether": "Gardez les lignes ensemble",
    "toolbarAvoidOrphans": "Évitez les lignes orphelines",
    "toolbarPageBreakBefore": "Ajouter un saut de page avant",
    "toolbarDecreaseSize": "Diminuer la taille",
    "toolbarIncreaseSize": "Augmenter la taille",
    "toolbarAlignment": "Alignement",
    "toolbarSingleSpacing": "Célibataire",
    "toolbarDoubleSpacing": "Double",
    "toolbarZoom": "Zoom",
    "toolbarZoomOut": "Zoom arrière",
    "toolbarZoomIn": "Zoomer",
    "toolbarUndo": "Annuler (Ctrl+Z)",
    "toolbarRedo": "Refaire (Ctrl+Y)",
    "toolbarMoreOptions": "Plus d'options de formatage",
    "toolbarFindingsMode": "Mode Résultats",
    "toolbarFindingsFirst": "Les constatations d’abord",
    "toolbarFindingsFirstDesc": "Les résultats sont placés au-dessus des résultats normaux",
    "toolbarFindingsInside": "Constatations dans le texte",
    "toolbarFindingsInsideDesc": "Les résultats sont intégrés dans le corps du rapport",
    "toolbarHighlightFindings": "Mettre en évidence les résultats",
    "toolbarLineSpacingSingle": "Célibataire",
    "toolbarLineSpacingDouble": "Double",
    "toolbarLanguagePlaceholder": "Langue"
  },
  "inconsistencies": {
    "label": "Incohérence",
    "show": "Montrer",
    "hide": "Rejeter",
    "mixedLateralityTerm": "Latéralités mixtes",
    "mixedLateralityReason": "Différentes latéralités (DROITE et GAUCHE) ont été détectées dans la même étude. Veuillez vérifier si cela est correct.",
    "missingLateralityTerm": "Latéralité manquante",
    "missingLateralityReason": "La procédure nécessite une latéralité mais aucune (droite ou gauche) n’a été détectée dans la technique."
  },
  "settings": {
    "title": "Paramètres",
    "subtitle": "Personnaliser la langue et le format du rapport",
    "profile": "Profil",
    "account": "Compte",
    "preferences": "Préférences",
    "language": "Langue",
    "languageDescription": "Sélectionnez la langue de l'interface utilisateur",
    "theme": "Thème",
    "themeDescription": "Choisissez le thème de couleur de l'application",
    "themeOptions": {
      "light": "Lumière",
      "dark": "Sombre",
      "system": "Système"
    },
    "notifications": "Notifications",
    "security": "Sécurité",
    "changePassword": "Changer le mot de passe",
    "currentPassword": "Mot de passe actuel",
    "privacyPolicy": "Politique de confidentialité",
    "termsOfService": "Conditions d'utilisation",
    "audio": "Audio",
    "audioDescription": "Configurer le périphérique d'entrée audio pour la dictée",
    "audioDevice": "Périphérique audio",
    "audioDeviceDescription": "Sélectionnez le microphone que vous souhaitez utiliser pour la dictée",
    "selectMicrophone": "Sélectionnez le microphone",
    "selectedDevice": "Appareil sélectionné",
    "microphone": "Microphone",
    "onboarding": "Tutoriel",
    "onboardingDescription": "Consulter à nouveau le didacticiel d'application",
    "onboardingText": "Si vous souhaitez revoir le didacticiel guidé, cliquez sur le bouton pour le réactiver. Il s'affichera la prochaine fois que vous accéderez aux écrans correspondants.",
    "onboardingButton": "Réactiver le tutoriel",
    "onboardingResetSuccess": "Tutoriel réactivé avec succès",
    "session": "Session",
    "sessionDescription": "Gérer votre session en cours",
    "logoutText": "Lorsque vous vous déconnecterez, vous serez redirigé vers la page de connexion",
    "signature": "Signature",
    "signatureDescription": "Écrivez le texte qui sera inséré lorsque vous signez un compte rendu",
    "defaultSignatureName": "Dr Premier Dernier",
    "signedBy": "Signé par",
    "colegiadoLabel": "Nº d'ordre",
    "signatureHint": "Configurez votre numéro d'ordre et votre titre professionnel dans la section d'administration des utilisateurs.",
    "signatureSaved": "Signature enregistrée",
    "deleteSignature": "Supprimer la signature",
    "generateSignature": "Générer une signature",
    "ainovisTemplates": "Modèles Ainovis",
    "ainovisTemplatesDescription": "Utilisez les modèles prédéfinis d'Ainovis lors de la génération des comptes rendus",
    "ainovisTemplatesText": "Activez cette option pour utiliser les modèles Ainovis. Si vous la désactivez, seuls vos modèles personnels seront utilisés."
  },
  "users": {
    "professionalTitle": "Titre",
    "professionalTitlePlaceholder": "Dr, Dre, etc.",
    "practitionerIdentifier": "Nº d'ordre",
    "practitionerIdentifierPlaceholder": "Ex: 282812345",
    "practitionerIdentifierSystem": "Système d'identification",
    "practitionerIdentifierSystemPlaceholder": "URI de l'ordre ou du registre professionnel",
    "title": "Utilisateurs",
    "user": "utilisateur",
    "usersPlural": "utilisateurs",
    "userList": "Liste des utilisateurs",
    "addUser": "Ajouter un utilisateur",
    "editUser": "Modifier l'utilisateur",
    "deleteUser": "Supprimer un utilisateur",
    "userDetails": "Détails de l'utilisateur",
    "newUser": "Nouvel utilisateur",
    "management": "Gestion des utilisateurs",
    "subtitle": "Gérer et afficher les informations utilisateur du système",
    "searchPlaceholder": "Recherche par nom, email ou code...",
    "sortBy": "Trier par",
    "defaultSort": "Par défaut (Nom)",
    "nameAsc": "Nom (A-Z)",
    "nameDesc": "Nom (Z-A)",
    "surnameAsc": "Prénom (A-Z)",
    "emailAsc": "Email (A-Z)",
    "emailDesc": "Email (Z-A)",
    "roleAsc": "Rôle (A-Z)",
    "roleDesc": "Rôle (Z-A)",
    "noUsers": "Aucun utilisateur disponible",
    "showing": "Affichage",
    "of": "de",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "role": "Rôle",
    "roleSuper": "Super",
    "roleAdmin": "Administrateur",
    "roleSupervisor": "Superviseur",
    "roleUser": "Utilisateur",
    "status": "Statut",
    "active": "Actif",
    "inactive": "Inactif",
    "verified": "Vérifié",
    "pending": "En attente",
    "lastLogin": "Dernière connexion",
    "createSuccess": "Utilisateur créé avec succès",
    "createError": "Erreur lors de la création de l'utilisateur",
    "updateSuccess": "L'utilisateur a été mis à jour avec succès",
    "deleteSuccess": "Utilisateur supprimé avec succès",
    "notVerified": "Utilisateur non vérifié",
    "notVerifiedDescription": "Cet utilisateur n'a pas encore vérifié son adresse e-mail.",
    "resendVerification": "Renvoyer l'e-mail de vérification",
    "resending": "Renvoi...",
    "emailSentSuccess": "E-mail envoyé avec succès",
    "basicInfo": "Informations de base",
    "personalInfo": "Informations personnelles",
    "assignments": "Missions",
    "code": "Code",
    "primaryEmail": "E-mail principal",
    "secondaryEmail": "E-mail secondaire",
    "nationalId": "Carte d'identité nationale",
    "birthDate": "Date de naissance",
    "address": "Adresse",
    "account": "Compte",
    "notSpecified": "Non spécifié",
    "required": "*",
    "optional": "(facultatif)",
    "namePlaceholder": "Prénom de l'utilisateur",
    "surnamePlaceholder": "Nom de famille de l'utilisateur",
    "emailPlaceholder": "utilisateur@exemple.com",
    "email2Placeholder": "optionnel@exemple.com",
    "searchAccountPlaceholder": "Rechercher un compte...",
    "roleRadiologist": "Radiologue",
    "roleRadiologistDesc": "Accès de base au système",
    "roleSupervisorDesc": "Supervise et examine les rapports",
    "roleAdminDesc": "Gère les utilisateurs dans leur compte",
    "roleSuperDesc": "Accès complet au système",
    "nameRequired": "Le prénom est obligatoire",
    "nameMinLength": "Le prénom doit comporter au moins 2 caractères",
    "nameMaxLength": "Le prénom est trop long (maximum 100 caractères)",
    "nameInvalidChars": "Le prénom contient des caractères invalides",
    "surnameRequired": "Le nom de famille est obligatoire",
    "surnameMinLength": "Le nom de famille doit comporter au moins 2 caractères",
    "surnameMaxLength": "Le nom de famille est trop long (maximum 100 caractères)",
    "surnameInvalidChars": "Le nom de famille contient des caractères non valides",
    "emailRequired": "L'e-mail est requis",
    "emailInvalid": "Le format de l'e-mail n'est pas valide",
    "emailMaxLength": "L'e-mail est trop long (maximum 255 caractères)",
    "email2Invalid": "Le format de l'e-mail secondaire n'est pas valide",
    "email2MaxLength": "L'e-mail secondaire est trop long (maximum 255 caractères)",
    "roleRequired": "Le rôle est requis",
    "accountRequired": "Un compte est requis",
    "saving": "Économie...",
    "create": "Créer un utilisateur",
    "createWithoutInvite": "Créer sans inviter",
    "update": "Mise à jour"
  },
  "accounts": {
    "moreActions": "Plus d'actions",
    "noLicenseLimits": "Aucune limite de licences",
    "modifiedOn": "Modifiée · {{date}}",
    "title": "Comptes",
    "account": "compte",
    "accountsPlural": "comptes",
    "accountList": "Liste des comptes",
    "addAccount": "Ajouter un compte",
    "editAccount": "Modifier le compte",
    "accountDetails": "Détails du compte",
    "accountName": "Nom du compte",
    "accountType": "Type de compte",
    "newAccount": "Nouveau compte",
    "management": "Gestion des comptes",
    "subtitle": "Gérer les hôpitaux, les utilisateurs et les licences",
    "searchPlaceholder": "Rechercher par nom ou @domaine...",
    "sortBy": "Trier par",
    "defaultSort": "Par défaut (mis à jour)",
    "nameAsc": "Nom (A-Z)",
    "nameDesc": "Nom (Z-A)",
    "newestFirst": "Le plus récent en premier",
    "oldestFirst": "Le plus ancien en premier",
    "recentlyModified": "Récemment modifié",
    "notModified": "Non modifié",
    "noAccounts": "Aucun compte trouvé",
    "tryDifferentSearch": "Essayez différents termes de recherche",
    "createFirstAccount": "Créez votre premier compte pour commencer",
    "page": "Page",
    "of": "de",
    "domains": "Domaines de messagerie",
    "noDomains": "Aucun domaine configuré",
    "licenseLimits": "Limites de licence",
    "administrators": "Administrateurs",
    "supervisors": "Superviseurs",
    "radiologists": "Radiologues",
    "unlimited": "Illimité",
    "metadata": "Métadonnées",
    "createdAt": "Créé à",
    "updatedAt": "Mis à jour à",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce compte ?",
    "deleteWarning": "Cette action ne peut pas être annulée et supprimera toutes les données associées.",
    "deletion": {
      "title": "Supprimer le compte {{name}}",
      "lead": "La suppression entraîne tout ce qui dépend du compte. Elle est irréversible.",
      "loading": "Calcul de la portée...",
      "planFailed": "Impossible de calculer la portée de la suppression.",
      "groups": "groupes",
      "usersToDelete": "utilisateurs seront supprimés",
      "usersToDeactivate": "utilisateurs seront désactivés (ils ont un historique clinique)",
      "gateways": "passerelles seront désactivées dans le Hub",
      "hubUnreachable": "Le Hub d'intégration ne répond pas. Le compte ne peut pas être supprimé sans désactiver d'abord ses passerelles.",
      "confirm": "Supprimer en cascade",
      "success": "Compte supprimé : {{groups}} groupes, {{deleted}} utilisateurs supprimés et {{deactivated}} désactivés."
    },
    "deleteSuccess": "Compte supprimé avec succès",
    "createSuccess": "Compte créé avec succès",
    "updateSuccess": "Compte mis à jour avec succès",
    "nameRequired": "Le nom est requis",
    "invalidNumber": "Doit être un nombre positif",
    "invalidDomain": "Format invalide. Doit être comme @domain.com",
    "domainExists": "Ce domaine a déjà été ajouté",
    "addDomain": "Ajouter un domaine",
    "domainPlaceholder": "@exemple.com",
    "optional": "(Facultatif, laissez vide pour illimité)",
    "generalInfo": "Informations générales",
    "additionalInfo": "Informations Complémentaires",
    "creationDate": "Date de création",
    "lastUpdate": "Dernière mise à jour",
    "deleteAccount": "Supprimer le compte ?",
    "deleteAccountMessage": "Cette action supprimera définitivement le compte{name}et ne peut pas être annulé.",
    "cancel": "Annuler",
    "confirmDelete": "Oui, supprimer",
    "accountNameField": "Nom du compte",
    "requiredField": "*",
    "domainsDescription": "Ajouter des domaines de messagerie autorisés pour ce compte",
    "domainInputPlaceholder": "Par exemple : @hospital.com",
    "limitsDescription": "Définir le nombre maximum d'utilisateurs par rôle",
    "maxAdmins": "Nombre maximum d'administrateurs",
    "maxSupervisors": "Nombre maximum de superviseurs",
    "maxRadiologists": "Maximum de radiologues",
    "distributorTitle": "Distributeur",
    "distributorDescription": "Sélectionnez le distributeur associé à ce compte. Vous pouvez créer de nouveaux distributeurs.",
    "distributor": "Distributeur",
    "hierarchy": {
      "title": "Structure de l'organisation",
      "manage": "Gérer l'organisation",
      "manageHint": "Groupes, équipe, modèles institutionnels et politiques, dans le panneau d'organisation."
    },
    "distributorDefault": "Par défaut",
    "distributorCreate": "Créer un distributeur…",
    "distributorCreatePlaceholder": "Ex. : NOUVEAU_DISTRIBUTEUR",
    "distributorNameRequired": "Saisissez un nom valide"
  },
  "groups": {
    "management": "Gestion du groupe",
    "subtitle": "Gérer les groupes médicaux de la plateforme",
    "newGroup": "Nouveau groupe",
    "editGroup": "Modifier le groupe",
    "searchPlaceholder": "Recherche par nom ou numéro d'identification fiscale...",
    "group": "groupe",
    "groupsPlural": "groupes",
    "noGroups": "Aucun groupe trouvé",
    "tryDifferentSearch": "Essayez différents termes de recherche",
    "createFirstGroup": "Créez votre premier groupe pour commencer",
    "generalInfo": "Informations générales",
    "contactInfo": "Coordonnées",
    "accountInfo": "Informations sur le compte",
    "code": "Code",
    "groupName": "Nom du groupe",
    "groupNamePlaceholder": "Ex. : Groupe de Diagnostic Nord",
    "nationalId": "Numéro d'identification fiscale",
    "nationalIdPlaceholder": "Ex. : B12345678",
    "address": "Adresse",
    "addressPlaceholder": "Ex. : 45 Avenue Santé",
    "email": "E-mail de contact",
    "emailPlaceholder": "Ex : contact@groupe.com",
    "phone": "Téléphone de contact",
    "phonePlaceholder": "Par exemple : +1 555 123 456",
    "account": "Compte",
    "selectAccount": "Sélectionnez un compte...",
    "delete": "Supprimer",
    "edit": "Modifier",
    "cancel": "Annuler",
    "saving": "Économie...",
    "update": "Mise à jour",
    "create": "Créer un groupe",
    "deleteSuccess": "Groupe supprimé avec succès",
    "createSuccess": "Groupe créé avec succès",
    "updateSuccess": "Groupe mis à jour avec succès",
    "nameRequired": "Le nom est requis",
    "addressRequired": "L'adresse est requise",
    "emailRequired": "L'e-mail est requis",
    "phoneRequired": "Le téléphone est requis",
    "accountRequired": "Un compte est requis",
    "invalidEmail": "Format d'e-mail invalide",
    "notSpecified": "Non spécifié",
    "notAssigned": "Non attribué",
    "close": "Fermer",
    "loadError": "Erreur lors du chargement des groupes"
  },
  "validation": {
    "required": "Ce champ est obligatoire",
    "invalidEmail": "E-mail invalide",
    "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "invalidFormat": "Format invalide"
  },
  "navigation": {
    "home": "Maison",
    "dashboard": "Tableau de bord",
    "reports": "Rapports",
    "templates": "Modèles",
    "users": "Utilisateurs",
    "accounts": "Comptes",
    "settings": "Paramètres"
  },
  "templates": {
    "title": "Modèles",
    "preparationNoticeLabel": "Des modèles sont en cours d'enregistrement.",
    "preparationNoticeHint": "Attendez avant d'utiliser la dictée.",
    "preparationNoticeDetail": "Les modèles ont déjà été enregistrés, mais ils sont encore en préparation pour la dictée. Attendez que cet avis disparaisse.",
    "galleryTitle": "Galerie de modèles",
    "viewAllTemplates": "Voir tous les modèles",
    "count": "{{count}} modèles",
    "all": "Tous",
    "personal": "Personnels",
    "emptyPersonal": "Vous n'avez aucun modèle associé.",
    "createFirst": "Créer un nouveau modèle",
    "newTemplate": "Nouveau modèle",
    "searchPlaceholder": "Modèle de recherche...",
    "allTypes": "Tous types",
    "allSources": "Toutes les sources",
    "allLanguages": "Toutes les langues",
    "customSelect": "Sélectionnez la langue",
    "showing": "Affichage",
    "template": "modèle",
    "templates_plural": "modèles",
    "searching": "Recherche de modèles...",
    "loadingMore": "Chargement de plus de modèles...",
    "empty": "Aucun modèle trouvé.",
    "emptyHint": "Ajouter de nouveaux modèles",
    "newTemplateTitle": "Nouveau modèle",
    "details": "Détails",
    "selectTemplate": "Sélectionnez un modèle…",
    "templateName": "Nom du modèle",
    "templateNameLabel": "Nom du modèle",
    "templatePlaceholder": "Ex : MRI_KNEE_CONTRAST",
    "isBlock": "Est-ce un modèle pathologique ?",
    "no": "Non (normal)",
    "yes": "Oui (pathologique)",
    "activationWord": "Mot d'activation",
    "activationWordLabel": "Mot d'activation",
    "activationWordPlaceholder": "Ex : TUMEUR, LÉSION, etc.",
    "activationWordInfo": "Le mot d'activation permet de distinguer les gabarits d'une même zone anatomique. Par exemple, pour la pancréatite, vous pouvez utiliser « PANCRÉATITE » pour la différencier des autres modèles de pancréas.",
    "autoUppercase": "Sera automatiquement converti en majuscule",
    "standard": "Standard",
    "defaultBadge": "Standard",
    "setDefault": "Utiliser « {{name}} » comme modèle standard",
    "unsetDefault": "Ne plus utiliser « {{name}} » comme modèle standard",
    "defaultSet": "« {{name}} » est désormais votre modèle standard",
    "defaultUnset": "Vous n'avez plus de modèle standard personnel",
    "defaultError": "Impossible de modifier le modèle standard",
    "standardInfoTitle": "Modèle standard",
    "standardInfoBody": "",
    "standardInfoIntro": "Le modèle standard est conçu pour les études de radiologie générale. Il utilise des marqueurs dynamiques dans la technique qui sont automatiquement remplacés lors de la génération du rapport.",
    "standardInfoTechniqueTitle": "Technique",
    "standardInfoTechniqueBody": "La technique comprend des marqueurs dynamiques entre doubles parenthèses (tels que [[latéralité]], [[séquences]], [[régions_anatomiques]]) que le système remplace automatiquement par les valeurs correspondantes lors de la génération du rapport.",
    "standardInfoTechniqueExample": "[[latéralité]] Une IRM du genou est réalisée [[séquences]].",
    "standardInfoFindingsTitle": "Résultats",
    "standardInfoFindingsBody": "Les résultats sont rédigés sous forme de texte descriptif continu en prose, décrivant les structures évaluées et leurs caractéristiques de manière narrative.",
    "standardInfoUseCaseTitle": "Quand l'utiliser ?",
    "standardInfoUseCaseBody": "Idéal pour les études de radiologie générale : scanner des extrémités, IRM du genou, du rachis, de l'abdomen, échographies, radiographies, etc.",
    "infoExample": "Par exemple :",
    "content": "3. Contenu du modèle",
    "contentPlaceholder": "Faites glisser un fichier .txt ici ou écrivez le contenu...",
    "dragFile": "📄 Faites glisser un fichier .txt ici",
    "referenceIf": "4. Référence d'activation (REFERENCE_IF)",
    "alwaysActive": "Toujours actif (TOUJOURS)",
    "referenceIfWarning": "⚠️ Impossible d'avoir deux REFERENCE_IF = ALWAYS pour la même procédure",
    "activationWordRequired": "Mot d'activation :",
    "activationWordInputPlaceholder": "Ex : PATHOLOGIE, URGENT...",
    "language": "Code de langue",
    "type": "Taper",
    "saving": "Économie...",
    "saveChanges": "Enregistrer les modifications",
    "createTemplate": "Créer un modèle",
    "creating": "Création d'un modèle...",
    "nameRequired": "Le nom du modèle est obligatoire",
    "activationRequired": "Doit saisir un mot d'activation pour les modèles pathologiques",
    "activationOrAlways": "Doit saisir un mot d'activation ou cocher \"Toujours actif\"",
    "supportsBilaterality": "ℹ️ Prend en charge l'unilatéralité et la bilatéralité",
    "viewOtherTechnique": "Modèle de révision avec bilatéralité/unilatéralité opposée",
    "relatedTechnique": "Technique connexe (Bilatérale/Unilatérale)",
    "contentRequired": "Le contenu du modèle ne peut pas être vide",
    "techniqueRequired": "Le contenu de la technique ne peut pas être vide",
    "findingsRequired": "Le contenu des résultats ne peut pas être vide",
    "conclusionRequired": "Le contenu de la conclusion ne peut pas être vide",
    "technique": "Technique",
    "techniquePlaceholder": "Rédiger le contenu technique...",
    "techniquePlaceholderStandard": "Ex. : [[latéralité]] Une IRM du genou est réalisée [[séquences]].",
    "findings": "Résultats",
    "findingsBlocks": "Résultats",
    "findingsPlaceholder": "Rédiger le contenu des résultats...",
    "findingsPlaceholderStandard": "Ex : Structures osseuses avec signal médullaire normal, sans œdème ni lésion focale.",
    "conclusion": "Conclusion",
    "conclusionPlaceholder": "Écrivez le contenu de la conclusion...",
    "conclusionPlaceholderStandard": "Ex. : Examen sans résultats significatifs.",
    "noProcedures": "Aucune procédure associée à votre modèle",
    "templateCreated": "Modèle créé avec succès",
    "errorSaving": "Erreur lors de l'enregistrement du modèle",
    "normal": "Normale",
    "pathology": "Pathologie",
    "urgent": "Urgent",
    "followUp": "Suivi",
    "pediatric": "Pédiatrique",
    "USER": "Utilisateur",
    "STANDARD": "Standard",
    "AINOVIS": "Ainovis",
    "procedureAssignment": "Attribuer des procédures",
    "procedureAssignmentExplanation": "Lorsque vous générez un rapport et qu'une des procédures assignées est détectée, ce modèle sera automatiquement utilisé pour générer le rapport.",
    "groupFull": "Groupe complet",
    "principal": "Principal",
    "complementary": "Complémentaire",
    "procedure": "Procédure",
    "addPrincipalFirst": "Ajoutez d’abord une procédure principale",
    "dragOrAssign": "Faites glisser ou assignez des procédures",
    "suggestedProcedures": "Procédures suggérées",
    "availableProcedures": "Procédures disponibles",
    "highRelevance": "Haute pertinence",
    "mediumRelevance": "Pertinence moyenne",
    "assignAsPrincipal": "Assigner en tant que directeur",
    "assignAsComplementary": "Attribuer comme complémentaire",
    "confirmSelection": "Confirmer la sélection",
    "remove": "Retirer",
    "resolving": "Résolution du modèle avec des procédures...",
    "contentLabel": "Modèle",
    "groupsDescription": "Créer des groupes de procédures à associer à ce modèle",
    "assignedGroups": "Groupes de procédures",
    "group": "Groupe",
    "groupsPlural": "groupes",
    "groupsExamples": "Exemples de groupes",
    "singleExample": "Célibataire",
    "singleExampleValue": "Genou → Une seule procédure",
    "multiExample": "Multi",
    "multiExampleValue": "Genou + Jambe → Plusieurs procédures ensemble",
    "clickToAddProcedure": "Cliquez ou faites glisser une procédure pour l'ajouter",
    "single": "Célibataire",
    "multi": "Multi",
    "removeGroup": "Supprimer le groupe",
    "selectGroup": "Sélectionner un groupe",
    "whereToAdd": "Où voulez-vous ajouter",
    "createNewGroup": "Créer un nouveau groupe",
    "add": "Ajouter",
    "assigned": "Attribué",
    "dropHere": "Déposez ici pour créer un groupe",
    "dropToCreateGroup": "Déposez ici pour un nouveau groupe",
    "expandList": "Développer la liste",
    "collapseList": "Réduire la liste",
    "activationReference": "Référence d'activation",
    "alwaysActiveDesc": "Le modèle s'active toujours",
    "customReference": "Référence personnalisée",
    "customReferenceDesc": "Écrivez un mot-clé d'activation",
    "customActivation": "Activation personnalisée",
    "selectDestination": "Sélectionnez une destination",
    "addToExisting": "Ajouter à l'existant",
    "willCreateMulti": "Créera une multi-procédure",
    "willCreateSingle": "Créera une procédure unique",
    "full": "Complet",
    "createNewSection": "Créer nouveau",
    "createNewProcedure": "Créer en tant que procédure unique",
    "assignedProcedures": "Procédures assignées",
    "item": "article",
    "items": "articles",
    "examples": "Exemples",
    "singleProcedure": "Procédure unique",
    "multiProcedure": "Multi-procédure",
    "collapse": "Effondrement",
    "expand": "Développer",
    "dropToCreate": "Déposez ici pour créer un nouveau",
    "templateContent": "Contenu du modèle",
    "block": "Pathologique",
    "howToTemplates": "Comment fonctionnent les modèles",
    "chipLegendSelector": "Sélecteur",
    "chipLegendPlaceholder": "Espace réservé",
    "chipInsertHint": "Cliquez sur un champ ou tapez<kbd>/</kbd>insérer",
    "stepConfigureTemplate": "Configurer",
    "stepSelectMarkers": "Marqueurs",
    "stepAssignProcedures": "Procédures",
    "analyzeTemplate": "Analyser le modèle",
    "assignProcedures": "Attribuer des procédures",
    "saveTemplate": "Enregistrer le modèle",
    "blocksHint": "Les modèles pathologiques nécessitent uniquement des résultats et un mot d'activation. La technique et la conclusion sont omises.",
    "normalHint": "Les modèles normaux incluent la technique, les résultats et la conclusion.",
    "standardHint": "Texte libre pour décrire les résultats sans structure fixe.",
    "cancelConfirmTitle": "Supprimer les modifications ?",
    "cancelConfirmMessage": "Vous avez des modifications non enregistrées. Qu'aimeriez-vous faire ?",
    "discardChanges": "Jeter",
    "keepEditing": "Continuer à éditer",
    "draftSaved": "Brouillon enregistré",
    "draftSavedJustNow": "Brouillon enregistré",
    "fieldRequired": "Ce champ est obligatoire",
    "procedureStepIntro": "Étape 1 : Cliquez sur une procédure pour l'attribuer.",
    "procedureStepGroup": "Étape 2 : Si des groupes existent, choisissez où les ajouter.",
    "procedureStepConfirm": "Étape 3 : Confirmez la sélection une fois terminée.",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce modèle ? Toutes les versions associées (bilatérales/unilatérales) et leurs relations avec les procédures seront supprimées.",
    "voiceChipTemplate": "Utilise le modèle",
    "voiceChipTemplatesHint": "Dicte «Utilise le modèle ...» ou sélectionne",
    "copyAsPersonal": "Copier à titre personnel",
    "copying": "Copier...",
    "copySuccess": "Copié!",
    "copyError": "Erreur lors de la copie du modèle",
    "copyConflictTitle": "Conflit de procédure",
    "copyConflictMessage": "Des modèles personnels existent déjà pour les procédures affectées à ce modèle :",
    "copyConflictHint": "Pour utiliser ce modèle, vous devez attribuer un mot d'activation pour le différencier de ceux existants.",
    "copyWithActivation": "Copie avec activation",
    "help": {
      "title": "Comment créer des modèles",
      "intro": "Les modèles vous permettent de générer des rapports de radiologie rapidement et de manière cohérente. Écrivez le texte du rapport de base et ajoutez<strong>champs variables</strong>où vous avez besoin de valeurs dynamiques.",
      "selectorTitle": "Sélecteur",
      "selectorDesc": "Définit une liste d'options possibles pour un champ. Lors de la génération du rapport, l'un d'entre eux sera choisi. En option, vous pouvez marquer un<strong>valeur par défaut</strong>qui sera utilisé si aucun n’est spécifié.",
      "exampleInEditor": "Exemple dans l'éditeur :",
      "selectorExampleChip": "préservé / augmenté / diminué : *préservé*",
      "selectorDetail": "Cela signifie : les options sont « conservées », « augmentées » et « diminuées ». Si rien d'autre n'est précisé,<strong>\"conservé\"</strong>sera utilisé par défaut. La valeur par défaut est facultative : si vous n'en définissez pas, les options seront simplement affichées sans valeur présélectionnée.",
      "placeholderTitle": "Espace réservé",
      "placeholderDesc": "Un marqueur générique qui sera<strong>remplacé</strong>par une valeur précise lors de la génération du rapport (une description, une mesure, un constat, etc.).",
      "placeholderExampleChip": "trouver",
      "placeholderDetail": "Ce marqueur sera remplacé par le texte correspondant lors de la génération du rapport final.",
      "tipTitle": "💡 Astuce",
      "tipText": "Taper<kbd>/</kbd>dans l'éditeur pour ouvrir le menu d'insertion rapide de champs, ou utilisez les boutons dans la barre supérieure de chaque section.",
      "ok": "J'ai compris"
    },
    "source": "Source",
    "galleryNormalPrefix": "Galerie de ",
    "galleryBlockPrefix": "Galerie de ",
    "galleryBlockSuffix": "",
    "gallerySubtitle": "Gérez vos modèles et blocs de compte rendu",
    "countShown": "{{count}} modèles",
    "countShown_one": "{{count}} modèle",
    "countShown_other": "{{count}} modèles",
    "blocksCountShown": "{{count}} blocs",
    "blocksCountShown_one": "{{count}} bloc",
    "blocksCountShown_other": "{{count}} blocs",
    "blocksWord": "Blocs",
    "templatesWord": "modèles",
    "myTemplates": "Vos modèles",
    "import": "Importer un modèle",
    "importTemplates": "Importer des modèles",
    "importDropTitle": "Déposez un DOCX, un PDF ou un TXT ici",
    "importDropActive": "Déposez les fichiers ici",
    "importDropHint": "Ou cliquez pour sélectionner des fichiers",
    "importAddMore": "Ajoutez d’autres fichiers ou continuez",
    "importFilesCount": "{{count}} fichiers",
    "importTotalSize": "{{count}} fichiers · {{size}} sur {{limit}}",
    "importTotalTooLarge": "La taille totale des fichiers dépasse la limite de {{limit}}",
    "importProcessingN": "Traitement du document {{current}} sur {{total}}…",
    "importFormats": "Formats pris en charge : .docx, .pdf, .txt · Max 25 Mo au total",
    "importInvalidFormat": "Format non pris en charge. Utilisez un fichier .docx, .pdf ou .txt",
    "importProcessing": "Traitement du document…",
    "importSaving": "Importation…",
    "importSaveFailed": "Impossible d’importer les modèles",
    "importPartialFailure": "Impossible d’importer : {{titles}}",
    "importDone": "{{created}} modèles créés et {{replaced}} remplacés",
    "importSkippedAinovis": "Ignorés car ils correspondent à des modèles Ainovis : {{titles}}",
    "importFailed": "Impossible de traiter le document",
    "importEmpty": "Aucun modèle n’a été trouvé dans le document.",
    "importRemoveFile": "Retirer le fichier",
    "importSplitTitle": "Diviser le document",
    "importSplitHint": "Choisissez comment séparer les modèles du document.",
    "importSplitAi": "Détection IA",
    "importSplitAiHint": "L'IA détecte chaque modèle du document.",
    "importSplitPageBreaks": "Sauts de page",
    "importSplitPageBreaksHint": "Un modèle par page du document.",
    "importSplitHorizontalLine": "Ligne horizontale",
    "importSplitHorizontalLineHint": "Divise le document à chaque ligne horizontale.",
    "importPreviewTitle": "Aperçu",
    "importFoundCount": "{{count}} modèles trouvés",
    "importSplitBy": "Diviser par",
    "importNameLabel": "Nom du modèle",
    "importWordCount": "{{count}} mots",
    "importNoConflict": "Aucun modèle ne porte ce nom.",
    "importReplaces": "Remplace « {{name}} »",
    "importAinovisConflict": "Un modèle Ainovis porte déjà ce nom",
    "importAinovisConflictFull": "Un modèle Ainovis porte déjà ce nom. Modifiez-le pour pouvoir l’importer.",
    "importDuplicateInDocument": "Nom répété dans ce document",
    "importDuplicateInDocumentFull": "Un autre modèle de ce document porte déjà ce nom. Modifiez-le pour pouvoir l’importer.",
    "importEmptyName": "Donnez-lui un nom pour l’importer",
    "importUntitled": "Sans nom",
    "importBlocked": "Corrigez {{count}} nom(s) pour importer",
    "importNameLabel": "Nom du modèle",
    "importFilledPerReport": "À remplir dans chaque compte rendu",
    "importSummary": "{{total}} sur {{found}} sélectionnés",
    "importChooseAnother": "Choisir un autre fichier",
    "importConfirm": "Importer {{count}} modèles",
    "tabMine": "Personnels",
    "tabShared": "Institutionnels",
    "tabAinovis": "Ainovis",
    "filterStandard": "Standard",
    "loading": "Chargement des modèles...",
    "editTitle": "Modifier le modèle",
    "saveEdit": "Enregistrer les modifications",
    "filterSource": "Origine",
    "filterLanguage": "Langue",
    "normalTab": "Modèles",
    "blocksTab": "Blocs",
    "filters": "Filtres",
    "deleteTitle": "Supprimer le modèle",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer <strong>{{name}}</strong> ? Cette action supprimera toutes les versions de ce modèle et ne peut pas être annulée.",
    "deleting": "Suppression…",
    "delete": "Supprimer",
    "bulkDeleteTitle": "Supprimer les modèles",
    "bulkDeleteMessage": "Voulez-vous vraiment supprimer {{count}} modèles ? Toutes leurs versions seront supprimées et cette action est irréversible.",
    "selectedCount": "{{count}} sélectionnés",
    "selectTemplate": "Sélectionner « {{name}} »",
    "tabNormal": "Modèles",
    "tabBlocks": "Blocs",
    "previewLabel": "Aperçu :",
    "apply": "Appliquer",
    "cancel": "Annuler"
  },
  "recommendations": {
    "title": "Suggestions",
    "show": "Afficher les suggestions",
    "hide": "Masquer les suggestions",
    "list": "Suggestions disponibles",
    "block": "Bloc",
    "classification": "Classification",
    "loading": "Chargement des suggestions…",
    "error": "Certaines suggestions n'ont pas pu être actualisées.",
    "noTemplate": "Sélectionnez un modèle pour voir les suggestions.",
    "empty": "Aucune utilisation avec ce modèle pour l'instant.",
    "expandName": "Lire le nom complet",
    "collapseName": "Replier le nom",
    "remove": "Retirer {{name}} des suggestions"
  },
  "blocks": {
    "sectionContentPlaceholder": "Tapez ici le contenu qui sera inséré dans la section...",
    "namePlaceholder": "Nom du bloc (ex : Pancréatite aiguë)",
    "createHint": "Ce contenu sera inséré dans la section où vous le déposez.",
    "empty": "Aucun bloc",
    "createFirst": "Créer un bloc",
    "createCard": "Créer un bloc",
    "deleteTitle": "Supprimer le bloc",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer <strong>{{name}}</strong> ? Cette action est irréversible.",
    "deleting": "Suppression…",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "sidebarTitle": "Blocs",
    "searchToPin": "Rechercher un bloc...",
    "noResults": "Aucun résultat",
    "expand": "Développer",
    "collapse": "Fermer",
    "addToTemplate": "Ajouter",
    "unpin": "Détacher",
    "pinnedLoadError": "Les épingles sont indisponibles. Vous pouvez toujours utiliser les blocs.",
    "preview": "Aperçu",
    "removeAssociation": "Retirer de la liste"
  },
  "classificationCarousel": {
    "searchPlaceholder": "Rechercher une classification...",
    "empty": "Aucune classification trouvée",
    "descriptions": {
      "FLEISCHNER": "Suivi des nodules pulmonaires incidentels au scanner.",
      "TI-RADS": "Risque de malignité des nodules thyroïdiens à l'échographie.",
      "PI-RADS": "Suspicion de cancer de la prostate cliniquement significatif à l'IRM.",
      "BOSNIAK_2019": "Stratification des masses rénales kystiques au scanner ou à l'IRM.",
      "GARDEN": "Fractures sous-capitales du col du fémur selon le déplacement.",
      "EATON_LITTLER": "Stadification de la rhizarthrose trapézo-métacarpienne.",
      "SNYDER": "Ruptures complètes de la coiffe des rotateurs selon la taille et les tendons atteints.",
      "HERBERT_FISCHER": "Fractures du scaphoïde selon la stabilité et l'évolution."
    }
  },
  "classificationRequest": {
    "title": "Demander une classification",
    "close": "Fermer",
    "successTitle": "Merci pour votre demande !",
    "successSub": "Nous examinerons votre suggestion et travaillerons à l'ajout de la classification.",
    "intro": "Vous pensez qu'il manque une classification ? Dites-nous laquelle vous avez besoin et nous évaluerons son ajout.",
    "descriptionLabel": "Décrivez la classification dont vous avez besoin",
    "descriptionPlaceholder": "Indiquez le nom de la classification, la spécialité ou le type d'étude dans lequel elle est utilisée et tout détail pertinent...",
    "submitError": "La demande n'a pas pu être envoyée. Veuillez réessayer.",
    "allowContact": "J'accepte que l'équipe Ainovis me contacte pour obtenir plus de détails",
    "disclaimer": "Nous utiliserons ces informations uniquement pour évaluer et développer de nouvelles classifications.",
    "submitting": "Envoi en cours…",
    "submit": "Envoyer la demande",
    "requestClassification": "Demander une classification"
  },
  "keyboardShortcuts": {
    "title": "Raccourcis clavier",
    "close": "Fermer",
    "groupDictation": "Dictée",
    "dictationStart": "Commencer l'enregistrement",
    "dictationSend": "Envoyer l'audio",
    "dictationSendAlt": "Envoyer l'audio",
    "dictationPauseResume": "Mettre en pause / reprendre la dictée",
    "dictationCancel": "Annuler l'audio",
    "groupTextFormat": "Mise en forme du texte",
    "bold": "Gras",
    "italic": "Italique",
    "underline": "Souligné",
    "strikethrough": "Barré",
    "groupAlignment": "Alignement",
    "alignLeft": "Aligner à gauche",
    "alignCenter": "Centrer",
    "alignRight": "Aligner à droite",
    "justify": "Justifier",
    "groupEditing": "Édition",
    "undo": "Annuler",
    "redo": "Rétablir",
    "selectAll": "Tout sélectionner",
    "copy": "Copier",
    "cut": "Couper",
    "paste": "Coller",
    "save": "Enregistrer",
    "groupIndent": "Indentation",
    "indent": "Augmenter le retrait",
    "unindent": "Diminuer le retrait",
    "groupView": "Affichage",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "zoomReset": "Réinitialiser le zoom",
    "key_space": "Espace",
    "key_enter": "Entrée",
    "key_esc": "Échap",
    "key_tab": "Tab",
    "key_shift": "Maj"
  },
  "aiSidebar": {
    "title": "Carolina",
    "newChat": "Nouvelle conversation",
    "closePanel": "Fermer le panneau IA",
    "heroText": "Posez-moi n'importe quelle question sur Ainovis",
    "inputPlaceholder": "Écrivez un message...",
    "errorMessage": "Désolé, je n'ai pas pu traiter votre question. Veuillez réessayer.",
    "question1": "Comment générer un rapport avec la SmartBar ?",
    "question2": "Comment démarrer la dictée vocale ?",
    "question3": "Quelles classifications médicales puis-je utiliser ?"
  },
  "diffModal": {
    "badge": "Conversion de modèle",
    "progressOptions": "choix",
    "title": "Marqueurs détectés dans le texte",
    "subtitle": "Examinez les modifications proposées pour convertir ce rapport en un modèle réutilisable",
    "closeLabel": "Fermer modale",
    "selectMarkers": "Sélectionner des marqueurs",
    "slotsTitle": "Options de construction de modèles",
    "slotsSubtitle": "Sélectionnez les marqueurs à appliquer. Les textes correspondants seront remplacés.",
    "globalMode": "Mode global",
    "individualMode": "Mode individuel",
    "useGlobalMarker": "Utiliser un marqueur global",
    "globalMarkerDescription": "Appliquera le même marqueur à toutes les régions anatomiques",
    "finalResult": "Résultat final",
    "previewBadge": "Aperçu",
    "defaultValue": "Valeur par défaut",
    "unspecified": "Indéterminé",
    "defaultHint": "Les pièces en surbrillance utilisent les valeurs par défaut. Sélectionnez toutes les options pour confirmer.",
    "infoTitle": "Que sont les marqueurs ?",
    "infoDescription": "Les marqueurs (ex : [région anatomique], [latéralité]) sont des champs qui seront automatiquement renseignés lors de l'utilisation de ce modèle, permettant de le réutiliser pour différents cas.",
    "warningTitle": "Complétez toutes les sélections",
    "warningDescription": "{count}options restant à sélectionner. Les emplacements non sélectionnés sont mis en surbrillance.",
    "keepOriginal": "Conserver l'original",
    "applyTemplate": "Appliquer le modèle",
    "lateralityDisabledByRegion": "Les latéralités sont désactivées car les régions anatomiques les incluent déjà",
    "regionDisabledByLaterality": "Les régions anatomiques sont désactivées car les latéralités sont sélectionnées",
    "flexibilityTitle": "Modèle plus flexible",
    "flexibilityDescription": "En choisissant des marqueurs, votre rapport sera plus polyvalent. Les champs marqués seront automatiquement remplis en fonction de la procédure, vous permettant de réutiliser ce modèle pour plusieurs cas sans modification manuelle.",
    "noMarkersTitle": "Aucun marqueur sélectionné",
    "noMarkersDescription": "Sélectionnez au moins un marqueur pour appliquer les modifications à la technique ou continuez à utiliser le texte original.",
    "replace": "Remplacer",
    "insert": "Insérer"
  },
  "editor": {
    "sectionTitleEditToast": "N'oubliez pas que vous pouvez modifier les titres par défaut à partir des paramètres"
  },
  "errors": {
    "authInvalidCredentials": "Email ou mot de passe incorrect",
    "authInvalidToken": "Session invalide ou expirée",
    "authTokenExpired": "Votre session a expiré. Veuillez vous reconnecter",
    "authMissingToken": "Vous devez vous connecter pour accéder",
    "authUserNotFound": "Utilisateur introuvable",
    "authUserAlreadyExists": "Cet utilisateur existe déjà",
    "authInactiveUser": "Votre compte est désactivé. Contacter l'administrateur",
    "authInsufficientPermissions": "Vous ne disposez pas des autorisations suffisantes pour cette action",
    "authValidationError": "Erreur de validation des données",
    "validationError": "Veuillez vérifier les données saisies",
    "templateNotFound": "Modèle introuvable",
    "templateValidationError": "Erreur dans les données du modèle",
    "templateRetrievalError": "Erreur lors de la récupération des modèles",
    "templateAlreadyExists": "Un modèle portant ce nom existe déjà",
    "templateNameDuplicate": "Un modèle portant ce nom existe déjà pour cet utilisateur",
    "templateReferenceIfConflictAlways": "Un modèle \"{{templateName}}\" existe déjà pour la combinaison de procédures :{{procedureNames}}. Un seul modèle par défaut peut exister par combinaison de procédures.",
    "templateReferenceIfConflict": "Un modèle \"{{templateName}}\" avec le mot d'activation \"{{referenceIf}}\" existe déjà pour la combinaison de procédures :{{procedureNames}}. Veuillez utiliser un mot d'activation différent.",
    "templateNoTemplatesFound": "Aucun modèle trouvé pour cet utilisateur",
    "templateInvalidFormat": "Format de modèle invalide",
    "templateAccessDenied": "Vous n'avez pas accès à ce modèle",
    "blockLimitReached": "Vous avez atteint la limite de {{limit}} blocs. Supprimez-en un pour en créer un autre.",
    "reportNotFound": "Rapport introuvable",
    "reportValidationError": "Erreur dans les données du rapport",
    "reportGenerationError": "Erreur lors de la génération du rapport",
    "reportSaveError": "Rapport d'erreur lors de l'enregistrement",
    "reportAlreadyExists": "Un rapport avec cet identifiant existe déjà",
    "reportRetrievalError": "Erreur lors de la récupération des rapports",
    "reportModalityNotFound": "La modalité sélectionnée n'existe pas",
    "reportAccessDenied": "Vous n'avez pas accès à ce rapport",
    "reportDataInvalid": "Les données du rapport ne sont pas valides",
    "reportMissingField": "Les champs obligatoires sont manquants dans le rapport",
    "reportInvalidFormat": "Format de rapport invalide",
    "reportInvalidGenerationRequest": "Demande de génération invalide",
    "reportApiError": "Erreur de connexion au service de rapport",
    "reportServiceError": "Erreur dans le service de rapport",
    "reportAlignmentError": "Erreur lors de l'alignement du rapport",
    "reportNoModalityOrRegions": "Impossible de détecter la modalité ou les régions anatomiques dans le texte",
    "reportTemplatesNotFoundForProcedure": "Aucun modèle trouvé pour votre procédure et votre langue",
    "reportTemplatesFoundForDifferentType": "Aucun modèle du type demandé n'a été trouvé pour votre procédure, mais{{availableType}}des modèles existent",
    "reportTemplateType_STANDARD": "les résultats en premier ou les résultats à l'intérieur",
    "reportsTemplateNotFound": "Aucun modèle disponible pour cette description. Vous pouvez en créer un pour l'utiliser",
    "reportsTemplateIncomplete": "Le modèle est incomplet et ne peut pas être utilisé pour générer le rapport",
    "reportsTemplateContentNotFound": "Contenu du modèle introuvable",
    "reportsTemplateContentIncomplete": "Le contenu du modèle est incomplet",
    "reportsPromptNotFound": "L'invite requise pour la génération n'a pas été trouvée",
    "reportsFindingsGenerationError": "Erreur lors de la génération des résultats du rapport",
    "reportsConclusionGenerationError": "Erreur lors de la génération de la conclusion du rapport",
    "reportsSectionGenerationError": "Erreur lors de la génération d'une section de rapport",
    "reportsParallelGenerationError": "Erreur lors de la génération de rapports parallèles",
    "reportsInvalidGenerationParameters": "Paramètres de génération invalides",
    "reportsAlignmentError": "Erreur lors de l'alignement du rapport",
    "reportsPreSaveReviewError": "Erreur lors de l'examen avant l'enregistrement",
    "reportsLlmServiceError": "Erreur dans le service d'intelligence artificielle",
    "reportLanguageCodeNotFound": "Le code de langue demandé n'a pas été trouvé",
    "reportInactiveTemplate": "Le modèle sélectionné est inactif",
    "reportProcedureNotFound": "La procédure demandée n'a pas été trouvée",
    "reportAnatomicalRegionNotFound": "La région anatomique demandée n'a pas été trouvée",
    "reportVariantNotFound": "La variante demandée n'a pas été trouvée",
    "reportTemplateNotFound": "Modèle de rapport introuvable",
    "ainovisApiError": "Erreur dans le service IA",
    "ainovisConnectionError": "Erreur de connexion avec le service AI",
    "ainovisTimeoutError": "Le service IA a mis trop de temps à répondre",
    "ainovisInvalidAudioFormat": "Format audio invalide",
    "ainovisAudioFileSizeExceeded": "Le fichier audio est trop volumineux",
    "ainovisMissingAudioFile": "Aucun fichier audio fourni",
    "sttServiceError": "Erreur dans le service de transcription",
    "sttValidationError": "Erreur dans la validation des données de transcription",
    "sttMissingField": "Champs obligatoires manquants pour la transcription",
    "sttProcessingError": "Erreur lors du traitement de l'audio",
    "sttApiError": "Erreur de connexion au service de transcription",
    "sttNoVoiceDetected": "Aucune voix détectée dans l'audio",
    "sttAudioProcessingError": "Erreur lors du traitement du fichier audio",
    "sttNoAudioChunks": "Aucun morceau audio valide n'a été généré",
    "sttTranscriptionError": "Erreur dans la transcription parole-texte",
    "sttNoTranscriptionResults": "Aucun résultat de transcription n'a été obtenu",
    "sttEmptyTranscript": "La transcription était vide",
    "sttInvalidAudioFile": "Le fichier audio est invalide ou corrompu",
    "sttAudioFormatNotSupported": "Le format audio n'est pas pris en charge",
    "emailSendFailed": "Erreur lors de l'envoi de l'e-mail",
    "emailInvalidConfig": "Configuration de messagerie invalide",
    "emailInvalidAddress": "Adresse e-mail invalide",
    "emailTemplateNotFound": "Modèle d'e-mail introuvable",
    "emailTemplateRenderError": "Erreur lors du rendu de l'e-mail",
    "emailConnectionError": "Erreur de connexion avec le serveur de messagerie",
    "emailAuthenticationError": "Erreur d'authentification avec le serveur de messagerie",
    "networkError": "Erreur de connexion. Vérifiez votre connexion Internet",
    "noResponse": "Le serveur ne répond pas. Essayer à nouveau",
    "requestSetupError": "Erreur de traitement de la demande",
    "unexpectedError": "Une erreur inattendue s'est produite"
  },
  "billing": {
    "studies": "Études",
    "revenue": "Revenus (€)",
    "modality": {
      "rx": "Radiographie",
      "eco": "Ultrason",
      "tc": "CT",
      "rm": "IRM"
    }
  },
  "statistics": {
    "dateRange": "15 janvier – 15 février 2026",
    "sections": {
      "productionVolume": "Production et volumes",
      "performanceEfficiency": "Performances et efficacité",
      "billing": "Facturation",
      "realtimeActivity": "Activité en temps réel"
    },
    "kpi": {
      "reportsToday": "Rapports aujourd'hui",
      "activeRadiologists": "Radiologues actifs",
      "averageTime": "Temps moyen",
      "templateUsage": "Utilisation du modèle",
      "vsYesterday": "12,3% par rapport à hier",
      "thisWeek": "+2 cette semaine",
      "vsAvg": "0,8 min contre moyenne.",
      "thisMonth": "5% ce mois-ci"
    },
    "charts": {
      "reportsPerMonth": "Rapports générés par mois",
      "reportsPerMonthSubtitle": "30 derniers jours — Total : 22 487",
      "reportsPerMonthBadge": "+18% mensuel",
      "billing": "Facturation par modalité",
      "billingSubtitle": "Niveau Or · Volume et revenus",
      "billingBadge": "🪩 Niveau Or",
      "billingMonthly": "Tendance des revenus mensuels",
      "billingMonthlySubtitle": "6 derniers mois · Revenus par modalité",
      "topRadiologists": "Paramètres par radiologue",
      "topRadiologistsSubtitle": "Rapports cette semaine par radiologue",
      "mostUsedTemplates": "Procédures les plus signalées",
      "mostUsedTemplatesSubtitle": "Répartition par type",
      "anatomicalRegions": "Résultats par procédure",
      "anatomicalRegionsSubtitle": "Nombre de constatations par procédure",
      "heatmap": "Comparaison des radiologues",
      "heatmapSubtitle": "Rapports du radiologue et modalité",
      "reportsByModality": "Rapports par modalité",
      "reportsByModalitySubtitle": "Distribution statistique (boîte et moustache)",
      "timePerRadiologist": "Temps de génération par radiologue",
      "timePerRadiologistSubtitle": "Moy. Minutes vs Volume",
      "correlationMatrix": "Matrice de corrélation diagnostique",
      "correlationMatrixSubtitle": "Concordance de Pearson entre radiologues (20 études)",
      "correlationLegend": "Coefficient de corrélation (Pearson)",
      "frequentFindings": "Résultats fréquents",
      "frequentFindingsSubtitle": "Fréquence par type de recherche",
      "weeklyComparison": "Comparaison hebdomadaire",
      "weeklyComparisonSubtitle": "Top 5 – Actuel vs précédent",
      "realtimeFeed": "Flux en temps réel",
      "realtimeFeedSubtitle": "Derniers rapports",
      "live": "En direct",
      "average": "Moyenne",
      "reports": "rapports",
      "currentMonth": "Mois en cours",
      "previousMonth": "Mois précédent",
      "currentWeek": "Semaine en cours",
      "previousWeek": "Semaine précédente",
      "reportsLabel": "Rapports",
      "avgMinutes": "Moy. minutes",
      "volume": "Volume",
      "timeMins": "Temps (min)",
      "time": "Temps"
    },
    "days": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Épouser",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Assis",
      "sun": "Soleil"
    },
    "specialties": {
      "neuroradiology": "Neuroradiologie",
      "musculoskeletal": "Appareil locomoteur",
      "chest": "Poitrine",
      "abdomen": "Abdomen",
      "breast": "Sein"
    },
    "templateNames": {
      "ctBrain": "CT Cerveau",
      "xrayChest": "Poitrine à rayons X",
      "mriKnee": "IRM du genou",
      "ctAbdomen": "CT Abdomen",
      "usThyroid": "Thyroïde américaine",
      "other": "Autre"
    },
    "regions": {
      "head": "Tête",
      "chest": "Poitrine",
      "abdomen": "Abdomen",
      "spine": "Colonne vertébrale",
      "extremities": "Extrémités",
      "pelvis": "Bassin"
    },
    "findings": {
      "noFindings": "Aucun résultat",
      "pulmonaryNodule": "Nodule pulmonaire",
      "discHerniation": "Hernie discale",
      "pleuralEffusion": "Épanchement pleural",
      "fracture": "Fracture",
      "renalMass": "Masse rénale",
      "aneurysm": "Anévrisme",
      "stenosis": "Sténose",
      "calcification": "Calcification",
      "hepaticCyst": "Kyste hépatique"
    },
    "feed": {
      "minAgo": "{{value}}il y a min"
    },
    "additionalTemplate": {
      "title": "Générer une version complémentaire",
      "infoBanner": "Ce modèle peut bénéficier d'une version complémentaire (bilatérale/unilatérale). Sur la gauche, sélectionnez le type de version que vous écrivez ici. Le modèle original sera automatiquement enregistré comme version opposée. Par exemple, si vous choisissez « Unilatéral », ce que vous écrivez ici sera la version unilatérale et le modèle original sera enregistré en version bilatérale.",
      "selectVersion": "De quel type de version s'agit-il ?",
      "selectionHint": "Indiquez si la version complémentaire que vous rédigez est bilatérale ou unilatérale.",
      "bilateral": "Bilatéral",
      "bilateralDescription": "La version complémentaire s'applique des deux côtés (les deux genoux, les deux épaules, etc.)",
      "unilateral": "Unilatéral",
      "unilateralDescription": "La version complémentaire s'applique sur une seule face, avec une étiquette [latéralité].",
      "selectedVersion": "{{option}}version sélectionnée",
      "noSelection": "Sélectionnez un type de version",
      "editContent": "Contenu de la version complémentaire",
      "edited": "Édité",
      "editHint": "Editez les champs pour définir le contenu de la version complémentaire. Ce sera le contenu qui sera enregistré.",
      "technique": "Technique",
      "techniquePlaceholder": "Ecrire la technique pour la version complémentaire...",
      "findings": "Résultats",
      "findingsPlaceholder": "Écrivez les résultats pour la version complémentaire...",
      "impression": "Impression",
      "impressionPlaceholder": "Ecrivez l'impression pour la version complémentaire...",
      "skipGeneration": "Continuer sans supplément",
      "save": "Enregistrer la version"
    }
  },
  "onboarding": {
    "skip": "Sauter",
    "next": "Suivant",
    "previous": "Dos",
    "finish": "J'ai compris!",
    "tryIt": "Essayez-le !",
    "example": "Exemple",
    "interactionPending": "Tapez dans l'éditeur pour continuer",
    "interactionDone": "Super! Vous pouvez continuer",
    "welcomeTitle": "Bienvenue àAinovis!",
    "welcomeDesc": "On dirait que c'est votre première fois ici. Vous souhaitez un petit tour pour découvrir les principaux outils ?",
    "skipTour": "Pas maintenant",
    "startTour": "Commencer la visite",
    "reportCreate": {
      "editorTitle": "Éditeur de dictée",
      "editorDesc": "C'est ici que votre dictée apparaîtra. Vous pouvez taper directement ou utiliser le microphone pour dicter l’étude.",
      "micTitle": "Dictée vocale",
      "micDesc": "Appuyez sur le microphone pour démarrer la dictée vocale. Le microphone fonctionne dans la langue de l'application. Si vous n'êtes pas à l'aise, vous pouvez changer la langue dans les paramètres.",
      "generateTitle": "Générer un rapport",
      "generateDesc": "Une fois que vous avez dicté ou tapé la description de l'étude, appuyez sur ce bouton pour générer automatiquement le rapport.",
      "modeTitle": "Mode automatique/manuel",
      "modeDesc": "Basculer entre le mode automatique (Ainovissélectionne le modèle) et le mode manuel (vous choisissez le modèle à utiliser).",
      "speedModeTitle": "Vitesse de génération",
      "speedModeDesc": "Choisissez entre le mode rapide (latence plus faible) ou le mode précis (génération de rapports de meilleure qualité).",
      "settingsTitle": "Paramètres du rapport",
      "settingsDesc": "Configurez la langue, le type de modèle et le type de conclusion avant de générer votre rapport.",
      "tryRomTitle": "Maintenant, essayez-le vous-même !",
      "tryRomDesc": "Saisissez une étude IRM du genou (imagerie par résonance magnétique) dans l'éditeur. Vous pouvez copier l'exemple ou écrire ce que vous voulez. Cela vous montrera commentAinovisgénère un rapport.",
      "tryRomHint": "Tapez une IRM du genou...",
      "tryRomExample": "IRM du genou. Normale",
      "tryGenerateTitle": "Générez votre premier rapport !",
      "tryGenerateDesc": "Appuyez maintenant sur le bouton d'envoi pour générer votre rapport.Ainovistraitera ce que vous avez écrit et créera un rapport complet."
    },
    "reportEdit": {
      "lateralMenuTitle": "Menu latéral",
      "lateralMenuDesc": "Dans ce panneau latéral, vous trouverez les paramètres du rapport. Si vous venez de l'écran de création, les paramètres que vous avez configurés (langue, type de modèle, mode) seront déjà appliqués ici.",
      "lateralMenuParamsTitle": "Régénérer avec de nouveaux paramètres",
      "lateralMenuParamsDesc": "De là, vous pouvez modifier la langue, le type de rapport, le type de conclusion ou la vitesse et régénérer le rapport avec les nouveaux paramètres. Vous pouvez également créer directement de nouvelles versions.",
      "patientBannerTitle": "Données des patients",
      "patientBannerDesc": "Ici, vous pouvez associer les données du patient au rapport : nom, pièce d'identité, âge, sexe, date de l'étude et motif de la consultation. Vous pouvez également accéder aux études antérieures du patient pour comparer ou réutiliser des rapports antérieurs.",
      "mainEditorTitle": "Éditeur de rapports",
      "mainEditorDesc": "Il s'agit de l'éditeur principal où est affiché le rapport généré, divisé en sections (Technique, Résultats, Conclusion). Vous pouvez librement modifier le texte, le dicter vocalement et les modifications sont automatiquement enregistrées sous forme de brouillon.",
      "versionTabsTitle": "Versions du rapport",
      "versionTabsDesc": "Chaque fois que vous régénérez le rapport ou créez un canevas vierge, une nouvelle version est créée. Les onglets en bas vous permettent de naviguer entre les versions, de fermer celles dont vous n'avez pas besoin ou de créer une nouvelle version vide avec le bouton +.",
      "actionsTitle": "Actions de rapport",
      "actionsDesc": "Utilisez « Copier » pour copier le rapport dans le presse-papiers, « Envoyer » pour enregistrer le rapport comme final ou « Supprimer » pour supprimer entièrement le brouillon."
    },
    "home": {
      "welcomeTitle": "Votre panneau de contrôle",
      "welcomeDesc": "Ceci est votre tableau de bord principal. À partir de là, vous pouvez créer de nouveaux rapports, télécharger de l'audio pour une dictée par lots et accéder à l'intégralité de votre historique de travail.",
      "createBtnTitle": "Créer un rapport",
      "createBtnDesc": "Appuyez sur ce bouton pour créer un nouveau rapport à partir de zéro. L'éditeur s'ouvrira où vous pourrez dicter ou taper l'étude.",
      "uploadBtnTitle": "Télécharger de l'audio",
      "uploadBtnDesc": "Téléchargez des fichiers audio avec plusieurs dictées.Ainovisles transcrira et les séparera automatiquement en études individuelles.",
      "performanceTitle": "Résumé de l'activité",
      "performanceDesc": "Ici vous pouvez voir vos statistiques : rapports créés, temps gagné et tendances de productivité. Appuyez sur « Afficher plus de statistiques » pour accéder au panneau d'analyse complet.",
      "templatesTitle": "Modèles",
      "templatesDesc": "L'onglet Modèles regroupe vos modèles de rapport complets, prêts à l'emploi lors de la génération. Créez-en de nouveaux, modifiez les existants ou utilisez ceux partagés par votre équipe.",
      "blocksTitle": "Blocs",
      "blocksDesc": "Passez à l'onglet Blocs : vous y verrez les blocs, des fragments réutilisables (paragraphes, constatations, descriptions) à insérer dans n'importe quel rapport pour rédiger plus vite.",
      "reportListTitle": "Historique de travail",
      "reportListDesc": "Vous trouverez ici tous vos brouillons, rapports enregistrés, rapports partagés avec vous et lots de dictées. Utilisez les onglets pour filtrer."
    },
    "reportEditV2": {
      "smartBarTitle": "SmartBar — Votre barre intelligente",
      "smartBarDesc": "Le SmartBar est votre outil principal. Tapez une description d'étude ou dictez-la vocalement et appuyez sur Envoyer pour générer automatiquement le rapport avecCarolina. Vous pouvez également l'utiliser pour modifier des sections spécifiques.",
      "canvasTitle": "Éditeur de rapports",
      "canvasDesc": "Il s'agit de l'éditeur principal dans lequel le rapport généré est affiché, divisé en sections modifiables. Vous pouvez librement modifier le texte et les modifications sont automatiquement enregistrées.",
      "toolbarTitle": "Barre d'outils",
      "findingsModeTitle": "Modes de rédaction",
      "findingsModeDesc": "Vous choisissez ici comment les constatations sont rédigées : « Les constatations d'abord » les regroupe en haut, au-dessus du texte normal ; « Constatations dans le texte » les intègre dans le corps du rapport. Vous pouvez changer de mode à tout moment.",
      "toolbarDesc": "Personnalisez le formatage du texte : police, taille, gras, italique, alignement, listes et plus encore. Fonctionne comme n'importe quel éditeur de texte enrichi.",
      "menuBarTitle": "Barre de menus",
      "menuBarDesc": "Accédez à toutes les fonctionnalités : gestion de fichiers, insertion d'éléments (images, tableaux, graphiques), classifications médicales, modèles et support.",
      "classificationsTitle": "Classements médicaux",
      "classificationsDesc": "Accédez à des classifications standardisées commeFleischner,TI-RADS,PI-RADS,Bosniaket plus encore. Sélectionnez les paramètres et la classification sera automatiquement insérée dans votre rapport.",
      "versionsTitle": "Historique des versions",
      "versionsDesc": "Voici l'historique des versions du rapport. Chaque envoi, régénération ou application de modèle y enregistre une version. Les étapes ayant modifié chaque version sont regroupées par date afin de comparer, prévisualiser et restaurer n'importe quelle version antérieure.",
      "patientsTitle": "Patients",
      "patientsDesc": "Depuis ce panneau, vous recherchez et associez le patient de l'examen. Une fois sélectionné, ses données et ses examens précédents restent liés au rapport pour les consulter ou réutiliser d'anciens rapports.",
      "patientsNotIntegrated": "Cette fonctionnalité n'est pas encore intégrée. Pour consulter les données et l'historique du patient, le rapport doit être ouvert depuis un système externe (RIS/PACS).",
      "reportsHistoryTitle": "Rapports précédents",
      "reportsHistoryDesc": "Ici vous voyez l'historique des rapports enregistrés et pouvez les consulter pour comparer les constatations avec des examens antérieurs.",
      "micQrTitle": "Micro du mobile",
      "micQrDesc": "Scannez ce code avec votre mobile pour l'utiliser comme micro de dictée sans fil. Le code expire au bout d'un moment ; s'il se déconnecte, régénérez-le d'ici.",
      "aiBtnTitle": "Assistant IA —Carolina",
      "aiBtnDesc": "OuvrirCarolinaLe panneau de, votre assistant IA. Vous pouvez lui poser des questions sur le rapport, demander des suggestions ou consulter des questions médicales.",
      "testTemplateTitle": "Créez votre premier modèle",
      "testTemplateDesc": "Cliquez sur la carte « CRÉER UN MODÈLE » : nous remplirons le nom et un compte rendu d'exemple pour vous.",
      "testTemplateSaveTitle": "Enregistrez votre modèle",
      "testTemplateSaveDesc": "Votre modèle est déjà rempli avec un compte rendu d'IRM du genou d'exemple. Appuyez sur « Enregistrer le modèle » pour terminer.",
      "testTemplatePending": "Enregistrez le modèle pour continuer",
      "autoFillTemplateName": "Test IRM genou",
      "autoFillTemplateSectionTechnique": "TECHNIQUE",
      "autoFillTemplateTechniqueBody": "Étude IRM du genou droit en séquences DP FS et T1 dans les trois plans, sans injection de produit de contraste.",
      "autoFillTemplateSectionFindings": "DÉCOUVERTES",
      "autoFillTemplateFindingsBody": "Ménisques de morphologie et de signal normaux, sans évidence de déchirure. Ligaments croisés et collatéraux intacts. Cartilage articulaire préservé. Pas d'épanchement articulaire significatif. Signal médullaire osseux normal.",
      "autoFillTemplateSectionConclusion": "CONCLUSION",
      "autoFillTemplateConclusionBody": "Étude IRM du genou droit sans anomalie.",
      "testBlockTitle": "Créez votre premier bloc",
      "testBlockDesc": "Cliquez sur la carte « Créer un bloc » : nous remplirons un fragment réutilisable d'exemple pour vous. Appuyez simplement sur « Enregistrer ».",
      "testBlockPending": "Enregistrez le bloc pour continuer",
      "autoFillBlockName": "Déchirure du ménisque interne",
      "autoFillBlockContent": "Déchirure horizontale de la corne postérieure du ménisque interne, s'étendant à la surface articulaire inférieure.",
      "testReportTitle": "Dictez votre premier compte rendu à Carolina",
      "testReportDesc": "Appuyez sur le microphone et dites la commande ci-dessous à voix haute. C'est ainsi que vous travaillerez au quotidien : en parlant, pas en tapant.",
      "testReportPending": "Dites la commande à voix haute pour continuer",
      "voiceGateIdle": "Appuyez sur le microphone et dites la commande à voix haute.",
      "voiceGateSayThis": "Dites à voix haute :",
      "voiceGateNoMic": "Je ne peux pas utiliser le microphone",
      "voiceGatePlaceholder": "Utilisez le microphone →",
      "voiceGateChecking": "Écoute de ce que vous avez dit…",
      "voiceGateHeard": "J'ai compris :",
      "voiceGateMissingTemplate": "Il manque le nom de votre modèle.",
      "voiceGateMissingBlock": "Il manque le nom de votre bloc.",
      "voiceGateRetry": "Répétez la commande telle qu'elle apparaît ci-dessus.",
      "voiceGateTypeFallback": "Vous pouvez aussi la taper dans la barre.",
      "voiceGateError": "L'audio n'a pas pu être transcrit. Réessayez.",
      "testReportExample": "Utilise le modèle {{template}} et ajoute le bloc {{block}}"
    }
  },
  "voiceHelp": {
    "title": "Commandes vocales",
    "intro": "Pendant l'enregistrement, vous pouvez utiliser les commandes vocales pour modifier le rapport. Vous pouvez également simplement dicter du texte et il sera inséré à la position du curseur. Voici les commandes disponibles :",
    "deleteTitle": "Supprimer le texte",
    "deleteDesc": "Supprime le texte du rapport. Vous pouvez spécifier une section particulière.",
    "deleteEx1": "Supprimer le patient présente des douleurs",
    "deleteEx2": "Supprimer dans la section des résultats la masse hépatique",
    "updateTitle": "Mettre à jour le texte",
    "updateDesc": "Remplace un texte par un autre. Utilisez « à » ou « avec » pour indiquer la nouvelle valeur.",
    "updateEx1": "Changer de patient en individu",
    "updateEx2": "Remplacer dans la section technique la séquence FLAIR par la séquence T2",
    "insertTitle": "Insérer du texte",
    "insertDesc": "Ajoute un nouveau texte au rapport. Vous pouvez spécifier une section ou une position relative (avant/après).",
    "insertEx1": "Insérer le patient présente un bon état général",
    "insertEx2": "Ajouter dans la section résultats une masse de 3 cm",
    "insertEx3": "Insérer dans la rubrique technique avec les séquences T1 après IRM du genou",
    "insertEx4": "Ajouter ce contenu avant les résultats",
    "insertSectionTitle": "Insérer une section",
    "insertSectionDesc": "Crée une nouvelle section dans le rapport. Vous pouvez indiquer la position par rapport à une autre section.",
    "insertSectionEx1": "Insérer une nouvelle section technique",
    "insertSectionEx2": "Ajouter des notes de section avant la conclusion",
    "selectTitle": "Sélectionnez les options",
    "selectDesc": "Lorsque le système affiche des options numérotées, vous pouvez sélectionner, modifier ou supprimer des options spécifiques par numéro.",
    "selectEx1": "Sélectionnez un et deux",
    "selectEx2": "Choisissez entre 1 et 4",
    "selectEx3": "Changer le premier",
    "selectEx4": "Supprimer le numéro 4",
    "selectEx5": "Changer tout",
    "generateTitle": "Générer un rapport",
    "generateDesc": "Génère ou régénère le rapport complet.",
    "generateEx1": "Générer un rapport",
    "dictationTitle": "Dictée et ponctuation",
    "dictationDesc": "Vous pouvez dicter les signes de ponctuation et le formatage avec votre voix.",
    "dictationEx1": "période → .",
    "dictationEx2": "virgule → ,",
    "dictationEx3": "deux points → :",
    "dictationEx4": "nouvelle ligne → saut de ligne",
    "dictationEx5": "nouveau paragraphe → saut de paragraphe",
    "tip": "💡 Les commandes fonctionnent avec des préfixes facultatifs comme le nom de l'assistante (Carolina), les expressions polies (s'il vous plaît) ou les salutations informelles (hé). Ils tolèrent également la ponctuation générée par la reconnaissance vocale."
  },
  "batch": {
    "title": "Dictée par lots",
    "uploadSubtitle": "Téléchargez un fichier audio avec plusieurs rapports",
    "transcribingSubtitle": "Transcription audio...",
    "reviewSubtitle": "Revoir et corriger les études détectées",
    "generatingSubtitle": "Génération de rapports...",
    "stepUpload": "Télécharger de l'audio",
    "stepReview": "Revoir",
    "transcriptionComplete": "Transcription terminée —{{count}}études détectées",
    "transcriptionError": "Erreur de transcription de l'audio",
    "noStudies": "Aucune étude trouvée. Assurez-vous d'utiliser le format [ID patient].",
    "batchSaved": "Lot enregistré avec succès —{{count}}études",
    "saveError": "Erreur lors de l'enregistrement du lot",
    "invalidFormat": "Format non pris en charge. Utilisez des fichiers .wav, .mp3, .ogg ou .webm",
    "durationExceeded": "La durée totale de l'audio ne peut pas dépasser 30 minutes",
    "transcribingAudio": "Transcription audio...",
    "transcribingHint": "L'audio est en cours de traitement. Cela peut prendre quelques secondes.",
    "dropHere": "Déposez le fichier ici",
    "uploadTitle": "Téléchargez votre fichier audio",
    "uploadHint": "Faites glisser un fichier ici ou cliquez pour le sélectionner",
    "supportedFormats": "Formats pris en charge : .wav, .mp3, .ogg, .webm",
    "useMockData": "Utiliser des exemples de données",
    "processAudio": "Traiter l'audio",
    "pause": "Pause",
    "playAll": "Jouer à tout",
    "unifiedHint": "Chaque étude est séparée par [ID patient]. Appuyez sur ▶ à côté de chaque patient pour écouter son segment audio.",
    "studiesDetected": "{{count}}études détectées",
    "scrollToBottom": "Aller en bas",
    "goToEnd": "Aller à la fin",
    "saving": "Sauvegarde du lot...",
    "playSegment": "Lire le segment",
    "unifiedPlaceholder": "[Patient 12345678]\nDescriptif de l'étude...\n\n[Patient 87654321]\nUne autre étude....",
    "generateAll": "Générer tout"
  },
  "voiceCommands": {
    "noTextToDelete": "Aucun texte à supprimer n'a été spécifié",
    "editorNotAvailable": "Éditeur non disponible",
    "completeUpdatesBeforeDelete": "Terminez ou annulez les mises à jour en attente avant d'effectuer des suppressions",
    "textNotFound": "\"{{text}}\" introuvable",
    "textNotFoundInDocument": "\"{{text}}\" introuvable dans le document",
    "couldNotDeleteText": "Impossible de supprimer le texte",
    "noPendingOperations": "Aucune opération en attente. Utilisez d'abord la commande DELETE, UPDATE ou INSERT.",
    "noMatchesFound": "Aucune correspondance marquée trouvée",
    "noIndicesSpecified": "Aucun indice spécifié",
    "invalidIndices": "Indices invalides :{{indices}}. Plage valide : 1-{{max}}",
    "noMatchesForIndices": "Aucune correspondance trouvée pour les indices spécifiés",
    "noMatchesForIndicesDetail": "Aucune correspondance trouvée pour les indices spécifiés :{{indices}}",
    "noTextToUpdate": "Aucun texte à mettre à jour n'a été spécifié",
    "noReplacementText": "Aucun texte de remplacement n'a été spécifié",
    "completeDeletesBeforeUpdate": "Terminez ou annulez les suppressions en attente avant d'effectuer des mises à jour",
    "couldNotUpdateText": "Impossible de mettre à jour le texte",
    "updateExtensionNotAvailable": "L'extension de mise à jour n'est pas disponible",
    "noMarkedElements": "Aucun élément marqué trouvé dans le document",
    "noPendingOperationsSimple": "Aucune opération en attente",
    "couldNotFindInsertPosition": "Impossible de trouver la position d'insertion",
    "noContentToInsert": "Aucun contenu à insérer",
    "noReferenceText": "Aucun texte de référence n'a été précisé",
    "completeDeletesBeforeInsert": "Terminez ou annulez les suppressions en attente avant de procéder à des insertions",
    "completeUpdatesBeforeInsert": "Terminez ou annulez les mises à jour en attente avant de procéder à des insertions",
    "insertExtensionNotAvailable": "L'extension d'insertion n'est pas disponible",
    "couldNotGenerateReport": "Impossible de générer le rapport",
    "textInsertedInReport": "Texte inséré dans le rapport",
    "textInsertedInDescription": "Texte inséré dans la description",
    "textInsertedAtEndOfReport": "Texte inséré à la fin du rapport",
    "textUpdated": "Texte mis à jour",
    "textDeleted": "Texte supprimé",
    "matchesFoundClickToUpdate": "{{count}}correspondances trouvées. Cliquez sur le texte souligné pour le mettre à jour.",
    "matchesFoundUseSelect": "{{count}}correspondances trouvées. Utilisez « sélectionner » pour choisir ceux à supprimer.",
    "matchesDeleted": "{{count}}match(s) supprimé(s)",
    "matchesUpdated": "{{count}}match(s) mis à jour",
    "couldNotProcessDeletions": "Impossible de traiter les suppressions",
    "couldNotProcessUpdates": "Impossible de traiter les mises à jour",
    "generateReportOnlyFromDescription": "La commande générer un rapport ne fonctionne qu'à partir de la description ou avec des indices",
    "generatingReport": "Génération du rapport...",
    "voiceInputProcessingError": "Erreur lors du traitement de la saisie vocale",
    "deleteExtensionNotAvailable": "L'extension de suppression n'est pas disponible",
    "textNotFoundInValidSection": "\"{{text}}\" introuvable dans une section valide",
    "textNotFoundForInsert": "\"{{text}}\" introuvable pour l'insertion",
    "noSectionSpecified": "Aucune section n'a été spécifiée",
    "sectionNotFound": "Section \"{{section}}\" introuvable",
    "textNotFoundInSection": "\"{{text}}\" introuvable dans la section \"{{section}}\"",
    "sectionTitleRequired": "Un titre est requis pour la section",
    "referenceSectionRequired": "Une section de référence doit être précisée",
    "cannotAddSection": "Impossible d'ajouter la section",
    "couldNotInsertSection": "Impossible d'insérer la section",
    "errorInsertingSection": "Erreur lors de l'insertion de la section",
    "couldNotDetermineInsertPosition": "Impossible de déterminer la position d'insertion dans \"{{section}}\"",
    "errorInsertingTextInSection": "Erreur lors de l'insertion du texte dans la section",
    "noCommandRecognized": "Aucune commande reconnue"
  },
  "share": {
    "me": "Moi",
    "sharedWith": "Partagé avec",
    "title": "Partager le brouillon",
    "tabUsers": "Personnes",
    "tabLink": "Lien",
    "searchUser": "Rechercher par nom ou par email...",
    "userAdded": "Utilisateur ajouté avec succès",
    "cannotShareSelf": "Vous ne pouvez pas partager avec vous-même",
    "differentAccount": "Vous ne pouvez partager qu'avec les utilisateurs de votre compte",
    "errorSharing": "Partage d'erreur",
    "userRemoved": "Accès révoqué",
    "errorRemoving": "Erreur lors de la révocation de l'accès",
    "errorUpdating": "Erreur lors de la mise à jour des autorisations",
    "linkEnabled": "Lien activé",
    "errorLink": "Erreur lors de la mise à jour du lien",
    "linkCopied": "Lien copié dans le presse-papier",
    "errorCopyLink": "Erreur lors de la copie du lien",
    "tokenRegenerated": "Lien régénéré",
    "errorRegenerate": "Erreur lors de la régénération du lien",
    "owner": "Propriétaire",
    "addedBy": "Ajouté par",
    "permView": "Voir",
    "permEdit": "Modifier",
    "targetNotFound": "Utilisateur avec qui partager introuvable",
    "linkInvalid": "Lien invalide ou désactivé",
    "linkOtherAccount": "Ce lien appartient à un autre compte et ne peut pas être ouvert",
    "joinError": "Erreur lors de l'accès au brouillon partagé",
    "goToReports": "Aller aux rapports",
    "joining": "Ouverture du brouillon partagé...",
    "noUsersFound": "Aucun utilisateur trouvé",
    "noUsersShared": "Pas encore partagé avec personne",
    "shareLinkTitle": "Partager par lien",
    "shareLinkDesc": "Toute personne disposant du lien peut accéder",
    "linkPermission": "Autorisation de lien",
    "removeAccess": "Révoquer l'accès",
    "addUser": "Partager",
    "copy": "Copie",
    "copyLink": "Copier le lien",
    "errorUpdatingLink": "Erreur lors de la mise à jour du lien"
  },
  "collaboration": {
    "connected": "En direct",
    "connecting": "Connexion...",
    "invite": "Inviter",
    "inviteMore": "Inviter d'autres personnes"
  },
  "workHistory": {
    "title": "Historique de travail",
    "subtitle": "Historique de travail",
    "sent": "Envoyés",
    "drafts": "Brouillons",
    "empty": "Aucun rapport dans cette section.",
    "error": "Impossible de charger l'historique."
  },
  "groupReports": {
    "exportFileName": "historique_travail",
    "titlePrefix": "Historique de ",
    "titleAccent": "travail",
    "subtitle": "Rapports envoyés et brouillons des membres de votre groupe.",
    "subtitleAccount": "Rapports envoyés et brouillons des membres du compte.",
    "subtitleSelf": "Vos rapports envoyés et brouillons.",
    "kind": "Type de rapport",
    "sent": "Envoyés",
    "drafts": "Brouillons",
    "author": "Auteur",
    "allAuthors": "Tout le groupe",
    "scope": "Périmètre",
    "scopeAccount": "Tout le compte",
    "scopeSearch": "Rechercher un groupe ou une personne…",
    "scopeExpand": "Voir les membres du groupe",
    "scopeNoMatches": "Aucune correspondance.",
    "scopeEmptyGroup": "Groupe sans utilisateurs.",
    "search": "Rechercher",
    "searchPlaceholder": "Rechercher par titre…",
    "from": "Du",
    "to": "Au",
    "clearFilters": "Effacer les filtres",
    "count": "{{count}} résultats",
    "searchModality": "Modalité…",
    "searchRegion": "Région…",
    "modalities": "Modalités",
    "regions": "Régions",
    "allTags": "Voir toutes les étiquettes",
    "exportReports": "Télécharger les rapports",
    "exportPreviewTitle": "Télécharger les rapports",
    "exportPreviewSubtitle": "Aperçu du fichier Excel qui sera téléchargé.",
    "exportSheetName": "historique_travail",
    "exportRowCount": "{{count}} lignes",
    "exportMoreRows": "+ {{count}} lignes de plus dans l'export",
    "exportCol_title": "Titre",
    "exportCol_author": "Auteur",
    "exportCol_group": "Groupe",
    "exportCol_date": "Date",
    "exportCol_modality": "Modalité",
    "exportCol_region": "Région",
    "exportDownload": "Télécharger Excel",
    "exportError": "Impossible de charger les rapports à exporter.",
    "exportErrorDownload": "Impossible de générer le fichier Excel.",
    "processingLabel": "{{count}} rapport(s) en traitement",
    "processingTooltip": "{{count}} rapport(s) en cours de traitement. La liste se mettra à jour automatiquement.",
    "untitled": "Sans titre",
    "noMatches": "Aucun rapport ne correspond aux filtres.",
    "empty": "Il n'y a pas encore de rapports dans votre groupe.",
    "emptySelf": "Vous n'avez pas encore de rapports.",
    "error": "Impossible de charger les rapports du groupe.",
    "errorSelf": "Impossible de charger vos rapports."
  },
  "radiologistInsights": {
    "periodCustom": "Période personnalisée",
    "title": "Vos métriques",
    "subtitle": "{{name}}l'activité de",
    "groupFallbackName": "groupe",
    "scopeLabel": "Portée des statistiques",
    "scopePersonal": "Espace personnel",
    "scopeGroup": "Espace du groupe",
    "groupPlaceholderTitle": "Statistiques du groupe",
    "groupPlaceholderText": "Les statistiques agrégées du groupe seront bientôt disponibles.",
    "correlationTitle": "Activité conjointe des radiologues",
    "correlationSubtitle": "Activité conjointe par rapport au radiologue ayant produit le plus de comptes rendus (0–1)",
    "correlationPairCount": "{{count}} comparaisons",
    "correlationPairOne": "1 comparaison",
    "correlationNoPairs": "Il faut au moins deux radiologues pour comparer leur activité.",
    "correlationError": "Impossible de charger les radiologues du groupe.",
    "correlationEmpty": "Aucun radiologue dans le groupe.",
    "groupError": "Impossible de charger les statistiques du groupe.",
    "groupOverviewSection": "Vue du groupe",
    "groupRadiologistsSection": "Radiologues",
    "groupProductionTitle": "Production du groupe",
    "groupProductionSubtitle": "{{total}} rapports sur la période sélectionnée",
    "groupModalityTitle": "Rapports par modalité",
    "groupModalitySubtitle": "Répartition du groupe",
    "topRadiologistsTitle": "Radiologues les plus productifs",
    "topRadiologistsSubtitle": "Rapports réalisés par radiologue",
    "timePerRadiologistTitle": "Temps moyen par radiologue",
    "timePerRadiologistSubtitle": "Minutes d'édition par rapport",
    "snomedTooltip": "Tous les résultats sont standardisés à l'aide des normes internationalesSNOMED CTcode",
    "processingLabel": "{{count}}traitement des rapports",
    "processingTooltip": "{{count}}les rapports sont toujours en cours de traitement. Les graphiques seront actualisés automatiquement une fois terminés.",
    "periodMonth": "Ce mois-ci",
    "periodWeek": "La semaine dernière",
    "periodLast30": "30 derniers jours",
    "periodDay": "Aujourd'hui",
    "kpi": {
      "reportsMonth": "Rapports ce mois-ci",
      "reportsRange": "Rapports de la période",
      "vsPrevRange": "vs période précédente",
      "reportsWeek": "Rapports cette semaine",
      "reportsDay": "Rapports aujourd'hui",
      "reportsLast30": "Rapports des 30 derniers jours",
      "vsLastMonth": "par rapport au mois dernier",
      "vsLastWeek": "vs la semaine dernière",
      "vsYesterday": "contre hier",
      "vsPrev30": "par rapport aux 30 jours précédents",
      "topModality": "Votre modalité principale",
      "topRegion": "Votre région principale",
      "reportsCount": "{{count}}rapports",
      "percentOfTotal": "{{percent}}% du total",
      "findingsPerReport": "Résultats par rapport",
      "billing": "Facturation",
      "accumulated": "Cumul mensuel",
      "topRadiologist": "Radiologue avec le plus de rapports",
      "groupTotalReports": "Rapports du groupe",
      "thisMonth": "ce mois-ci",
      "activeRadiologists": "Radiologues actifs",
      "inTheGroup": "dans le groupe",
      "groupAvgEditTime": "Temps moyen d'édition",
      "perReport": "par rapport"
    },
    "reportsPerDay": "Rapports par jour",
    "dailyAverage": "Votre moyenne quotidienne :{{average}}rapports",
    "reports": "rapports",
    "dayLabel": "Jour{{day}}",
    "today": "aujourd'hui",
    "average": "moyenne",
    "modalities": "Vos modalités",
    "periodDistribution": "Répartition des périodes",
    "noData": "Aucune donnée",
    "frequentFindings": "Constatations les plus fréquentes",
    "seeAll": "Voir tout →",
    "inYourReports": "Dans vos rapports ·{{total}}mentions totales",
    "findingsBy": "Constatations par",
    "searchModality": "Rechercher une modalité...",
    "searchRegion": "Rechercher une région...",
    "noFindingsForFilters": "Aucune constatation pour ces filtres sur la période.",
    "filter": "Filtre:",
    "yourReportsCount": "{{count}}de vos rapports",
    "billing": "Votre facturation",
    "billingMeta": "{{range}}·<strong>{{accumulated}}</strong>cumulé · projection de fin de mois{{projection}}",
    "billingMetaWeek": "{{range}}·<strong>{{accumulated}}</strong>cumulé · projection de fin de semaine{{projection}}",
    "billingMetaDay": "{{range}}·<strong>{{accumulated}}</strong>accumulé aujourd'hui",
    "billingMetaLast30": "{{range}}·<strong>{{accumulated}}</strong>accumulés au cours des 30 derniers jours",
    "billingDaily": "Revenu quotidien",
    "billingDailySubtitle": "Ce que vous avez facturé chaque jour de la période",
    "editTimeSection": "Modifier l'heure",
    "reportsSection": "Rapports",
    "findingsSection": "Constatations",
    "billingSection": "Facturation",
    "editTimeAvgCard": "Temps moyen par rapport",
    "editTimeCardSub": "{{reports}}rapports ·{{total}}total",
    "editTimeEmpty": "Aucune donnée de modification pour cette période",
    "editTimeMedianCard": "Médiane par rapport",
    "editTimeMedianSub": "Valeur centrale de{{reports}}rapports",
    "editTimeLastCard": "Dernier rapport",
    "editTimeLastSub": "Heure du rapport le plus récent",
    "editTime": "Temps dédié par jour",
    "editTimeAvg": "Moyenne par rapport :{{average}}· Total:{{total}}dans{{reports}}rapports",
    "editTimeLabel": "temps",
    "presave": {
      "sectionTitle": "Incohérences et avertissements",
      "overrideRate": "Taux d'envois forcés",
      "overrideTrendTooltip": "Variation par rapport à la période précédente (points de pourcentage)",
      "overrideSub": "{{count}} décisions",
      "totalWarnings": "Avertissements du groupe",
      "totalSub": "{{forced}} envoyés malgré tout",
      "warningsPerReport": "Incohérences par rapport",
      "perReport": "densité",
      "topOverride": "Taux d'envois forcés le plus élevé",
      "topOverrideSub": "{{pct}} % · {{forced}} envoyés malgré tout",
      "timelineTitle": "Incohérences par jour",
      "timelineSubtitle": "Répartition quotidienne entre Réviser (vert) et Envoyer malgré tout (rouge)",
      "splitTitle": "Répartition des décisions",
      "splitSubtitle": "Part d'envois forcés sur le total décidé",
      "radiologistsTitle": "Taux d'inconsistences non résolues par radiologue",
      "radiologistsSubtitle": "% d'avertissements envoyés malgré tout sur le total décidé",
      "radiologistsVolumeTitle": "Radiologues avec le plus d'inconsistences",
      "radiologistsVolumeSubtitle": "Total d'avertissements émis par chaque radiologue du groupe",
      "templatesTitle": "Modèles avec le plus d'avertissements",
      "templatesSubtitle": "Procédures à l'origine de l'incohérence",
      "listTitle": "Événements d'incohérences",
      "listMeta": "{{total}} avertissements",
      "colDate": "Date",
      "colRadiologist": "Radiologue",
      "colJustification": "Justification",
      "colDecision": "Décision",
      "review": "Réviser",
      "forceSend": "Envoyer malgré tout",
      "pending": "En attente",
      "override": "Forcés",
      "empty": "Aucun avertissement sur la période sélectionnée.",
      "loadMore": "Charger plus ({{remaining}} restants)",
      "collapse": "Réduire"
    }
  },
  "voice": {
    "recoveryTitle": "Enregistrement non traité",
    "recoveryDescription": "Votre enregistrement n'a pas pu être traité après plusieurs tentatives. Vous pouvez réessayer ou supprimer l'enregistrement.",
    "recoveryRetry": "Réessayer",
    "recoveryDownload": "Télécharger l'audio",
    "recoveryDiscard": "Jeter",
    "recoveryConfirmDiscard": "Es-tu sûr? Cliquez à nouveau",
    "hardLimitReached": "Limite maximale d'enregistrement atteinte (1h 30m). L'audio est en cours de traitement.",
    "importBusy": "Terminez ou annulez la dictée en cours avant d'importer un audio.",
    "importMultipleFiles": "Déposez un seul fichier audio.",
    "importUnsupportedType": "Seuls les fichiers audio sont acceptés.",
    "importTooLarge": "Le fichier dépasse la limite de {{maxMb}} Mo.",
    "importTooLong": "L'audio dépasse la limite de {{maxMin}} minutes.",
    "importDecodeFailed": "Impossible de lire l'audio. Essayez un autre format.",
    "importNoVoice": "Aucune voix détectée dans l'audio importé.",
    "importNoEncoder": "Ce navigateur ne peut pas préparer l'audio importé. Mettez-le à jour ou utilisez un autre navigateur.",
    "importError": "Impossible de préparer l'audio importé.",
    "importComposeFailed": "Impossible d'assembler l'audio. La dictée reste en pause : renvoyez-la.",
    "importPreparing": "Préparation de l'audio…",
    "importDropHint": "Déposez l'audio pour le charger",
    "softLimitWarning": "L'enregistrement dure depuis plus de 10 minutes",
    "errorTimeout": "Le serveur a mis trop de temps. Votre audio est enregistré, vous pouvez réessayer.",
    "errorDisconnected": "La connexion au serveur a été perdue. Votre audio est enregistré.",
    "generationInProgress": "Une génération est déjà en cours. Attendez qu'elle se termine.",
    "errorAfterApplied": "La génération s'est terminée avec une erreur. Vérifiez le contenu appliqué au compte rendu.",
    "errorGeneration": "Erreur lors de la génération du rapport. Votre audio est enregistré, vous pouvez réessayer.",
    "errorGeneric": "Erreur lors du traitement de l'audio. Votre audio est enregistré.",
    "audioSaved": "Audio reçu",
    "templateNotFound": "Modèle \"{{templateName}}\" introuvable.",
    "processingDictation": "Traitement de la dictée…",
    "holdCancel": "Annuler",
    "holdLock": "Verrouiller",
    "holdSend": "Envoyer",
    "traditionalDictation": "Dictée traditionnelle",
    "holdRightClickHint": "Maintenez pour dicter"
  },
  "micPage": {
    "title": "Micro du téléphone",
    "connecting": "Connexion…",
    "needPermission": "Vous devez autoriser le microphone sur le téléphone avant d'enregistrer. Appuyez pour l'autoriser.",
    "allowMic": "Autoriser le microphone",
    "retryMic": "Réessayer l'autorisation du microphone",
    "permissionBlocked": "L'accès au microphone a été refusé. Activez-le dans les réglages du navigateur du téléphone puis appuyez de nouveau.",
    "micNotFound": "Aucun microphone détecté sur ce téléphone.",
    "micBusy": "Une autre application utilise le microphone. Fermez-la et réessayez.",
    "micUnavailable": "Impossible d'accéder au microphone du téléphone. Appuyez de nouveau pour réessayer.",
    "ready": "Prêt. Appuyez sur le bouton pour enregistrer.",
    "waitingDesktop": "En attente du bureau…",
    "recording": "Enregistrement…",
    "paused": "En pause",
    "processing": "Traitement de l'audio…",
    "processingHint": "Silero retire les silences…",
    "record": "Enregistrer",
    "pause": "Pause",
    "resume": "Reprendre",
    "stop": "Envoyer",
    "cancel": "Annuler",
    "desktopConnected": "Bureau connecté",
    "desktopWaiting": "Bureau non connecté",
    "desktopBusy": "Le bureau est en train d'enregistrer. Attendez qu'il termine.",
    "missingToken": "Le lien d'appairage est manquant. Scannez à nouveau le QR.",
    "invalidToken": "Ce lien n'est pas valide. Générez un autre code sur le bureau.",
    "expiredToken": "Le code a expiré. Générez-en un autre sur le bureau.",
    "roomFull": "Un téléphone est déjà connecté à ce code.",
    "permissionDenied": "Impossible d'accéder au microphone. Vérifiez l'autorisation du navigateur.",
    "insecureOrigin": "Le microphone nécessite HTTPS (ou localhost).",
    "disconnected": "Connexion avec le bureau perdue.",
    "helloTimeout": "Impossible de rejoindre la salle. Réessayez.",
    "idle": "La salle a été fermée pour inactivité.",
    "recordingLimit": "La limite d'enregistrement a été atteinte.",
    "relayError": "Connexion impossible. Générez un autre code sur le bureau."
  },
  "orgAdmin": {
    "backToApp": "Retour à Ainovis",
    "loadError": "Impossible de charger les informations.",
    "saveError": "Impossible d'enregistrer. Vérifiez les données et réessayez.",
    "comingSoon": "Bientôt disponible",
    "shell": {
      "eyebrow": "Administration",
      "pageTitlePrefix": "Panneau d'",
      "pageTitleAccent": "administration",
      "pageSubtitle": "Gérez tout le compte {{name}}",
      "meta": "{{groups}} groupes · {{users}} utilisateurs"
    },
    "rail": {
      "title": "Compte",
      "groups": "Groupes",
      "account": "Tout le compte",
      "accountPicker": "Compte",
      "emptyAccount": "Aucun groupe pour l'instant. Ajouter le premier",
      "usersTooltip": "Utilisateurs du groupe"
    },
    "confirm": {
      "deleteGroupHint": "Ses utilisateurs se retrouveront sans groupe attribué. Action irréversible.",
      "irreversible": "Cette action est irréversible."
    },
    "nav": {
      "overview": "Aperçu",
      "stats": "Statistiques",
      "groups": "Groupes",
      "users": "Utilisateurs",
      "templates": "Modèles",
      "settings": "Autorisations",
      "usage": "Consommation"
    },
    "usage": {
      "title": "Consommation du forfait",
      "cycle": "Cycle",
      "cycleRange": "{{from}} – {{to}}",
      "status": {
        "current": "En cours",
        "pending": "En attente de clôture",
        "closed": "Clôturé"
      },
      "loadError": "Impossible de charger la consommation.",
      "noSubscription": "Aucun forfait attribué : le compte a tout gratuitement et la consommation n'est pas facturée.",
      "level": {
        "none": "Forfait illimité",
        "ok": "Dans le forfait ({{pct}} %)",
        "warn": "Proche de la limite ({{pct}} %)",
        "full": "Forfait épuisé ({{pct}} %)",
        "over": "Au-delà du forfait ({{pct}} %)"
      },
      "package": "Forfait « {{name}} »",
      "free": "Gratuit",
      "shadow": "Mode observation",
      "shadowHint": "La consommation est mesurée mais rien n'est bloqué.",
      "closedNote": "Chiffres de la clôture du cycle : ils ne changent plus.",
      "pendingNote": "Le cycle est terminé ; les chiffres peuvent varier jusqu'à sa clôture.",
      "kpi": {
        "contratados": "Comptes rendus souscrits",
        "enviados": "Comptes rendus envoyés",
        "iteraciones": "Itérations consommées",
        "penalizaciones": "Pénalités de lot",
        "facturables": "Comptes rendus facturables",
        "extras": "Comptes rendus supplémentaires"
      },
      "unlimited": "Illimité",
      "bolsa": "Réserve : {{count}} itérations",
      "overQuota": "+{{count}} envoyés hors réserve",
      "iteracionesHint": "1 compte rendu = {{n}} itérations",
      "penalizacionesHint": "Études de lot non utilisées avec l'IA dans le délai",
      "formula": "max(envoyés, ⌈itérations / {{n}}⌉)",
      "amount": "Montant : {{amount}}",
      "noCharge": "Sans frais",
      "centerTitle": "Centre {{name}}",
      "centerHint": "Le forfait et la facturation concernent toute l'institution ; ici, la part de ce centre.",
      "share": "({{pct}} % de l'institution)",
      "byCenter": "Par centre",
      "byUser": "Par utilisateur",
      "emptyRows": "Aucune activité pendant ce cycle.",
      "col": {
        "center": "Centre",
        "user": "Utilisateur",
        "enviados": "Envoyés",
        "iteraciones": "Itérations",
        "penalizaciones": "Pénalités",
        "consumidas": "Total consommé",
        "share": "% itérations"
      },
      "removedCenter": "Centre supprimé",
      "noCenter": "Sans centre",
      "removedUser": "Utilisateur supprimé",
      "summary": {
        "title": "Consommation du cycle",
        "figures": "{{facturables}} sur {{contratados}} comptes rendus facturables · {{enviados}} envoyés · {{iteraciones}} itérations",
        "extras": "{{count}} en plus",
        "open": "Voir la consommation"
      }
    },
    "period": {
      "month": "Mois",
      "week": "Semaine",
      "day": "Jour",
      "last30": "30 derniers jours"
    },
    "overview": {
      "title": "Aperçu",
      "subtitle": "Activité de {{name}}",
      "reports": "Comptes rendus",
      "activeUsers": "Utilisateurs actifs",
      "avgEdit": "Édition moyenne",
      "topUser": "Utilisateur principal",
      "reportsCount": "{{count}} comptes rendus",
      "activity": "Activité",
      "contact": "Coordonnées",
      "noContact": "Aucune coordonnée.",
      "parent": "Compte",
      "shortcuts": "Aller à",
      "groupsTitle": "Groupes",
      "topGroup": "Groupe le plus actif",
      "fastestGroup": "Groupe le plus rapide"
    },
    "groups": {
      "title": "Groupes",
      "subtitle": "Groupes du compte",
      "addGroup": "Ajouter un groupe",
      "emptyGroups": "Ce compte n'a pas encore de groupes.",
      "usersCount": "{{active}}/{{count}} utilisateurs",
      "deleteGroupConfirm": "Supprimer le groupe {{name}} ?",
      "editGroup": "Modifier le groupe"
    },
    "form": {
      "name": "Nom",
      "surname": "Prénom",
      "nationalId": "SIRET",
      "nameRequired": "Le nom est obligatoire.",
      "address": "Adresse",
      "professionalTitle": "Titre professionnel (facultatif)",
      "email": "Email",
      "phone": "Téléphone",
      "namePlaceholder": "Ex : Marie",
      "surnamePlaceholder": "Ex : Dupont Martin",
      "emailPlaceholder": "Ex : marie@hopital.com",
      "nationalIdPlaceholder": "Ex : 12345678A",
      "addressPlaceholder": "Ex : 1 rue Principale, Paris",
      "professionalTitlePlaceholder": "Dr, Dre, ...",
      "phonePlaceholder": "Ex : +33 1 23 45 67 89"
    },
    "users": {
      "title": "Utilisateurs",
      "searchPlaceholder": "Rechercher par nom ou email",
      "allRoles": "Tous les rôles",
      "allStatuses": "Tous les statuts",
      "filters": "Filtres",
      "columnUser": "Utilisateur",
      "columnRole": "Rôle",
      "columnGroup": "Groupe",
      "columnStatus": "Statut",
      "statusActive": "Actif",
      "statusPending": "En attente",
      "statusInactive": "Inactif",
      "noGroup": "Sans groupe",
      "count": "{{count}} utilisateurs",
      "empty": "Ce compte n'a pas encore d'utilisateurs.",
      "emptyFiltered": "Aucun utilisateur ne correspond aux filtres.",
      "selected": "{{count}} sélectionnés",
      "selectAll": "Tout sélectionner",
      "bulkLabel": "Modèles personnels :",
      "bulkDone": "{{count}} utilisateurs mis à jour.",
      "bulkPartial": "Impossible de mettre à jour {{count}} utilisateurs.",
      "columnActions": "Actions",
      "add": "Ajouter un utilisateur",
      "addHint": "Il recevra un email pour vérifier son compte et choisir un mot de passe.",
      "sendInvite": "Créer et inviter",
      "createOnly": "Créer sans inviter",
      "edit": "Modifier l'utilisateur",
      "editHint": "Le rôle et le groupe se modifient depuis le tableau.",
      "emailLocked": "L'email de connexion ne peut pas être modifié.",
      "updated": "Utilisateur mis à jour.",
      "formRequired": "Remplissez tous les champs obligatoires.",
      "resend": "Renvoyer l'invitation",
      "activate": "Activer",
      "deactivate": "Désactiver",
      "activated": "Utilisateur activé.",
      "deactivated": "Utilisateur désactivé.",
      "roleChanged": "Rôle mis à jour.",
      "groupChanged": "Utilisateur transféré de groupe.",
      "inviteSent": "Invitation envoyée.",
      "deleted": "Utilisateur supprimé.",
      "deleteTitle": "Supprimer {{name}} ?",
      "deleteHint": "Ses brouillons, modèles et préférences sont supprimés aussi.",
      "loadMore": "Charger plus ({{remaining}} restants)",
      "endOfList": "Plus d'utilisateurs.",
      "page": "Page {{page}} sur {{totalPages}}",
      "loadError": "Impossible de charger les utilisateurs.",
      "accessTitle": "Accès et permissions",
      "accessSelfHint": "Vous ne pouvez pas modifier votre propre rôle ni vos permissions."
    },
    "templates": {
      "title": "Modèles",
      "total": "{{count}} modèles",
      "upload": "Téléverser",
      "uploadScope": "Périmètre",
      "uploadScopePlaceholder": "Choisis un périmètre…",
      "scopeEverything": "Compte et groupes",
      "scopeAll": "{{name}}",
      "scopeOnlyAccount": "Compte uniquement",
      "hintAll": "{{total}} modèles dans {{count}} groupes",
      "hintAccount": "Visible par les {{count}} groupes du compte {{name}} · {{total}} modèles",
      "hintGroup": "Visible uniquement par l'équipe de {{name}} · {{total}} modèles",
      "searchPlaceholder": "Rechercher un modèle",
      "selected": "{{count}} sélectionnés",
      "moveTo": "Déplacer vers",
      "edit": "Modifier le modèle",
      "select": "Sélectionner {{name}}",
      "page": "Page {{page}} sur {{totalPages}}",
      "emptyAccount": "Ce compte n'a pas encore de modèles institutionnels.",
      "emptyGroup": "Ce groupe n'a pas de modèles propres.",
      "emptyGroupHint": "Il voit aussi les {{count}} du compte {{name}}.",
      "emptyFiltered": "Aucun modèle ne correspond à la recherche.",
      "confirmDelete": "Supprimer {{count}} modèles ? Action irréversible.",
      "confirmPromote": "Tu vas rendre {{count}} modèles visibles par les {{groups}} groupes du compte {{name}}.",
      "loadError": "Impossible de charger les modèles.",
      "moveError": "Impossible de déplacer les modèles.",
      "languageError": "Impossible de changer la langue du modèle.",
      "deleteError": "Impossible de supprimer les modèles.",
      "processing": "Enregistrement",
      "processingHint": "Ce modèle a déjà été enregistré. Il est encore en préparation pour la dictée et ne peut pas être détecté automatiquement avant la fin."
    },
    "scope": {
      "account": "Tout le compte",
      "group": "Groupe"
    },
    "settings": {
      "title": "Paramètres",
      "applyNote": "Écrase la politique des {{count}} groupes existants avec les valeurs ci-dessus."
    },
    "policy": {
      "title": "Politique des modèles",
      "groupNote": "S'applique aux utilisateurs de ce groupe sans autorisations personnalisées.",
      "personalTitle": "Modèles personnels",
      "personalHint": "Permet aux radiologues d'utiliser, créer et modifier leurs propres modèles et blocs. En le désactivant, les modèles personnels qu'ils avaient déjà disparaissent aussi.",
      "ainovisTitle": "Modèles Ainovis",
      "ainovisHint": "Permet d'accéder aux modèles Ainovis. Désactivé, ils ne sont plus disponibles dans l'application.",
      "institutionalTitle": "Modèles institutionnels",
      "institutionalHint": "Permet d'accéder aux modèles du groupe et du compte. Désactivé, ils ne sont plus disponibles dans l'application.",
      "allowed": "Autorisé",
      "blocked": "Bloqué",
      "inherit": "Hérité du groupe ({{state}})",
      "inheritShort": "Hérité du groupe",
      "groupPolicy": "Hérité du groupe",
      "legend": "Autorisé / Bloqué / Hérité du groupe : ce que chaque valeur signifie.",
      "legendAllowed": "cette personne peut toujours l'utiliser, même si son groupe l'interdit.",
      "legendBlocked": "cette personne ne peut jamais l'utiliser, même si son groupe l'autorise.",
      "legendGroup": "cette personne n'a pas de réglage propre ; la décision de son groupe s'applique (affichée à côté).",
      "legendNoGroup": "cette personne n'a pas de groupe attribué ; la politique par défaut du compte s'applique.",
      "alwaysAllowed": "Toujours autorisé",
      "exemptHint": "Les administrateurs peuvent toujours créer des modèles.",
      "saved": "Politique mise à jour.",
      "defaultsTitle": "Autorisations des modèles",
      "defaultsWarning": "Ces autorisations s'appliquent aux nouveaux groupes. Les groupes existants ne sont pas modifiés.",
      "applyToGroups": "Appliquer les autorisations aux groupes existants",
      "applyConfirm": "La politique de tous les groupes du compte sera écrasée. Continuer ?",
      "applied": "Appliqué à {{count}} groupes."
    },
    "sentReportPolicy": {
      "title": "Comptes rendus envoyés",
      "note": "Ce que l'auteur peut faire d'un compte rendu déjà envoyé. À coordonner avec l'intégration du compte.",
      "modeTitle": "Mode",
      "positionTitle": "Position de l'addendum",
      "markedNoIntegration": "N'est pas envoyé à l'intégration (RIS/PACS) : les versions avec modifications marquées restent uniquement dans Ainovis. N'utilisez pas ce mode sur les comptes intégrés.",
      "targetTitle": "Appliquer à",
      "target": {"ainovis": "Rapports enregistrés dans Ainovis", "integration": "Intégration (RIS/PACS)"},
      "targetDesc": {"ainovis": "Les rapports enregistrés dans Ainovis se corrigent depuis la liste des rapports envoyés. Les révisions ne sont pas envoyées au PACS.", "integration": "En ouvrant depuis le PACS une étude qui a déjà un rapport, ce rapport est chargé puis corrigé ou complété par un addendum ; à l'envoi, il remplace ou complète celui du PACS. Les rapports enregistrés dans Ainovis ne peuvent pas être révisés."},
      "positionDesc": "Où l'addendum est placé par rapport au rapport précédent. C'est identique pour tous les utilisateurs du compte.",
      "position": { "top": "Au-dessus du rapport", "bottom": "Sous le rapport" },      "saved": "Politique des comptes rendus envoyés mise à jour.",
      "mode": { "none": "Immuable", "edit": "Modifier", "marked": "Modifications suivies", "addendum": "Addendum" },
      "desc": {
        "none": "Un compte rendu envoyé ne peut pas être modifié.",
        "edit": "L'auteur peut corriger un compte rendu envoyé ; une nouvelle version est créée et les précédentes sont conservées.",
        "marked": "L'auteur peut corriger un compte rendu envoyé ; ce qu'il supprime reste barré et une nouvelle version est créée.",
        "addendum": "L'auteur peut ajouter un addendum ; le compte rendu d'origine reste intact."
      }
    },
    "classifications": {
      "title": "Politique des classifications",
      "note": "Définissez qui peut utiliser les classifications dans ce compte et quelles échelles sont disponibles.",
      "groupNote": "Ce qui s'applique aux utilisateurs de ce groupe, sauf permission propre.",
      "defaultsWarning": "Valeurs de départ des nouveaux groupes. Les groupes existants conservent les leurs.",
      "userTitle": "Classifications",
      "userHint": "Permet à cette personne d'utiliser les classifications, indépendamment de son groupe.",
      "scalesTitle": "Classifications disponibles",
      "scalesCount": "{{active}} sur {{total}} actives",
      "scalesUserTitle": "Choisir une par une",
      "scalesUserHint": "Exceptions pour cette personne ; ce qui n'est pas modifié suit le groupe.",
      "audienceTitle": "Qui peut classifier",
      "saved": "Politique des classifications mise à jour.",
      "audience": {
        "nobody": "Personne",
        "admins": "Administrateurs uniquement",
        "everyone": "Tout le compte"
      },
      "audienceDesc": {
        "nobody": "Personne dans le compte ne peut classifier.",
        "admins": "Comportement actuel : seuls les administrateurs peuvent classifier.",
        "everyone": "Tout utilisateur du compte peut classifier."
      },
      "hints": {
        "FLEISCHNER": "Nodule pulmonaire",
        "TI-RADS": "Thyroïde",
        "PI-RADS": "Prostate",
        "BOSNIAK_2019": "Kyste rénal",
        "GARDEN": "Fracture de la hanche",
        "EATON_LITTLER": "Rhizarthrose (main)",
        "SNYDER": "Coiffe des rotateurs (épaule)",
        "HERBERT_FISCHER": "Fracture du scaphoïde (poignet)"
      }
    },
    "permissions": {
      "column": "Autorisations",
      "edit": "Modifier les autorisations",
      "title": "Autorisations de {{name}}",
      "bulkTitle": "Autorisations de {{count}} utilisateurs",
      "bulkHint": "Les changements s'appliquent à tous les utilisateurs sélectionnés.",
      "inherited": "Héritées",
      "custom": "Personnalisées",
      "mixed": "Valeurs multiples",
      "partialExempt": "{{count}} des utilisateurs sélectionnés l'ont toujours autorisé."
    },
    "group": {
      "back": "Retour aux groupes",
      "title": "Groupe",
      "subtitle": "Activité et équipe du groupe",
      "team": "Équipe",
      "emptyTeam": "Ce groupe n'a pas encore d'utilisateurs.",
      "active": "Actif",
      "inactive": "Inactif"
    },
    "roles": {
      "user": "Utilisateur",
      "admin": "Admin",
      "supervisor": "Superviseur",
      "super": "Super"
    }
  },
  "usageAlert": {
    "warn": "Le compte a utilisé {{value}} % des rapports du cycle",
    "full": "Le compte a utilisé tous les rapports du cycle",
    "over": "Le compte a dépassé les rapports du cycle : {{extras}} supplémentaires",
    "capNear": "Le compte approche du plafond de rapports supplémentaires : {{extras}} sur {{cap}}",
    "capReached": "Le compte a atteint le plafond de {{cap}} rapports supplémentaires",
    "detail": "{{facturables}} sur {{contratados}} rapports · le cycle se termine le {{date}}",
    "viewUsage": "Voir la consommation",
    "dismiss": "Fermer l'alerte",
    "levelOver": "Dépassement",
    "levelCap": "Plafond",
    "levelTitle": "Consommation du cycle en cours"
  },
  "quota": {
    "exceeded": "Crédits épuisés, contactez votre administrateur",
    "notInPackage": "Cette fonctionnalité n'est pas incluse dans le forfait de votre établissement"
  }
}
